/* tslint:disable */
/* eslint-disable */
/**
 * customer crage-reserveのタイトル
 * フロントエンド開発に必要なデータ定義場所
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 会員顧客情報
 * @export
 * @interface AuthGet200Response
 */
export interface AuthGet200Response {
    /**
     * member_customers.id
     * @type {number}
     * @memberof AuthGet200Response
     */
    'id': number;
    /**
     * member_customers.email
     * @type {string}
     * @memberof AuthGet200Response
     */
    'email'?: string;
    /**
     * member_customers.password
     * @type {string}
     * @memberof AuthGet200Response
     */
    'password'?: string;
    /**
     * member_customers.last_name
     * @type {string}
     * @memberof AuthGet200Response
     */
    'last_name'?: string;
    /**
     * member_customers.first_name
     * @type {string}
     * @memberof AuthGet200Response
     */
    'first_name'?: string;
    /**
     * member_customers.last_name_kana
     * @type {string}
     * @memberof AuthGet200Response
     */
    'last_name_kana'?: string;
    /**
     * member_customers.first_name_kana
     * @type {string}
     * @memberof AuthGet200Response
     */
    'first_name_kana'?: string;
    /**
     * member_customers.withdrawal_flag
     * @type {string}
     * @memberof AuthGet200Response
     */
    'withdrawal_flag'?: AuthGet200ResponseWithdrawalFlagEnum;
    /**
     * member_customers.industry_name
     * @type {string}
     * @memberof AuthGet200Response
     */
    'created_at'?: string;
    /**
     * member_customers.updated_at
     * @type {string}
     * @memberof AuthGet200Response
     */
    'updated_at'?: string;
    /**
     * member_customers.deleted_at
     * @type {string}
     * @memberof AuthGet200Response
     */
    'deleted_at'?: string;
}

export const AuthGet200ResponseWithdrawalFlagEnum = {
    NOT_WITHDRAW: '未退会',
    WITHDRAW: '退会'
} as const;

export type AuthGet200ResponseWithdrawalFlagEnum = typeof AuthGet200ResponseWithdrawalFlagEnum[keyof typeof AuthGet200ResponseWithdrawalFlagEnum];

/**
 * BankAccount
 * @export
 * @interface BankAccount
 */
export interface BankAccount {
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    'bank_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    'bank_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    'branch_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    'branch_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    'account_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    'account_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    'account_holder'?: string;
}
/**
 * カレンダー予約可否フラグ 0:予約可 1:予約不可 2:営業外
 * @export
 * @enum {string}
 */

export const BookingAvailabilityLabel = {
    /**
    * 予約可
    */
    RESERVABLE: 0,
    /**
    * 予約不可
    */
    NON_RESERVABLE: 1,
    /**
    * 営業外
    */
    NON_OPERATING: 2
} as const;

export type BookingAvailabilityLabel = typeof BookingAvailabilityLabel[keyof typeof BookingAvailabilityLabel];


/**
 * カレンダー営業フラグ 0:営業時間 1:24時間営業 2:休業
 * @export
 * @enum {string}
 */

export const CalendarDefaultOpenings = {
    /**
    * 営業時間
    */
    OPENING_HOURS: 0,
    /**
    * 24時間営業
    */
    OPEN_24_HOURS: 1,
    /**
    * 休業
    */
    CLOSED: 2
} as const;

export type CalendarDefaultOpenings = typeof CalendarDefaultOpenings[keyof typeof CalendarDefaultOpenings];


/**
 * サービス(カレンダー)情報
 * @export
 * @interface CalendarInfo
 */
export interface CalendarInfo {
    /**
     * 
     * @type {ServiceStatus}
     * @memberof CalendarInfo
     */
    'status': ServiceStatus;
    /**
     * 
     * @type {ServiceType}
     * @memberof CalendarInfo
     */
    'type': ServiceType;
    /**
     * サービス名(services.name)
     * @type {string}
     * @memberof CalendarInfo
     */
    'service_name': string;
    /**
     * サービス提供者ID
     * @type {number}
     * @memberof CalendarInfo
     */
    'supplier_id': number;
    /**
     * 
     * @type {ServiceReservationPeriodFlag}
     * @memberof CalendarInfo
     */
    'reservation_period_flag': ServiceReservationPeriodFlag;
    /**
     * 予約受付公開開始日時
     * @type {string}
     * @memberof CalendarInfo
     */
    'reservation_period_start_time'?: string;
    /**
     * 予約受付公開終了日時
     * @type {string}
     * @memberof CalendarInfo
     */
    'reservation_period_end_time'?: string;
    /**
     * 
     * @type {ServiceReservationSpecifiedPeriodFlag}
     * @memberof CalendarInfo
     */
    'reservation_specified_period_flag': ServiceReservationSpecifiedPeriodFlag;
    /**
     * 
     * @type {ServicePaidFlag}
     * @memberof CalendarInfo
     */
    'paid_flag': ServicePaidFlag;
    /**
     * 予約問い合わせ先_名前(services.contact_name)
     * @type {string}
     * @memberof CalendarInfo
     */
    'contact_name': string;
    /**
     * 予約問い合わせ先_メールアドレス(services.contact_mail)
     * @type {string}
     * @memberof CalendarInfo
     */
    'contact_mail': string;
    /**
     * 予約問い合わせ先_電話番号(services.contact_tel)
     * @type {string}
     * @memberof CalendarInfo
     */
    'contact_tel'?: string;
    /**
     * 
     * @type {ServiceCancelSettings}
     * @memberof CalendarInfo
     */
    'cancel_settings': ServiceCancelSettings;
    /**
     * 
     * @type {ServiceCancelPriceSettings}
     * @memberof CalendarInfo
     */
    'cancel_price_settings'?: ServiceCancelPriceSettings;
    /**
     * 
     * @type {Array<CalendarServiceDetailsDto>}
     * @memberof CalendarInfo
     */
    'details': Array<CalendarServiceDetailsDto>;
    /**
     * 
     * @type {Array<ServicePaymentMethodDto>}
     * @memberof CalendarInfo
     */
    'paymentmethod'?: Array<ServicePaymentMethodDto>;
    /**
     * 
     * @type {Array<ServiceMenuDetailDto>}
     * @memberof CalendarInfo
     */
    'service_menus'?: Array<ServiceMenuDetailDto>;
    /**
     * フォーム情報（複数）
     * @type {Array<Form>}
     * @memberof CalendarInfo
     */
    'forms': Array<Form>;
    /**
     * 
     * @type {UserPlan}
     * @memberof CalendarInfo
     */
    'plan': UserPlan;
    /**
     * 
     * @type {UserSpecialCommercialLaw}
     * @memberof CalendarInfo
     */
    'special_commercial_law': UserSpecialCommercialLaw;
    /**
     * ga tracking id
     * @type {string}
     * @memberof CalendarInfo
     */
    'ga_tag'?: string;
    /**
     * ga cross domain
     * @type {Array<string>}
     * @memberof CalendarInfo
     */
    'ga_cross_domain_tag'?: Array<string>;
    /**
     * gtm id
     * @type {string}
     * @memberof CalendarInfo
     */
    'gtm_id'?: string;
    /**
     * 
     * @type {ServiceScheduleChangeSettings}
     * @memberof CalendarInfo
     */
    'schedule_change_settings': ServiceScheduleChangeSettings;
    /**
     * 
     * @type {ServiceViewTermFlag}
     * @memberof CalendarInfo
     */
    'view_term_flag': ServiceViewTermFlag;
}
/**
 * サービス詳細(カレンダー)項目
 * @export
 * @interface CalendarServiceDetailsDto
 */
export interface CalendarServiceDetailsDto {
    /**
     * サービス詳細ID(service_details.id)
     * @type {number}
     * @memberof CalendarServiceDetailsDto
     */
    'id': number;
    /**
     * イベント開始日時 (service_details.event_date,start_hour,start_minute)
     * @type {string}
     * @memberof CalendarServiceDetailsDto
     */
    'event_start_time'?: string;
    /**
     * イベント終了日時 (service_details.event_date,end_hour,end_minute)
     * @type {string}
     * @memberof CalendarServiceDetailsDto
     */
    'event_end_time'?: string;
    /**
     * 
     * @type {ServiceDetailType}
     * @memberof CalendarServiceDetailsDto
     */
    'type': ServiceDetailType;
    /**
     * URL (service_details.url) 
     * @type {string}
     * @memberof CalendarServiceDetailsDto
     */
    'url'?: string;
    /**
     * 場所名 (service_details.place_name) 
     * @type {string}
     * @memberof CalendarServiceDetailsDto
     */
    'place_name'?: string;
    /**
     * 郵便番号 (service_details.zip) 
     * @type {string}
     * @memberof CalendarServiceDetailsDto
     */
    'zip'?: string;
    /**
     * 都道府県 (service_details.pref_master_id) 
     * @type {number}
     * @memberof CalendarServiceDetailsDto
     */
    'pref_master_id'?: number;
    /**
     * 住所 (service_details.address1) 
     * @type {string}
     * @memberof CalendarServiceDetailsDto
     */
    'address1'?: string;
    /**
     * 建物名 (service_details.address2)
     * @type {string}
     * @memberof CalendarServiceDetailsDto
     */
    'address2'?: string;
    /**
     * 定員 (service_details.maximum_number)
     * @type {number}
     * @memberof CalendarServiceDetailsDto
     */
    'maximum_number'?: number | null;
    /**
     * 金額(service_details.price)
     * @type {number}
     * @memberof CalendarServiceDetailsDto
     */
    'price'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CapacityStatus = {
    NONE: 1,
    CUSTOM: 2,
    ALL: 3
} as const;

export type CapacityStatus = typeof CapacityStatus[keyof typeof CapacityStatus];


/**
 * 予約お問合せ先情報
 * @export
 * @interface Contact
 */
export interface Contact {
    /**
     * 問い合わせ先メールアドレス (services.contact_mail)
     * @type {string}
     * @memberof Contact
     */
    'contact_mail': string;
    /**
     * 問い合わせ先電話番号 (services.contact_tel)
     * @type {string}
     * @memberof Contact
     */
    'contact_tel': string;
}
/**
 * サービス詳細項目
 * @export
 * @interface ContentWebinarDetailsDto
 */
export interface ContentWebinarDetailsDto {
    /**
     * サービス詳細ID(service_details.id)
     * @type {number}
     * @memberof ContentWebinarDetailsDto
     */
    'id'?: number;
    /**
     * 
     * @type {ServiceDetailType}
     * @memberof ContentWebinarDetailsDto
     */
    'type': ServiceDetailType;
    /**
     * 金額(service_details.price)
     * @type {number}
     * @memberof ContentWebinarDetailsDto
     */
    'price': number;
}
/**
 * サービス情報(コンテンツ・ウェビナー)
 * @export
 * @interface ContentWebinarElement
 */
export interface ContentWebinarElement {
    /**
     * 
     * @type {ServiceStatus}
     * @memberof ContentWebinarElement
     */
    'status': ServiceStatus;
    /**
     * 
     * @type {ServiceType}
     * @memberof ContentWebinarElement
     */
    'type': ServiceType;
    /**
     * サービス名(services.name)
     * @type {string}
     * @memberof ContentWebinarElement
     */
    'service_name': string;
    /**
     * 
     * @type {ServiceReservationPeriodFlag}
     * @memberof ContentWebinarElement
     */
    'reservation_period_flag': ServiceReservationPeriodFlag;
    /**
     * 予約受付公開開始日時
     * @type {string}
     * @memberof ContentWebinarElement
     */
    'reservation_period_start_time'?: string;
    /**
     * 予約受付公開終了日時
     * @type {string}
     * @memberof ContentWebinarElement
     */
    'reservation_period_end_time'?: string;
    /**
     * 
     * @type {ServiceReservationSpecifiedPeriodFlag}
     * @memberof ContentWebinarElement
     */
    'reservation_specified_period_flag': ServiceReservationSpecifiedPeriodFlag;
    /**
     * 
     * @type {ServicePaidFlag}
     * @memberof ContentWebinarElement
     */
    'paid_flag': ServicePaidFlag;
    /**
     * 
     * @type {ServiceViewType}
     * @memberof ContentWebinarElement
     */
    'view_type': ServiceViewType;
    /**
     * 
     * @type {ServicePageViewTerm}
     * @memberof ContentWebinarElement
     */
    'page_view_term': ServicePageViewTerm;
    /**
     * 
     * @type {ServiceViewTermFlag}
     * @memberof ContentWebinarElement
     */
    'view_term_flag': ServiceViewTermFlag;
    /**
     * ページ表示開始日時(services.page_view_start_date,page_view_start_hour,page_view_start_minute)
     * @type {string}
     * @memberof ContentWebinarElement
     */
    'page_view_start_time'?: string;
    /**
     * ページ表示終了日時(services.page_view_end_date,page_view_end_hour,page_view_end_minute)
     * @type {string}
     * @memberof ContentWebinarElement
     */
    'page_view_end_time'?: string;
    /**
     * 
     * @type {Array<ServicePaymentMethodDto>}
     * @memberof ContentWebinarElement
     */
    'paymentmethod'?: Array<ServicePaymentMethodDto>;
    /**
     * 
     * @type {Array<ContentWebinarDetailsDto>}
     * @memberof ContentWebinarElement
     */
    'details'?: Array<ContentWebinarDetailsDto>;
    /**
     * フォーム情報（複数）
     * @type {Array<Form>}
     * @memberof ContentWebinarElement
     */
    'forms': Array<Form>;
    /**
     * 
     * @type {UserPlan}
     * @memberof ContentWebinarElement
     */
    'plan': UserPlan;
    /**
     * 
     * @type {UserSpecialCommercialLaw}
     * @memberof ContentWebinarElement
     */
    'special_commercial_law': UserSpecialCommercialLaw;
    /**
     * ga tracking id
     * @type {string}
     * @memberof ContentWebinarElement
     */
    'ga_tag'?: string;
    /**
     * ga cross domain
     * @type {Array<string>}
     * @memberof ContentWebinarElement
     */
    'ga_cross_domain_tag'?: Array<string>;
    /**
     * gtm id
     * @type {string}
     * @memberof ContentWebinarElement
     */
    'gtm_id'?: string;
}
/**
 * 
 * @export
 * @interface CouponAvailabilityRequest
 */
export interface CouponAvailabilityRequest {
    /**
     * 
     * @type {number}
     * @memberof CouponAvailabilityRequest
     */
    'supplier_id': number;
    /**
     * 
     * @type {number}
     * @memberof CouponAvailabilityRequest
     */
    'service_id': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CouponAvailabilityRequest
     */
    'service_detail_ids'?: Array<number>;
    /**
     * 
     * @type {Array<CouponAvailabilityRequestServiceDetailsInner>}
     * @memberof CouponAvailabilityRequest
     */
    'service_details'?: Array<CouponAvailabilityRequestServiceDetailsInner>;
    /**
     * 
     * @type {number}
     * @memberof CouponAvailabilityRequest
     */
    'service_menu_id'?: number;
}
/**
 * 
 * @export
 * @interface CouponAvailabilityRequestServiceDetailsInner
 */
export interface CouponAvailabilityRequestServiceDetailsInner {
    /**
     * 
     * @type {number}
     * @memberof CouponAvailabilityRequestServiceDetailsInner
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof CouponAvailabilityRequestServiceDetailsInner
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface CouponAvailabilityResponse
 */
export interface CouponAvailabilityResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CouponAvailabilityResponse
     */
    'has_active_coupon': boolean;
}
/**
 * クーポン適用時の金額内訳
 * @export
 * @interface CouponPriceBreakdown
 */
export interface CouponPriceBreakdown {
    /**
     * 
     * @type {boolean}
     * @memberof CouponPriceBreakdown
     */
    'has_coupon_discount': boolean;
    /**
     * 
     * @type {number}
     * @memberof CouponPriceBreakdown
     */
    'subtotal': number;
    /**
     * 
     * @type {number}
     * @memberof CouponPriceBreakdown
     */
    'coupon_discount_amount': number;
    /**
     * 
     * @type {number}
     * @memberof CouponPriceBreakdown
     */
    'payment_amount': number;
    /**
     * 注文時に適用されたクーポン内容。例: 1,000円OFF または 10%OFF
     * @type {string}
     * @memberof CouponPriceBreakdown
     */
    'coupon_discount_label': string;
}
/**
 * 
 * @export
 * @interface CouponValidateRequest
 */
export interface CouponValidateRequest {
    /**
     * 
     * @type {string}
     * @memberof CouponValidateRequest
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof CouponValidateRequest
     */
    'supplier_id': number;
    /**
     * 
     * @type {number}
     * @memberof CouponValidateRequest
     */
    'service_id': number;
    /**
     * 
     * @type {number}
     * @memberof CouponValidateRequest
     */
    'subtotal': number;
    /**
     * 
     * @type {string}
     * @memberof CouponValidateRequest
     */
    'email': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof CouponValidateRequest
     */
    'service_detail_ids'?: Array<number>;
    /**
     * 
     * @type {Array<CouponAvailabilityRequestServiceDetailsInner>}
     * @memberof CouponValidateRequest
     */
    'service_details'?: Array<CouponAvailabilityRequestServiceDetailsInner>;
    /**
     * 
     * @type {number}
     * @memberof CouponValidateRequest
     */
    'service_menu_id'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CouponValidateRequest
     */
    'service_option_ids'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CouponValidateRequest
     */
    'service_menu_option_ids'?: Array<number>;
}
/**
 * 
 * @export
 * @interface CouponValidateResponse
 */
export interface CouponValidateResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CouponValidateResponse
     */
    'valid': boolean;
    /**
     * 
     * @type {number}
     * @memberof CouponValidateResponse
     */
    'coupon_id': number;
    /**
     * 
     * @type {string}
     * @memberof CouponValidateResponse
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof CouponValidateResponse
     */
    'eligible_subtotal': number;
    /**
     * 
     * @type {number}
     * @memberof CouponValidateResponse
     */
    'discount_amount': number;
    /**
     * 
     * @type {number}
     * @memberof CouponValidateResponse
     */
    'final_amount': number;
    /**
     * 
     * @type {string}
     * @memberof CouponValidateResponse
     */
    'label': string;
    /**
     * 
     * @type {number}
     * @memberof CouponValidateResponse
     */
    'target_subtotal': number;
    /**
     * 
     * @type {number}
     * @memberof CouponValidateResponse
     */
    'option_subtotal': number;
    /**
     * 
     * @type {number}
     * @memberof CouponValidateResponse
     */
    'credit_settlement_amount': number;
}
/**
 * 
 * @export
 * @interface Creator
 */
export interface Creator {
    /**
     * 
     * @type {number}
     * @memberof Creator
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Creator
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Creator
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Creator
     */
    'last_name_kana': string;
    /**
     * 
     * @type {string}
     * @memberof Creator
     */
    'first_name_kana': string;
    /**
     * 
     * @type {string}
     * @memberof Creator
     */
    'tel': string | null;
    /**
     * 
     * @type {CreatorUserLogin}
     * @memberof Creator
     */
    'userLogin': CreatorUserLogin;
}
/**
 * 
 * @export
 * @interface CreatorUserLogin
 */
export interface CreatorUserLogin {
    /**
     * 
     * @type {string}
     * @memberof CreatorUserLogin
     */
    'email'?: string;
}
/**
 * 性別(customer.gender)
 * @export
 * @enum {string}
 */

export const CustomerGender = {
    /**
    * 未設定
    */
    NOT_SET: 0,
    /**
    * 男性
    */
    MALE: 1,
    /**
    * 女性
    */
    FEMALE: 2,
    /**
    * 未回答
    */
    OTHER: 3
} as const;

export type CustomerGender = typeof CustomerGender[keyof typeof CustomerGender];


/**
 * 顧客業種マスタ一情報
 * @export
 * @interface CustomerIndustryMaster
 */
export interface CustomerIndustryMaster {
    /**
     * customer_industry_master.id
     * @type {number}
     * @memberof CustomerIndustryMaster
     */
    'id': number;
    /**
     * customer_industry_master.industry_name
     * @type {string}
     * @memberof CustomerIndustryMaster
     */
    'industry_name': string;
}
/**
 * 
 * @export
 * @interface CustomerPurchase
 */
export interface CustomerPurchase {
    /**
     * 
     * @type {number}
     * @memberof CustomerPurchase
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchase
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchase
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchase
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchase
     */
    'last_name_kana': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchase
     */
    'first_name_kana': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPurchase
     */
    'tel': string | null;
}
/**
 * 予約申込登録(カレンダー)
 * @export
 * @interface CustomerReservationCalendarServiceDto
 */
export interface CustomerReservationCalendarServiceDto {
    /**
     * サービスID(service.id)
     * @type {number}
     * @memberof CustomerReservationCalendarServiceDto
     */
    'id': number;
    /**
     * 
     * @type {PutReservationPrepareOrderViaPaypalRequestServiceServiceMenu}
     * @memberof CustomerReservationCalendarServiceDto
     */
    'service_menu': PutReservationPrepareOrderViaPaypalRequestServiceServiceMenu;
}
/**
 * 予約申込登録(顧客情報)
 * @export
 * @interface CustomerReservationDto
 */
export interface CustomerReservationDto {
    /**
     * 氏名 姓(customer_purchase_histories.last_name)
     * @type {string}
     * @memberof CustomerReservationDto
     */
    'last_name'?: string;
    /**
     * 氏名 名(customer_purchase_histories.first_name)
     * @type {string}
     * @memberof CustomerReservationDto
     */
    'first_name'?: string;
    /**
     * フリガナ 姓(customer_purchase_histories.last_name_kana)
     * @type {string}
     * @memberof CustomerReservationDto
     */
    'last_name_kana'?: string;
    /**
     * フリガナ 名(customer_purchase_histories.first_name_kana)
     * @type {string}
     * @memberof CustomerReservationDto
     */
    'first_name_kana'?: string;
    /**
     * 会社名(customer_purchase_histories.company_name)
     * @type {string}
     * @memberof CustomerReservationDto
     */
    'company_name'?: string;
    /**
     * メールアドレス(customer_purchase_histories.name)
     * @type {string}
     * @memberof CustomerReservationDto
     */
    'email': string;
    /**
     * メールアドレス(customer_purchase_histories.sub_email)
     * @type {string}
     * @memberof CustomerReservationDto
     */
    'sub_email'?: string;
    /**
     * 
     * @type {CustomerSendMailFlag}
     * @memberof CustomerReservationDto
     */
    'send_mail_flag'?: CustomerSendMailFlag;
    /**
     * 電話番号(customer_purchase_histories.tel)
     * @type {string}
     * @memberof CustomerReservationDto
     */
    'tel'?: string;
    /**
     * 郵便番号(customer_purchase_histories.zip)
     * @type {string}
     * @memberof CustomerReservationDto
     */
    'zip'?: string;
    /**
     * 都道府県ID(customer_purchase_histories.pref_master_id)
     * @type {number}
     * @memberof CustomerReservationDto
     */
    'pref_master_id'?: number;
    /**
     * 住所(customer_purchase_histories.address1)
     * @type {string}
     * @memberof CustomerReservationDto
     */
    'address1'?: string;
    /**
     * 建物名(customer_purchase_histories.address2)
     * @type {string}
     * @memberof CustomerReservationDto
     */
    'address2'?: string;
    /**
     * 生年月日(customer_purchase_histories.birthday_year,birthday_month,birthday_day)
     * @type {string}
     * @memberof CustomerReservationDto
     */
    'birthday'?: string;
    /**
     * 年齢(customer_purchase_histories.age)
     * @type {number}
     * @memberof CustomerReservationDto
     */
    'age'?: number;
    /**
     * 
     * @type {CustomerGender}
     * @memberof CustomerReservationDto
     */
    'gender'?: CustomerGender;
    /**
     * LINE ID(customer_purchase_histories.line_id)
     * @type {string}
     * @memberof CustomerReservationDto
     */
    'line_id'?: string;
    /**
     * Facebook ID(customer_purchase_histories.facebook_id)
     * @type {string}
     * @memberof CustomerReservationDto
     */
    'facebook_id'?: string;
    /**
     * Twitter ID(customer_purchase_histories.twitter_id)
     * @type {string}
     * @memberof CustomerReservationDto
     */
    'twitter_id'?: string;
    /**
     * Instagram ID(customer_purchase_histories.instagram_id)
     * @type {string}
     * @memberof CustomerReservationDto
     */
    'instagram_id'?: string;
    /**
     * 業種ID(customer_purchase_histories.industry_id)
     * @type {number}
     * @memberof CustomerReservationDto
     */
    'industry_id'?: number;
    /**
     * 業種その他(customer_purchase_histories.industry_text)
     * @type {string}
     * @memberof CustomerReservationDto
     */
    'industry_text'?: string;
    /**
     * 部署(customer_purchase_histories.department)
     * @type {string}
     * @memberof CustomerReservationDto
     */
    'department'?: string;
    /**
     * 役割(customer_purchase_histories.official_position)
     * @type {string}
     * @memberof CustomerReservationDto
     */
    'official_position'?: string;
    /**
     * 会社ホームページ(customer_purchase_histories.hp)
     * @type {string}
     * @memberof CustomerReservationDto
     */
    'hp'?: string;
}
/**
 * 予約申込支払い情報
 * @export
 * @interface CustomerReservationPaymentDto
 */
export interface CustomerReservationPaymentDto {
    /**
     * PaymentIntent ID
     * @type {string}
     * @memberof CustomerReservationPaymentDto
     */
    'payment_intent_id': string;
    /**
     * payment_paypal_id
     * @type {string}
     * @memberof CustomerReservationPaymentDto
     */
    'payment_paypal_id'?: string;
    /**
     * Billing amount
     * @type {number}
     * @memberof CustomerReservationPaymentDto
     */
    'billing_amount': number;
    /**
     * Credit
     * @type {number}
     * @memberof CustomerReservationPaymentDto
     */
    'settlement_method'?: number;
    /**
     * 適用クーポンID
     * @type {number}
     * @memberof CustomerReservationPaymentDto
     */
    'coupon_id'?: number | null;
    /**
     * 適用クーポンコード
     * @type {string}
     * @memberof CustomerReservationPaymentDto
     */
    'coupon_code'?: string | null;
}
/**
 * 予約申込登録(サービス)
 * @export
 * @interface CustomerReservationServiceDto
 */
export interface CustomerReservationServiceDto {
    /**
     * サービスID(services.id)
     * @type {number}
     * @memberof CustomerReservationServiceDto
     */
    'id': number;
    /**
     * 顧客が選択した開催日
     * @type {Array<number>}
     * @memberof CustomerReservationServiceDto
     */
    'service_detail_ids': Array<number>;
    /**
     * 顧客が選択したオプション
     * @type {Array<number>}
     * @memberof CustomerReservationServiceDto
     */
    'service_option_ids'?: Array<number>;
    /**
     * サービスメニューID(service_menu.id) — used for subscription services
     * @type {number}
     * @memberof CustomerReservationServiceDto
     */
    'service_menu_id'?: number;
    /**
     * 注文UUID(orders.uuid) — used to link payment to existing order
     * @type {string}
     * @memberof CustomerReservationServiceDto
     */
    'order_uuid'?: string;
    /**
     * Stripe Subscription ID — returned by POST /payment for subscription services, must be passed to POST /order to link the order to the subscription
     * @type {string}
     * @memberof CustomerReservationServiceDto
     */
    'stripe_subscription_id'?: string | null;
}
/**
 * メール送信設定(customer.send_mail_flag)
 * @export
 * @enum {string}
 */

export const CustomerSendMailFlag = {
    /**
    * 対象
    */
    TARGET: 0,
    /**
    * 非対称
    */
    NOT_TARGET: 1
} as const;

export type CustomerSendMailFlag = typeof CustomerSendMailFlag[keyof typeof CustomerSendMailFlag];


/**
 * 曜日フラグ 0:日曜日 1:月曜日 2:火曜日 3:水曜日 4:木曜日 5:金曜日 6:土曜日 7:祝日
 * @export
 * @enum {string}
 */

export const DayWeekFlag = {
    /**
    * 日曜日
    */
    SUNDAY: 0,
    /**
    * 月曜日
    */
    MONDAY: 1,
    /**
    * 火曜日
    */
    TUESDAY: 2,
    /**
    * 水曜日
    */
    WEDNESDAY: 3,
    /**
    * 木曜日
    */
    THURSDAY: 4,
    /**
    * 金曜日
    */
    FRIDAY: 5,
    /**
    * 土曜日
    */
    SATURDAY: 6,
    /**
    * 祝日
    */
    HOLIDAY: 7
} as const;

export type DayWeekFlag = typeof DayWeekFlag[keyof typeof DayWeekFlag];


/**
 * Ticket info in ticket detail
 * @export
 * @interface DetailTicket
 */
export interface DetailTicket {
    /**
     * 
     * @type {number}
     * @memberof DetailTicket
     */
    'id': number;
    /**
     * Name code
     * @type {string}
     * @memberof DetailTicket
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DetailTicket
     */
    'position': string;
    /**
     * 
     * @type {CustomerPurchase}
     * @memberof DetailTicket
     */
    'customer_purchase_history': CustomerPurchase;
    /**
     * 
     * @type {ServiceDetail}
     * @memberof DetailTicket
     */
    'service_detail': ServiceDetail;
}
/**
 * サービス情報(コンテンツ・ウェビナー)
 * @export
 * @interface DocumentRequestElement
 */
export interface DocumentRequestElement {
    /**
     * 
     * @type {ServiceStatus}
     * @memberof DocumentRequestElement
     */
    'status': ServiceStatus;
    /**
     * 
     * @type {ServiceType}
     * @memberof DocumentRequestElement
     */
    'type': ServiceType;
    /**
     * サービス名(services.name)
     * @type {string}
     * @memberof DocumentRequestElement
     */
    'service_name': string;
    /**
     * 
     * @type {ServiceReservationPeriodFlag}
     * @memberof DocumentRequestElement
     */
    'reservation_period_flag': ServiceReservationPeriodFlag;
    /**
     * 予約受付公開開始日時
     * @type {string}
     * @memberof DocumentRequestElement
     */
    'reservation_period_start_time'?: string;
    /**
     * 予約受付公開終了日時
     * @type {string}
     * @memberof DocumentRequestElement
     */
    'reservation_period_end_time'?: string;
    /**
     * 
     * @type {ServiceReservationSpecifiedPeriodFlag}
     * @memberof DocumentRequestElement
     */
    'reservation_specified_period_flag': ServiceReservationSpecifiedPeriodFlag;
    /**
     * 
     * @type {ServicePaidFlag}
     * @memberof DocumentRequestElement
     */
    'paid_flag': ServicePaidFlag;
    /**
     * 
     * @type {ServiceViewType}
     * @memberof DocumentRequestElement
     */
    'view_type': ServiceViewType;
    /**
     * 
     * @type {ServicePageViewTerm}
     * @memberof DocumentRequestElement
     */
    'page_view_term': ServicePageViewTerm;
    /**
     * 
     * @type {ServiceViewTermFlag}
     * @memberof DocumentRequestElement
     */
    'view_term_flag': ServiceViewTermFlag;
    /**
     * ページ表示開始日時(services.page_view_start_date,page_view_start_hour,page_view_start_minute)
     * @type {string}
     * @memberof DocumentRequestElement
     */
    'page_view_start_time'?: string;
    /**
     * ページ表示終了日時(services.page_view_end_date,page_view_end_hour,page_view_end_minute)
     * @type {string}
     * @memberof DocumentRequestElement
     */
    'page_view_end_time'?: string;
    /**
     * フォーム情報（複数）
     * @type {Array<Form>}
     * @memberof DocumentRequestElement
     */
    'forms': Array<Form>;
    /**
     * 
     * @type {UserPlan}
     * @memberof DocumentRequestElement
     */
    'plan': UserPlan;
    /**
     * 
     * @type {UserSpecialCommercialLaw}
     * @memberof DocumentRequestElement
     */
    'special_commercial_law': UserSpecialCommercialLaw;
    /**
     * ga tracking id
     * @type {string}
     * @memberof DocumentRequestElement
     */
    'ga_tag'?: string;
    /**
     * ga cross domain
     * @type {Array<string>}
     * @memberof DocumentRequestElement
     */
    'ga_cross_domain_tag'?: Array<string>;
    /**
     * gtm id
     * @type {string}
     * @memberof DocumentRequestElement
     */
    'gtm_id'?: string;
}
/**
 * サービス情報(コンテンツ・ウェビナー)
 * @export
 * @interface EmailNewsLetterElement
 */
export interface EmailNewsLetterElement {
    /**
     * 
     * @type {ServiceStatus}
     * @memberof EmailNewsLetterElement
     */
    'status': ServiceStatus;
    /**
     * 
     * @type {ServiceType}
     * @memberof EmailNewsLetterElement
     */
    'type': ServiceType;
    /**
     * サービス名(services.name)
     * @type {string}
     * @memberof EmailNewsLetterElement
     */
    'service_name': string;
    /**
     * 
     * @type {ServiceReservationPeriodFlag}
     * @memberof EmailNewsLetterElement
     */
    'reservation_period_flag': ServiceReservationPeriodFlag;
    /**
     * 予約受付公開開始日時
     * @type {string}
     * @memberof EmailNewsLetterElement
     */
    'reservation_period_start_time'?: string;
    /**
     * 予約受付公開終了日時
     * @type {string}
     * @memberof EmailNewsLetterElement
     */
    'reservation_period_end_time'?: string;
    /**
     * 
     * @type {ServiceReservationSpecifiedPeriodFlag}
     * @memberof EmailNewsLetterElement
     */
    'reservation_specified_period_flag': ServiceReservationSpecifiedPeriodFlag;
    /**
     * 
     * @type {ServicePaidFlag}
     * @memberof EmailNewsLetterElement
     */
    'paid_flag': ServicePaidFlag;
    /**
     * 
     * @type {ServiceViewType}
     * @memberof EmailNewsLetterElement
     */
    'view_type': ServiceViewType;
    /**
     * 
     * @type {ServicePageViewTerm}
     * @memberof EmailNewsLetterElement
     */
    'page_view_term': ServicePageViewTerm;
    /**
     * 
     * @type {ServiceViewTermFlag}
     * @memberof EmailNewsLetterElement
     */
    'view_term_flag': ServiceViewTermFlag;
    /**
     * ページ表示開始日時(services.page_view_start_date,page_view_start_hour,page_view_start_minute)
     * @type {string}
     * @memberof EmailNewsLetterElement
     */
    'page_view_start_time'?: string;
    /**
     * ページ表示終了日時(services.page_view_end_date,page_view_end_hour,page_view_end_minute)
     * @type {string}
     * @memberof EmailNewsLetterElement
     */
    'page_view_end_time'?: string;
    /**
     * フォーム情報（複数）
     * @type {Array<Form>}
     * @memberof EmailNewsLetterElement
     */
    'forms': Array<Form>;
    /**
     * 
     * @type {UserPlan}
     * @memberof EmailNewsLetterElement
     */
    'plan': UserPlan;
    /**
     * 
     * @type {UserSpecialCommercialLaw}
     * @memberof EmailNewsLetterElement
     */
    'special_commercial_law': UserSpecialCommercialLaw;
    /**
     * ga tracking id
     * @type {string}
     * @memberof EmailNewsLetterElement
     */
    'ga_tag'?: string;
    /**
     * ga cross domain
     * @type {Array<string>}
     * @memberof EmailNewsLetterElement
     */
    'ga_cross_domain_tag'?: Array<string>;
    /**
     * gtm id
     * @type {string}
     * @memberof EmailNewsLetterElement
     */
    'gtm_id'?: string;
}
/**
 * APIから返されるエラーレスポンスのボディ
 * @export
 * @interface ErrorResponseBody
 */
export interface ErrorResponseBody {
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseBody
     */
    'message': string;
    /**
     * 詳細なエラー内容
     * @type {Array<ErrorResponseBodyErrorsInner>}
     * @memberof ErrorResponseBody
     */
    'errors': Array<ErrorResponseBodyErrorsInner>;
}
/**
 * 
 * @export
 * @interface ErrorResponseBodyErrorsInner
 */
export interface ErrorResponseBodyErrorsInner {
    /**
     * エラーコード
     * @type {string}
     * @memberof ErrorResponseBodyErrorsInner
     */
    'code': string;
    /**
     * エラーメッセージ
     * @type {string}
     * @memberof ErrorResponseBodyErrorsInner
     */
    'message': string;
}
/**
 * サービス(イベント・セミナー)情報
 * @export
 * @interface EventSeminarElement
 */
export interface EventSeminarElement {
    /**
     * 
     * @type {ServiceStatus}
     * @memberof EventSeminarElement
     */
    'status': ServiceStatus;
    /**
     * 
     * @type {CapacityStatus}
     * @memberof EventSeminarElement
     */
    'capacity_status': CapacityStatus;
    /**
     * 
     * @type {number}
     * @memberof EventSeminarElement
     */
    'maximum_capacity'?: number;
    /**
     * 
     * @type {number}
     * @memberof EventSeminarElement
     */
    'remaining_capacity': number;
    /**
     * 
     * @type {ServiceType}
     * @memberof EventSeminarElement
     */
    'type': ServiceType;
    /**
     * サービス名(services.name)
     * @type {string}
     * @memberof EventSeminarElement
     */
    'service_name': string;
    /**
     * サービス提供者ID
     * @type {number}
     * @memberof EventSeminarElement
     */
    'supplier_id': number;
    /**
     * 
     * @type {ServiceReserveStatus}
     * @memberof EventSeminarElement
     */
    'reserve_status': ServiceReserveStatus;
    /**
     * 
     * @type {ServiceReservationPeriodFlag}
     * @memberof EventSeminarElement
     */
    'reservation_period_flag': ServiceReservationPeriodFlag;
    /**
     * 予約受付公開開始日時
     * @type {string}
     * @memberof EventSeminarElement
     */
    'reservation_period_start_time'?: string;
    /**
     * 予約受付公開終了日時
     * @type {string}
     * @memberof EventSeminarElement
     */
    'reservation_period_end_time'?: string;
    /**
     * 
     * @type {ServiceReservationSpecifiedPeriodFlag}
     * @memberof EventSeminarElement
     */
    'reservation_specified_period_flag': ServiceReservationSpecifiedPeriodFlag;
    /**
     * 
     * @type {ServicePaidFlag}
     * @memberof EventSeminarElement
     */
    'paid_flag': ServicePaidFlag;
    /**
     * 
     * @type {ServiceViewType}
     * @memberof EventSeminarElement
     */
    'view_type': ServiceViewType;
    /**
     * 予約問い合わせ先_名前(services.contact_name)
     * @type {string}
     * @memberof EventSeminarElement
     */
    'contact_name': string;
    /**
     * 予約問い合わせ先_メールアドレス(services.contact_mail)
     * @type {string}
     * @memberof EventSeminarElement
     */
    'contact_mail': string;
    /**
     * 予約問い合わせ先_電話番号(services.contact_tel)
     * @type {string}
     * @memberof EventSeminarElement
     */
    'contact_tel'?: string;
    /**
     * 
     * @type {ServiceViewSeatsLeft}
     * @memberof EventSeminarElement
     */
    'view_seats_left': ServiceViewSeatsLeft;
    /**
     * 
     * @type {ServicePageViewTerm}
     * @memberof EventSeminarElement
     */
    'page_view_term': ServicePageViewTerm;
    /**
     * 
     * @type {ServiceViewTermFlag}
     * @memberof EventSeminarElement
     */
    'view_term_flag': ServiceViewTermFlag;
    /**
     * 
     * @type {ServiceReservationAcceptanceSettings}
     * @memberof EventSeminarElement
     */
    'reservation_acceptance_settings': ServiceReservationAcceptanceSettings;
    /**
     * 
     * @type {ServiceReservationAcceptanceTime}
     * @memberof EventSeminarElement
     */
    'reservation_acceptance_time'?: ServiceReservationAcceptanceTime;
    /**
     * 
     * @type {ServiceCancelSettings}
     * @memberof EventSeminarElement
     */
    'cancel_settings': ServiceCancelSettings;
    /**
     * 
     * @type {ServiceCancelPriceSettings}
     * @memberof EventSeminarElement
     */
    'cancel_price_settings'?: ServiceCancelPriceSettings;
    /**
     * 
     * @type {ServiceScheduleChangeSettings}
     * @memberof EventSeminarElement
     */
    'schedule_change_settings': ServiceScheduleChangeSettings;
    /**
     * ページ表示開始日時(services.page_view_start_date,page_view_start_hour,page_view_start_minute)
     * @type {string}
     * @memberof EventSeminarElement
     */
    'page_view_start_time'?: string;
    /**
     * ページ表示終了日時(services.page_view_end_date,page_view_end_hour,page_view_end_minute)
     * @type {string}
     * @memberof EventSeminarElement
     */
    'page_view_end_time'?: string;
    /**
     * 
     * @type {Array<ServiceDetailsDto>}
     * @memberof EventSeminarElement
     */
    'details': Array<ServiceDetailsDto>;
    /**
     * 
     * @type {Array<ServicePaymentMethodDto>}
     * @memberof EventSeminarElement
     */
    'paymentmethod'?: Array<ServicePaymentMethodDto>;
    /**
     * 
     * @type {Array<OptionDto>}
     * @memberof EventSeminarElement
     */
    'options'?: Array<OptionDto>;
    /**
     * フォーム情報（複数）
     * @type {Array<Form>}
     * @memberof EventSeminarElement
     */
    'forms': Array<Form>;
    /**
     * 
     * @type {UserPlan}
     * @memberof EventSeminarElement
     */
    'plan': UserPlan;
    /**
     * 
     * @type {UserSpecialCommercialLaw}
     * @memberof EventSeminarElement
     */
    'special_commercial_law': UserSpecialCommercialLaw;
    /**
     * disable_past_flag
     * @type {boolean}
     * @memberof EventSeminarElement
     */
    'disable_past_flag'?: boolean;
    /**
     * ga tracking id
     * @type {string}
     * @memberof EventSeminarElement
     */
    'ga_tag'?: string;
    /**
     * ga cross domain
     * @type {Array<string>}
     * @memberof EventSeminarElement
     */
    'ga_cross_domain_tag'?: Array<string>;
    /**
     * gtm id
     * @type {string}
     * @memberof EventSeminarElement
     */
    'gtm_id'?: string;
}
/**
 * フォーム情報取得
 * @export
 * @interface Form
 */
export interface Form {
    /**
     * 
     * @type {ServiceFormsType}
     * @memberof Form
     */
    'form_type': ServiceFormsType;
    /**
     * 
     * @type {number}
     * @memberof Form
     */
    'service_form_id': number;
    /**
     * 
     * @type {FormCustomForm}
     * @memberof Form
     */
    'custom_form': FormCustomForm;
}
/**
 * カスタムフォーム項目情報
 * @export
 * @interface FormCustomForm
 */
export interface FormCustomForm {
    /**
     * 
     * @type {number}
     * @memberof FormCustomForm
     */
    'service_custom_form_id': number;
    /**
     * service_custom_forms.title
     * @type {string}
     * @memberof FormCustomForm
     */
    'title'?: string;
    /**
     * 
     * @type {ServiceCustomFormsType}
     * @memberof FormCustomForm
     */
    'custom_forms_type': ServiceCustomFormsType;
    /**
     * 
     * @type {ServiceCustomFormsMaximumFile}
     * @memberof FormCustomForm
     */
    'custom_forms_maximum_file'?: ServiceCustomFormsMaximumFile;
    /**
     * 
     * @type {ServiceCustomFormsFileType}
     * @memberof FormCustomForm
     */
    'custom_forms_file_type'?: ServiceCustomFormsFileType;
    /**
     * 
     * @type {ServiceCustomFormsRequiredFlag}
     * @memberof FormCustomForm
     */
    'required_flag': ServiceCustomFormsRequiredFlag;
    /**
     * 
     * @type {string}
     * @memberof FormCustomForm
     */
    'custom_forms_description'?: string;
    /**
     * 
     * @type {FormCustomFormCustomFormsDescriptionJson}
     * @memberof FormCustomForm
     */
    'custom_forms_description_json'?: FormCustomFormCustomFormsDescriptionJson;
    /**
     * 
     * @type {FormCustomFormCustomFormsExtraJson}
     * @memberof FormCustomForm
     */
    'custom_forms_extra_json'?: FormCustomFormCustomFormsExtraJson;
    /**
     * 
     * @type {Array<FormCustomFormCustomFormsOptionsInner>}
     * @memberof FormCustomForm
     */
    'custom_forms_options'?: Array<FormCustomFormCustomFormsOptionsInner>;
    /**
     * 
     * @type {string}
     * @memberof FormCustomForm
     */
    'custom_forms_title'?: string;
}
/**
 * DescriptionJson
 * @export
 * @interface FormCustomFormCustomFormsDescriptionJson
 */
export interface FormCustomFormCustomFormsDescriptionJson {
    /**
     * RawDraftContentState
     * @type {object}
     * @memberof FormCustomFormCustomFormsDescriptionJson
     */
    'content'?: object;
    /**
     * 
     * @type {object}
     * @memberof FormCustomFormCustomFormsDescriptionJson
     */
    'textAreaStyle'?: object;
}
/**
 * extraJson
 * @export
 * @interface FormCustomFormCustomFormsExtraJson
 */
export interface FormCustomFormCustomFormsExtraJson {
    /**
     * RawDraftContentState
     * @type {object}
     * @memberof FormCustomFormCustomFormsExtraJson
     */
    'content'?: object;
    /**
     * 
     * @type {object}
     * @memberof FormCustomFormCustomFormsExtraJson
     */
    'textAreaStyle'?: object;
}
/**
 * 
 * @export
 * @interface FormCustomFormCustomFormsOptionsInner
 */
export interface FormCustomFormCustomFormsOptionsInner {
    /**
     * 
     * @type {number}
     * @memberof FormCustomFormCustomFormsOptionsInner
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof FormCustomFormCustomFormsOptionsInner
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof FormCustomFormCustomFormsOptionsInner
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof FormCustomFormCustomFormsOptionsInner
     */
    'otherLabel'?: string;
}
/**
 * サービス(イベント・セミナー)情報
 * @export
 * @interface FormServiceElement
 */
export interface FormServiceElement {
    /**
     * 
     * @type {ServiceStatus}
     * @memberof FormServiceElement
     */
    'status': ServiceStatus;
    /**
     * 
     * @type {ServiceType}
     * @memberof FormServiceElement
     */
    'type': ServiceType;
    /**
     * サービス名(services.name)
     * @type {string}
     * @memberof FormServiceElement
     */
    'service_name': string;
    /**
     * サービス提供者ID
     * @type {number}
     * @memberof FormServiceElement
     */
    'supplier_id': number;
    /**
     * 
     * @type {ServiceReserveStatus}
     * @memberof FormServiceElement
     */
    'reserve_status': ServiceReserveStatus;
    /**
     * 
     * @type {ServiceReservationPeriodFlag}
     * @memberof FormServiceElement
     */
    'reservation_period_flag': ServiceReservationPeriodFlag;
    /**
     * 予約受付公開開始日時
     * @type {string}
     * @memberof FormServiceElement
     */
    'reservation_period_start_time'?: string;
    /**
     * 予約受付公開終了日時
     * @type {string}
     * @memberof FormServiceElement
     */
    'reservation_period_end_time'?: string;
    /**
     * 
     * @type {ServiceReservationSpecifiedPeriodFlag}
     * @memberof FormServiceElement
     */
    'reservation_specified_period_flag': ServiceReservationSpecifiedPeriodFlag;
    /**
     * 
     * @type {ServicePaidFlag}
     * @memberof FormServiceElement
     */
    'paid_flag': ServicePaidFlag;
    /**
     * 
     * @type {ServiceViewType}
     * @memberof FormServiceElement
     */
    'view_type': ServiceViewType;
    /**
     * 予約問い合わせ先_名前(services.contact_name)
     * @type {string}
     * @memberof FormServiceElement
     */
    'contact_name': string;
    /**
     * 予約問い合わせ先_メールアドレス(services.contact_mail)
     * @type {string}
     * @memberof FormServiceElement
     */
    'contact_mail': string;
    /**
     * 予約問い合わせ先_電話番号(services.contact_tel)
     * @type {string}
     * @memberof FormServiceElement
     */
    'contact_tel'?: string;
    /**
     * 
     * @type {ServiceViewSeatsLeft}
     * @memberof FormServiceElement
     */
    'view_seats_left': ServiceViewSeatsLeft;
    /**
     * 
     * @type {ServicePageViewTerm}
     * @memberof FormServiceElement
     */
    'page_view_term': ServicePageViewTerm;
    /**
     * 
     * @type {ServiceViewTermFlag}
     * @memberof FormServiceElement
     */
    'view_term_flag': ServiceViewTermFlag;
    /**
     * 
     * @type {ServiceReservationAcceptanceSettings}
     * @memberof FormServiceElement
     */
    'reservation_acceptance_settings': ServiceReservationAcceptanceSettings;
    /**
     * 
     * @type {ServiceReservationAcceptanceTime}
     * @memberof FormServiceElement
     */
    'reservation_acceptance_time'?: ServiceReservationAcceptanceTime;
    /**
     * 
     * @type {ServiceCancelSettings}
     * @memberof FormServiceElement
     */
    'cancel_settings': ServiceCancelSettings;
    /**
     * 
     * @type {ServiceCancelPriceSettings}
     * @memberof FormServiceElement
     */
    'cancel_price_settings'?: ServiceCancelPriceSettings;
    /**
     * 
     * @type {ServiceScheduleChangeSettings}
     * @memberof FormServiceElement
     */
    'schedule_change_settings': ServiceScheduleChangeSettings;
    /**
     * ページ表示開始日時(services.page_view_start_date,page_view_start_hour,page_view_start_minute)
     * @type {string}
     * @memberof FormServiceElement
     */
    'page_view_start_time'?: string;
    /**
     * ページ表示終了日時(services.page_view_end_date,page_view_end_hour,page_view_end_minute)
     * @type {string}
     * @memberof FormServiceElement
     */
    'page_view_end_time'?: string;
    /**
     * 
     * @type {Array<ServiceDetailsDto>}
     * @memberof FormServiceElement
     */
    'details': Array<ServiceDetailsDto>;
    /**
     * 
     * @type {Array<ServicePaymentMethodDto>}
     * @memberof FormServiceElement
     */
    'paymentmethod'?: Array<ServicePaymentMethodDto>;
    /**
     * 
     * @type {Array<OptionDto>}
     * @memberof FormServiceElement
     */
    'options'?: Array<OptionDto>;
    /**
     * フォーム情報（複数）
     * @type {Array<Form>}
     * @memberof FormServiceElement
     */
    'forms': Array<Form>;
    /**
     * 
     * @type {UserPlan}
     * @memberof FormServiceElement
     */
    'plan': UserPlan;
    /**
     * 
     * @type {UserSpecialCommercialLaw}
     * @memberof FormServiceElement
     */
    'special_commercial_law': UserSpecialCommercialLaw;
    /**
     * ga tracking id
     * @type {string}
     * @memberof FormServiceElement
     */
    'ga_tag'?: string;
    /**
     * ga cross domain
     * @type {Array<string>}
     * @memberof FormServiceElement
     */
    'ga_cross_domain_tag'?: Array<string>;
    /**
     * gtm id
     * @type {string}
     * @memberof FormServiceElement
     */
    'gtm_id'?: string;
}
/**
 * 
 * @export
 * @interface GetCalendarServiceById200Response
 */
export interface GetCalendarServiceById200Response {
    /**
     * 
     * @type {CalendarInfo}
     * @memberof GetCalendarServiceById200Response
     */
    'data': CalendarInfo;
}
/**
 * 
 * @export
 * @interface GetCustomerIndustries200Response
 */
export interface GetCustomerIndustries200Response {
    /**
     * 
     * @type {Array<CustomerIndustryMaster>}
     * @memberof GetCustomerIndustries200Response
     */
    'data': Array<CustomerIndustryMaster>;
}
/**
 * 
 * @export
 * @interface GetDetailTicket200Response
 */
export interface GetDetailTicket200Response {
    /**
     * 
     * @type {DetailTicket}
     * @memberof GetDetailTicket200Response
     */
    'data': DetailTicket;
}
/**
 * 
 * @export
 * @interface GetFileDownload200Response
 */
export interface GetFileDownload200Response {
    /**
     * 
     * @type {GetFileDownload200ResponseData}
     * @memberof GetFileDownload200Response
     */
    'data': GetFileDownload200ResponseData;
}
/**
 * 
 * @export
 * @interface GetFileDownload200ResponseData
 */
export interface GetFileDownload200ResponseData {
    /**
     * 署名付きURL
     * @type {string}
     * @memberof GetFileDownload200ResponseData
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface GetForm200Response
 */
export interface GetForm200Response {
    /**
     * サービスID
     * @type {number}
     * @memberof GetForm200Response
     */
    'service_id'?: number;
    /**
     * ページID
     * @type {number}
     * @memberof GetForm200Response
     */
    'page_id'?: number;
    /**
     * フォーム情報（複数）
     * @type {Array<Form>}
     * @memberof GetForm200Response
     */
    'data': Array<Form>;
}
/**
 * 
 * @export
 * @interface GetListOrders200Response
 */
export interface GetListOrders200Response {
    /**
     * 
     * @type {Array<ServiceDetail>}
     * @memberof GetListOrders200Response
     */
    'serviceDetails': Array<ServiceDetail>;
    /**
     * 
     * @type {CustomerPurchase}
     * @memberof GetListOrders200Response
     */
    'customerPurchase': CustomerPurchase;
    /**
     * 
     * @type {Creator}
     * @memberof GetListOrders200Response
     */
    'creator': Creator;
}
/**
 * 
 * @export
 * @interface GetPage200Response
 */
export interface GetPage200Response {
    /**
     * 
     * @type {Page}
     * @memberof GetPage200Response
     */
    'data': Page;
}
/**
 * 
 * @export
 * @interface GetPrefectures200Response
 */
export interface GetPrefectures200Response {
    /**
     * 
     * @type {Array<PrefMaster>}
     * @memberof GetPrefectures200Response
     */
    'data': Array<PrefMaster>;
}
/**
 * 
 * @export
 * @interface GetPrivacyPolicyByServiceId200Response
 */
export interface GetPrivacyPolicyByServiceId200Response {
    /**
     * 
     * @type {PrivacyPolicy}
     * @memberof GetPrivacyPolicyByServiceId200Response
     */
    'data': PrivacyPolicy;
}
/**
 * 
 * @export
 * @interface GetReservationCalendar200Response
 */
export interface GetReservationCalendar200Response {
    /**
     * Googleカレンダーの再認証が必要なため予約受付を停止しているか
     * @type {boolean}
     * @memberof GetReservationCalendar200Response
     */
    'booking_suspended'?: boolean;
    /**
     * 予約サービス情報取得
     * @type {{ [key: string]: ReservationCalendarDtoValue; }}
     * @memberof GetReservationCalendar200Response
     */
    'data': { [key: string]: ReservationCalendarDtoValue; };
}
/**
 * 
 * @export
 * @interface GetReservationCalendarDetail200Response
 */
export interface GetReservationCalendarDetail200Response {
    /**
     * 
     * @type {ReservationCalendarDetail}
     * @memberof GetReservationCalendarDetail200Response
     */
    'data': ReservationCalendarDetail;
}
/**
 * 
 * @export
 * @interface GetReservationCalendarNearestDate200Response
 */
export interface GetReservationCalendarNearestDate200Response {
    /**
     * 
     * @type {GetReservationCalendarNearestDate200ResponseData}
     * @memberof GetReservationCalendarNearestDate200Response
     */
    'data': GetReservationCalendarNearestDate200ResponseData;
}
/**
 * 
 * @export
 * @interface GetReservationCalendarNearestDate200ResponseData
 */
export interface GetReservationCalendarNearestDate200ResponseData {
    /**
     * 
     * @type {string}
     * @memberof GetReservationCalendarNearestDate200ResponseData
     */
    'date': string;
}
/**
 * 
 * @export
 * @interface GetReservationCalendarService200Response
 */
export interface GetReservationCalendarService200Response {
    /**
     * 
     * @type {ServiceCalendar}
     * @memberof GetReservationCalendarService200Response
     */
    'data': ServiceCalendar;
}
/**
 * 
 * @export
 * @interface GetReservationContact200Response
 */
export interface GetReservationContact200Response {
    /**
     * 
     * @type {Contact}
     * @memberof GetReservationContact200Response
     */
    'data': Contact;
}
/**
 * 
 * @export
 * @interface GetReservationDetail200Response
 */
export interface GetReservationDetail200Response {
    /**
     * 
     * @type {ReservationDetail}
     * @memberof GetReservationDetail200Response
     */
    'data': ReservationDetail;
}
/**
 * 
 * @export
 * @interface GetReservationService200Response
 */
export interface GetReservationService200Response {
    /**
     * 
     * @type {Service}
     * @memberof GetReservationService200Response
     */
    'data': Service;
}
/**
 * 
 * @export
 * @interface GetServiceById200Response
 */
export interface GetServiceById200Response {
    /**
     * 
     * @type {ServiceInfo}
     * @memberof GetServiceById200Response
     */
    'data': ServiceInfo;
}
/**
 * 
 * @export
 * @interface GetServiceComponents200Response
 */
export interface GetServiceComponents200Response {
    /**
     * 
     * @type {Array<GetServiceComponents200ResponseDataInner>}
     * @memberof GetServiceComponents200Response
     */
    'data': Array<GetServiceComponents200ResponseDataInner>;
    /**
     * 
     * @type {GetServiceComponents200ResponseMeta}
     * @memberof GetServiceComponents200Response
     */
    'meta'?: GetServiceComponents200ResponseMeta;
}
/**
 * 
 * @export
 * @interface GetServiceComponents200ResponseDataInner
 */
export interface GetServiceComponents200ResponseDataInner {
    /**
     * 
     * @type {number}
     * @memberof GetServiceComponents200ResponseDataInner
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetServiceComponents200ResponseDataInner
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetServiceComponents200ResponseDataInner
     */
    'status'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetServiceComponents200ResponseDataInner
     */
    'type'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetServiceComponents200ResponseDataInner
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetServiceComponents200ResponseDataInner
     */
    'image'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetServiceComponents200ResponseDataInner
     */
    'first_public_page'?: string;
    /**
     * 
     * @type {Array<GetServiceComponents200ResponseDataInnerServiceDetailsInner>}
     * @memberof GetServiceComponents200ResponseDataInner
     */
    'serviceDetails'?: Array<GetServiceComponents200ResponseDataInnerServiceDetailsInner>;
}
/**
 * 
 * @export
 * @interface GetServiceComponents200ResponseDataInnerServiceDetailsInner
 */
export interface GetServiceComponents200ResponseDataInnerServiceDetailsInner {
    /**
     * 
     * @type {number}
     * @memberof GetServiceComponents200ResponseDataInnerServiceDetailsInner
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetServiceComponents200ResponseDataInnerServiceDetailsInner
     */
    'event_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetServiceComponents200ResponseDataInnerServiceDetailsInner
     */
    'event_start_time': string;
    /**
     * 
     * @type {number}
     * @memberof GetServiceComponents200ResponseDataInnerServiceDetailsInner
     */
    'start_hour'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetServiceComponents200ResponseDataInnerServiceDetailsInner
     */
    'start_minute'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetServiceComponents200ResponseDataInnerServiceDetailsInner
     */
    'end_hour'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetServiceComponents200ResponseDataInnerServiceDetailsInner
     */
    'end_minute'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetServiceComponents200ResponseDataInnerServiceDetailsInner
     */
    'pref_master_id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetServiceComponents200ResponseDataInnerServiceDetailsInner
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetServiceComponents200ResponseDataInnerServiceDetailsInner
     */
    'address1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetServiceComponents200ResponseDataInnerServiceDetailsInner
     */
    'address2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetServiceComponents200ResponseDataInnerServiceDetailsInner
     */
    'place_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetServiceComponents200ResponseDataInnerServiceDetailsInner
     */
    'url'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetServiceComponents200ResponseDataInnerServiceDetailsInner
     */
    'type'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetServiceComponents200ResponseDataInnerServiceDetailsInner
     */
    'menu_name'?: string;
}
/**
 * 
 * @export
 * @interface GetServiceComponents200ResponseMeta
 */
export interface GetServiceComponents200ResponseMeta {
    /**
     * 
     * @type {number}
     * @memberof GetServiceComponents200ResponseMeta
     */
    'current_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetServiceComponents200ResponseMeta
     */
    'last_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetServiceComponents200ResponseMeta
     */
    'per_page'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetServiceComponents200ResponseMeta
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface GetServiceComponentsByIds200Response
 */
export interface GetServiceComponentsByIds200Response {
    /**
     * 
     * @type {Array<GetServiceComponents200ResponseDataInner>}
     * @memberof GetServiceComponentsByIds200Response
     */
    'data': Array<GetServiceComponents200ResponseDataInner>;
}
/**
 * 
 * @export
 * @interface GetServiceMenuById200Response
 */
export interface GetServiceMenuById200Response {
    /**
     * 
     * @type {ServiceMenuInfo}
     * @memberof GetServiceMenuById200Response
     */
    'data': ServiceMenuInfo;
}
/**
 * 
 * @export
 * @interface GetServiceTermPage200Response
 */
export interface GetServiceTermPage200Response {
    /**
     * 
     * @type {ServiceTermsPage}
     * @memberof GetServiceTermPage200Response
     */
    'data': ServiceTermsPage;
}
/**
 * 
 * @export
 * @interface GetSimplePage200Response
 */
export interface GetSimplePage200Response {
    /**
     * 
     * @type {SimplePage}
     * @memberof GetSimplePage200Response
     */
    'data': SimplePage;
}
/**
 * 
 * @export
 * @interface GetSpecialCommercialLawById200Response
 */
export interface GetSpecialCommercialLawById200Response {
    /**
     * 
     * @type {SpecialCommercialLaw}
     * @memberof GetSpecialCommercialLawById200Response
     */
    'data': SpecialCommercialLaw;
}
/**
 * 
 * @export
 * @interface GetSubscriptionPortal200Response
 */
export interface GetSubscriptionPortal200Response {
    /**
     * 
     * @type {GetSubscriptionPortal200ResponseData}
     * @memberof GetSubscriptionPortal200Response
     */
    'data': GetSubscriptionPortal200ResponseData;
}
/**
 * 
 * @export
 * @interface GetSubscriptionPortal200ResponseData
 */
export interface GetSubscriptionPortal200ResponseData {
    /**
     * 
     * @type {string}
     * @memberof GetSubscriptionPortal200ResponseData
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface GetThanksPage200Response
 */
export interface GetThanksPage200Response {
    /**
     * 
     * @type {ThanksPage}
     * @memberof GetThanksPage200Response
     */
    'data': ThanksPage;
}
/**
 * 
 * @export
 * @interface GetUserName200Response
 */
export interface GetUserName200Response {
    /**
     * 
     * @type {GetUserName200ResponseData}
     * @memberof GetUserName200Response
     */
    'data': GetUserName200ResponseData;
}
/**
 * 
 * @export
 * @interface GetUserName200ResponseData
 */
export interface GetUserName200ResponseData {
    /**
     * Name
     * @type {string}
     * @memberof GetUserName200ResponseData
     */
    'name': string;
}
/**
 * サービス開催日
 * @export
 * @interface HoldDate
 */
export interface HoldDate {
    /**
     * サービス詳細ID(service_details.id)
     * @type {number}
     * @memberof HoldDate
     */
    'id': number;
    /**
     * 
     * @type {ServiceDetailType}
     * @memberof HoldDate
     */
    'type': ServiceDetailType;
    /**
     * サービスID(service_details.service_id)
     * @type {number}
     * @memberof HoldDate
     */
    'service_id': number;
    /**
     * 開始日時(service_details.event_date,start_hour,start_minute)
     * @type {string}
     * @memberof HoldDate
     */
    'start': string;
    /**
     * 終了日時(service_details.event_date,end_hour,end_minute)
     * @type {string}
     * @memberof HoldDate
     */
    'end': string;
    /**
     * 価格(service_details.price)
     * @type {number}
     * @memberof HoldDate
     */
    'price': number;
    /**
     * 郵便番号(service_details.zip)
     * @type {string}
     * @memberof HoldDate
     */
    'zip': string;
    /**
     * 都道府県(service_details.pref_master_id)
     * @type {number}
     * @memberof HoldDate
     */
    'pref_master_id': number;
    /**
     * 住所(service_details.address1)
     * @type {string}
     * @memberof HoldDate
     */
    'address1': string;
    /**
     * 建物名(service_details.address2)
     * @type {string}
     * @memberof HoldDate
     */
    'address2': string;
    /**
     * 建物名(service_details.place_name)
     * @type {string}
     * @memberof HoldDate
     */
    'place_name': string;
    /**
     * 
     * @type {string}
     * @memberof HoldDate
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface IndexServiceHoldDate200Response
 */
export interface IndexServiceHoldDate200Response {
    /**
     * 
     * @type {Array<HoldDate>}
     * @memberof IndexServiceHoldDate200Response
     */
    'data': Array<HoldDate>;
}
/**
 * サービス情報(コンテンツ・ウェビナー)
 * @export
 * @interface InquiryElement
 */
export interface InquiryElement {
    /**
     * 
     * @type {ServiceStatus}
     * @memberof InquiryElement
     */
    'status': ServiceStatus;
    /**
     * 
     * @type {ServiceType}
     * @memberof InquiryElement
     */
    'type': ServiceType;
    /**
     * サービス名(services.name)
     * @type {string}
     * @memberof InquiryElement
     */
    'service_name': string;
    /**
     * 
     * @type {ServiceReservationPeriodFlag}
     * @memberof InquiryElement
     */
    'reservation_period_flag': ServiceReservationPeriodFlag;
    /**
     * 予約受付公開開始日時
     * @type {string}
     * @memberof InquiryElement
     */
    'reservation_period_start_time'?: string;
    /**
     * 予約受付公開終了日時
     * @type {string}
     * @memberof InquiryElement
     */
    'reservation_period_end_time'?: string;
    /**
     * 
     * @type {ServiceReservationSpecifiedPeriodFlag}
     * @memberof InquiryElement
     */
    'reservation_specified_period_flag': ServiceReservationSpecifiedPeriodFlag;
    /**
     * 
     * @type {ServicePaidFlag}
     * @memberof InquiryElement
     */
    'paid_flag': ServicePaidFlag;
    /**
     * 
     * @type {ServiceViewType}
     * @memberof InquiryElement
     */
    'view_type': ServiceViewType;
    /**
     * 
     * @type {ServicePageViewTerm}
     * @memberof InquiryElement
     */
    'page_view_term': ServicePageViewTerm;
    /**
     * 
     * @type {ServiceViewTermFlag}
     * @memberof InquiryElement
     */
    'view_term_flag': ServiceViewTermFlag;
    /**
     * ページ表示開始日時(services.page_view_start_date,page_view_start_hour,page_view_start_minute)
     * @type {string}
     * @memberof InquiryElement
     */
    'page_view_start_time'?: string;
    /**
     * ページ表示終了日時(services.page_view_end_date,page_view_end_hour,page_view_end_minute)
     * @type {string}
     * @memberof InquiryElement
     */
    'page_view_end_time'?: string;
    /**
     * フォーム情報（複数）
     * @type {Array<Form>}
     * @memberof InquiryElement
     */
    'forms': Array<Form>;
    /**
     * 
     * @type {UserPlan}
     * @memberof InquiryElement
     */
    'plan': UserPlan;
    /**
     * 
     * @type {UserSpecialCommercialLaw}
     * @memberof InquiryElement
     */
    'special_commercial_law': UserSpecialCommercialLaw;
    /**
     * ga tracking id
     * @type {string}
     * @memberof InquiryElement
     */
    'ga_tag'?: string;
    /**
     * ga cross domain
     * @type {Array<string>}
     * @memberof InquiryElement
     */
    'ga_cross_domain_tag'?: Array<string>;
    /**
     * gtm id
     * @type {string}
     * @memberof InquiryElement
     */
    'gtm_id'?: string;
}
/**
 * 
 * @export
 * @interface InvalidateReservation200Response
 */
export interface InvalidateReservation200Response {
    /**
     * 
     * @type {InvalidateReservation200ResponseData}
     * @memberof InvalidateReservation200Response
     */
    'data': InvalidateReservation200ResponseData;
}
/**
 * 
 * @export
 * @interface InvalidateReservation200ResponseData
 */
export interface InvalidateReservation200ResponseData {
    /**
     * バリデーション結果
     * @type {boolean}
     * @memberof InvalidateReservation200ResponseData
     */
    'is_valid'?: boolean;
}
/**
 * 
 * @export
 * @interface InvalidateReservationRequest
 */
export interface InvalidateReservationRequest {
    /**
     * 
     * @type {InvalidateReservationRequestService}
     * @memberof InvalidateReservationRequest
     */
    'service'?: InvalidateReservationRequestService;
}
/**
 * 
 * @export
 * @interface InvalidateReservationRequestService
 */
export interface InvalidateReservationRequestService {
    /**
     * サービスID
     * @type {number}
     * @memberof InvalidateReservationRequestService
     */
    'id': number;
    /**
     * 
     * @type {Array<InvalidateReservationRequestServiceServiceDetailsInner>}
     * @memberof InvalidateReservationRequestService
     */
    'service_details': Array<InvalidateReservationRequestServiceServiceDetailsInner>;
}
/**
 * 
 * @export
 * @interface InvalidateReservationRequestServiceServiceDetailsInner
 */
export interface InvalidateReservationRequestServiceServiceDetailsInner {
    /**
     * サービス詳細ID
     * @type {number}
     * @memberof InvalidateReservationRequestServiceServiceDetailsInner
     */
    'id': number;
    /**
     * 数量
     * @type {number}
     * @memberof InvalidateReservationRequestServiceServiceDetailsInner
     */
    'quantity': number;
}
/**
 * サービスオプション情報
 * @export
 * @interface OptionDto
 */
export interface OptionDto {
    /**
     * サービスオプションID(service_option.id)
     * @type {number}
     * @memberof OptionDto
     */
    'id'?: number;
    /**
     * 名前(service_option.name)
     * @type {string}
     * @memberof OptionDto
     */
    'name': string;
    /**
     * 金額(service_option.price)
     * @type {number}
     * @memberof OptionDto
     */
    'price'?: number;
    /**
     * 説明(service_option.describe)
     * @type {string}
     * @memberof OptionDto
     */
    'describe'?: string;
    /**
     * 
     * @type {number}
     * @memberof OptionDto
     */
    'is_show_free'?: number;
}
/**
 * 決済方法(order.settlement_method)
 * @export
 * @enum {string}
 */

export const OrderSettlementMethod = {
    /**
    * 無料
    */
    FREE: 0,
    /**
    * クレジット
    */
    CREDIT: 1,
    /**
    * 銀行振込
    */
    BANK: 2,
    /**
    * 現地払い
    */
    LOCAL_PAYMENT: 3,
    /**
    * PayPal
    */
    PAYPAL: 4
} as const;

export type OrderSettlementMethod = typeof OrderSettlementMethod[keyof typeof OrderSettlementMethod];


/**
 * ステータス(order.status)
 * @export
 * @enum {string}
 */

export const OrderStatus = {
    /**
    * 未入金
    */
    UNPAID: 1,
    /**
    * 決済済み
    */
    BILLED: 2,
    /**
    * 入金済
    */
    PAID: 3,
    /**
    * 購入・受講終了
    */
    COMPLETION: 4,
    /**
    * キャンセル
    */
    CANCEL: 5,
    /**
    * 解約受付済み
    */
    WAITINGCANCEL: 6,
    /**
    * 現地決済
    */
    FINISHED: 7,
    /**
    * 申し込み完了（決済なし）
    */
    FREE_FINISHED: 8,
    /**
    * トライアル中
    */
    TRIALING: 9
} as const;

export type OrderStatus = typeof OrderStatus[keyof typeof OrderStatus];


/**
 * Ticket info in list order
 * @export
 * @interface OrderTicket
 */
export interface OrderTicket {
    /**
     * 
     * @type {number}
     * @memberof OrderTicket
     */
    'id': number;
    /**
     * Name code
     * @type {string}
     * @memberof OrderTicket
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof OrderTicket
     */
    'order_id': number;
    /**
     * 
     * @type {number}
     * @memberof OrderTicket
     */
    'type'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderTicket
     */
    'service_detail_id'?: number;
}
/**
 * LPテンプレート取得
 * @export
 * @interface Page
 */
export interface Page {
    /**
     * サービスID(services.id)
     * @type {number}
     * @memberof Page
     */
    'service_id'?: number;
    /**
     * サービス名(services.name)
     * @type {string}
     * @memberof Page
     */
    'service_name'?: string;
    /**
     * サービスが紐づいたテンプレートブロックID
     * @type {string}
     * @memberof Page
     */
    'service_templatepart_id'?: string;
    /**
     * 
     * @type {ServiceViewType}
     * @memberof Page
     */
    'view_type': ServiceViewType;
    /**
     * フォーム情報のUUID(pages.uuid)
     * @type {string}
     * @memberof Page
     */
    'form_uuid'?: string;
    /**
     * 
     * @type {PageEditorContent}
     * @memberof Page
     */
    'page_editor_content': PageEditorContent;
    /**
     * 
     * @type {PageOgp}
     * @memberof Page
     */
    'page_ogp': PageOgp;
    /**
     * 
     * @type {PageSecretFlag}
     * @memberof Page
     */
    'form_secret_flag'?: PageSecretFlag;
    /**
     * 
     * @type {UserPlan}
     * @memberof Page
     */
    'plan'?: UserPlan;
    /**
     * 
     * @type {UserPlanConfig}
     * @memberof Page
     */
    'user_plan_config'?: UserPlanConfig;
}
/**
 * ページのJSON表現
 * @export
 * @interface PageEditorContent
 */
export interface PageEditorContent {
    /**
     * 
     * @type {object}
     * @memberof PageEditorContent
     */
    'mainBlock': object;
    /**
     * 
     * @type {object}
     * @memberof PageEditorContent
     */
    'globalCssProperties': object;
    /**
     * 
     * @type {object}
     * @memberof PageEditorContent
     */
    'draftContentState': object;
}
/**
 * OGP設定
 * @export
 * @interface PageOgp
 */
export interface PageOgp {
    /**
     * OGP タイトル
     * @type {string}
     * @memberof PageOgp
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PageOgp
     */
    'description'?: string;
    /**
     * OGP 画像
     * @type {string}
     * @memberof PageOgp
     */
    'image'?: string;
    /**
     * メイン画像のUUID
     * @type {string}
     * @memberof PageOgp
     */
    'image_uuid'?: string;
    /**
     * OGP 画像の幅
     * @type {string}
     * @memberof PageOgp
     */
    'image_width'?: string;
    /**
     * OGP 画像の高さ
     * @type {string}
     * @memberof PageOgp
     */
    'image_height'?: string;
    /**
     * 
     * @type {string}
     * @memberof PageOgp
     */
    'url'?: string;
}
/**
 * ステータス(page.secret_flag)
 * @export
 * @enum {string}
 */

export const PageSecretFlag = {
    /**
    * 指定しない
    */
    HIDE: 0,
    /**
    * 指定する
    */
    SHOW: 1
} as const;

export type PageSecretFlag = typeof PageSecretFlag[keyof typeof PageSecretFlag];


/**
 * 
 * @export
 * @interface PostCalendarReservable200Response
 */
export interface PostCalendarReservable200Response {
    /**
     * true:予約可 false:予約不可
     * @type {boolean}
     * @memberof PostCalendarReservable200Response
     */
    'data': boolean;
}
/**
 * 
 * @export
 * @interface PostContentAccessLogRequest
 */
export interface PostContentAccessLogRequest {
    /**
     * サービスID
     * @type {number}
     * @memberof PostContentAccessLogRequest
     */
    'service_id'?: number;
    /**
     * ページUUID（URLの/lp/[uuid]から取得）
     * @type {string}
     * @memberof PostContentAccessLogRequest
     */
    'page_uuid': string;
    /**
     * 顧客ID（未認証時はnull）
     * @type {number}
     * @memberof PostContentAccessLogRequest
     */
    'customer_id'?: number | null;
    /**
     * 注文ID（任意）
     * @type {number}
     * @memberof PostContentAccessLogRequest
     */
    'order_id'?: number | null;
    /**
     * 注文UUID（任意）
     * @type {string}
     * @memberof PostContentAccessLogRequest
     */
    'order_uuid'?: string | null;
    /**
     * Email from localStorage customer_form（任意）
     * @type {string}
     * @memberof PostContentAccessLogRequest
     */
    'email'?: string | null;
}
/**
 * 
 * @export
 * @interface PostLogin200Response
 */
export interface PostLogin200Response {
    /**
     * 
     * @type {boolean}
     * @memberof PostLogin200Response
     */
    'two_factor'?: boolean;
}
/**
 * 
 * @export
 * @interface PostLoginRequest
 */
export interface PostLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof PostLoginRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PostLoginRequest
     */
    'password': string;
    /**
     * 
     * @type {boolean}
     * @memberof PostLoginRequest
     */
    'remember'?: boolean;
}
/**
 * 
 * @export
 * @interface PostPageSecretPasswordRequest
 */
export interface PostPageSecretPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof PostPageSecretPasswordRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface PostPurchaseHistoriesInvoice200Response
 */
export interface PostPurchaseHistoriesInvoice200Response {
    /**
     * 
     * @type {PostPurchaseHistoriesInvoice200ResponseData}
     * @memberof PostPurchaseHistoriesInvoice200Response
     */
    'data': PostPurchaseHistoriesInvoice200ResponseData;
}
/**
 * 
 * @export
 * @interface PostPurchaseHistoriesInvoice200ResponseData
 */
export interface PostPurchaseHistoriesInvoice200ResponseData {
    /**
     * 
     * @type {string}
     * @memberof PostPurchaseHistoriesInvoice200ResponseData
     */
    'invoice_path': string;
}
/**
 * 
 * @export
 * @interface PostPurchaseHistoriesInvoiceRequest
 */
export interface PostPurchaseHistoriesInvoiceRequest {
    /**
     * 
     * @type {string}
     * @memberof PostPurchaseHistoriesInvoiceRequest
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostPurchaseHistoriesInvoiceRequest
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostPurchaseHistoriesInvoiceRequest
     */
    'proviso'?: string;
}
/**
 * 
 * @export
 * @interface PostReservationCalendarPayment200Response
 */
export interface PostReservationCalendarPayment200Response {
    /**
     * 
     * @type {PostReservationCalendarPayment200ResponseData}
     * @memberof PostReservationCalendarPayment200Response
     */
    'data': PostReservationCalendarPayment200ResponseData;
}
/**
 * 
 * @export
 * @interface PostReservationCalendarPayment200ResponseData
 */
export interface PostReservationCalendarPayment200ResponseData {
    /**
     * Stripe処理ID
     * @type {string}
     * @memberof PostReservationCalendarPayment200ResponseData
     */
    'client_secret': string;
}
/**
 * 
 * @export
 * @interface PostReservationCalendarPaymentRequest
 */
export interface PostReservationCalendarPaymentRequest {
    /**
     * 
     * @type {CustomerReservationCalendarServiceDto}
     * @memberof PostReservationCalendarPaymentRequest
     */
    'service'?: CustomerReservationCalendarServiceDto;
    /**
     * 
     * @type {CustomerReservationDto}
     * @memberof PostReservationCalendarPaymentRequest
     */
    'customer'?: CustomerReservationDto;
    /**
     * PaymentMethod ID
     * @type {string}
     * @memberof PostReservationCalendarPaymentRequest
     */
    'payment_method_id'?: string;
    /**
     * 適用クーポンID
     * @type {number}
     * @memberof PostReservationCalendarPaymentRequest
     */
    'coupon_id'?: number | null;
    /**
     * 適用クーポンコード
     * @type {string}
     * @memberof PostReservationCalendarPaymentRequest
     */
    'coupon_code'?: string | null;
}
/**
 * 
 * @export
 * @interface PostReservationPayment200Response
 */
export interface PostReservationPayment200Response {
    /**
     * 
     * @type {PostReservationPayment200ResponseData}
     * @memberof PostReservationPayment200Response
     */
    'data': PostReservationPayment200ResponseData;
}
/**
 * 
 * @export
 * @interface PostReservationPayment200ResponseData
 */
export interface PostReservationPayment200ResponseData {
    /**
     * Stripe処理ID
     * @type {string}
     * @memberof PostReservationPayment200ResponseData
     */
    'client_secret': string;
    /**
     * Stripe Subscription ID (sub_xxx) — set for subscription service types
     * @type {string}
     * @memberof PostReservationPayment200ResponseData
     */
    'subscription_id'?: string | null;
}
/**
 * 
 * @export
 * @interface PostReservationPaymentRequest
 */
export interface PostReservationPaymentRequest {
    /**
     * 
     * @type {CustomerReservationServiceDto}
     * @memberof PostReservationPaymentRequest
     */
    'service'?: CustomerReservationServiceDto;
    /**
     * 
     * @type {CustomerReservationDto}
     * @memberof PostReservationPaymentRequest
     */
    'customer'?: CustomerReservationDto;
    /**
     * PaymentMethod ID
     * @type {string}
     * @memberof PostReservationPaymentRequest
     */
    'payment_method_id'?: string;
    /**
     * 適用クーポンID
     * @type {number}
     * @memberof PostReservationPaymentRequest
     */
    'coupon_id'?: number | null;
    /**
     * 適用クーポンコード
     * @type {string}
     * @memberof PostReservationPaymentRequest
     */
    'coupon_code'?: string | null;
}
/**
 * 
 * @export
 * @interface PostResetPasswordRequest
 */
export interface PostResetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof PostResetPasswordRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PostResetPasswordRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof PostResetPasswordRequest
     */
    'password_confirmation': string;
    /**
     * 
     * @type {string}
     * @memberof PostResetPasswordRequest
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface PostUploadFile200Response
 */
export interface PostUploadFile200Response {
    /**
     * 
     * @type {PostUploadFile200ResponseData}
     * @memberof PostUploadFile200Response
     */
    'data': PostUploadFile200ResponseData;
}
/**
 * 
 * @export
 * @interface PostUploadFile200ResponseData
 */
export interface PostUploadFile200ResponseData {
    /**
     * 
     * @type {string}
     * @memberof PostUploadFile200ResponseData
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface PostUploadFileRequest
 */
export interface PostUploadFileRequest {
    /**
     * ファイル名
     * @type {string}
     * @memberof PostUploadFileRequest
     */
    'name': string;
    /**
     * 画像ファイル(base64-encoded)
     * @type {string}
     * @memberof PostUploadFileRequest
     */
    'file': string;
}
/**
 * 都道府県マスタ情報
 * @export
 * @interface PrefMaster
 */
export interface PrefMaster {
    /**
     * pref_master.id
     * @type {number}
     * @memberof PrefMaster
     */
    'id': number;
    /**
     * pref_master.pref_name
     * @type {string}
     * @memberof PrefMaster
     */
    'pref_name': string;
}
/**
 * プライバシーポリシー
 * @export
 * @interface PrivacyPolicy
 */
export interface PrivacyPolicy {
    /**
     * 
     * @type {PrivacyPolicyType}
     * @memberof PrivacyPolicy
     */
    'type': PrivacyPolicyType;
    /**
     * 
     * @type {PrivacyPolicyPrivacyPolicyJson}
     * @memberof PrivacyPolicy
     */
    'privacy_policy_json': PrivacyPolicyPrivacyPolicyJson;
    /**
     * プライバシーポリシーのリンク
     * @type {string}
     * @memberof PrivacyPolicy
     */
    'privacy_link': string;
}
/**
 * プライバシーポリシーのJSONデータ
 * @export
 * @interface PrivacyPolicyPrivacyPolicyJson
 */
export interface PrivacyPolicyPrivacyPolicyJson {
    /**
     * RawDraftContentState
     * @type {object}
     * @memberof PrivacyPolicyPrivacyPolicyJson
     */
    'content'?: object;
    /**
     * 
     * @type {object}
     * @memberof PrivacyPolicyPrivacyPolicyJson
     */
    'textAreaStyle'?: object;
}
/**
 * プライバシーポリシータイプ
 * @export
 * @enum {string}
 */

export const PrivacyPolicyType = {
    /**
    * カスタム
    */
    CUSTOM: 1,
    /**
    * リンク
    */
    LINK: 2
} as const;

export type PrivacyPolicyType = typeof PrivacyPolicyType[keyof typeof PrivacyPolicyType];


/**
 * 
 * @export
 * @interface PutReservationCalendarOrder200Response
 */
export interface PutReservationCalendarOrder200Response {
    /**
     * 
     * @type {PutReservationCalendarOrder200ResponseData}
     * @memberof PutReservationCalendarOrder200Response
     */
    'data': PutReservationCalendarOrder200ResponseData;
}
/**
 * 
 * @export
 * @interface PutReservationCalendarOrder200ResponseData
 */
export interface PutReservationCalendarOrder200ResponseData {
    /**
     * サンクスページのUUID(pages.uuid)
     * @type {string}
     * @memberof PutReservationCalendarOrder200ResponseData
     */
    'thanks_uuid': string;
    /**
     * 注文情報のUUID(order.uuid)
     * @type {string}
     * @memberof PutReservationCalendarOrder200ResponseData
     */
    'order_uuid': string;
    /**
     * 
     * @type {number}
     * @memberof PutReservationCalendarOrder200ResponseData
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface PutReservationCalendarOrderRequest
 */
export interface PutReservationCalendarOrderRequest {
    /**
     * 
     * @type {CustomerReservationCalendarServiceDto}
     * @memberof PutReservationCalendarOrderRequest
     */
    'service'?: CustomerReservationCalendarServiceDto;
    /**
     * 
     * @type {CustomerReservationDto}
     * @memberof PutReservationCalendarOrderRequest
     */
    'customer'?: CustomerReservationDto;
    /**
     * 
     * @type {CustomerReservationPaymentDto}
     * @memberof PutReservationCalendarOrderRequest
     */
    'payment'?: CustomerReservationPaymentDto;
    /**
     * ページID
     * @type {number}
     * @memberof PutReservationCalendarOrderRequest
     */
    'page_id'?: number;
}
/**
 * 
 * @export
 * @interface PutReservationDatesRequest
 */
export interface PutReservationDatesRequest {
    /**
     * 予約されたサービス詳細のID(service_details.id)
     * @type {Array<number>}
     * @memberof PutReservationDatesRequest
     */
    'reserved_ids': Array<number>;
}
/**
 * 
 * @export
 * @interface PutReservationOrder200Response
 */
export interface PutReservationOrder200Response {
    /**
     * 
     * @type {PutReservationOrder200ResponseData}
     * @memberof PutReservationOrder200Response
     */
    'data': PutReservationOrder200ResponseData;
}
/**
 * 
 * @export
 * @interface PutReservationOrder200ResponseData
 */
export interface PutReservationOrder200ResponseData {
    /**
     * 
     * @type {number}
     * @memberof PutReservationOrder200ResponseData
     */
    'id': number;
    /**
     * サンクスページのUUID(pages.uuid)
     * @type {string}
     * @memberof PutReservationOrder200ResponseData
     */
    'thanks_uuid': string;
    /**
     * 注文情報のUUID(order.uuid)
     * @type {string}
     * @memberof PutReservationOrder200ResponseData
     */
    'order_uuid': string;
}
/**
 * 
 * @export
 * @interface PutReservationOrderRequest
 */
export interface PutReservationOrderRequest {
    /**
     * 
     * @type {CustomerReservationServiceDto}
     * @memberof PutReservationOrderRequest
     */
    'service'?: CustomerReservationServiceDto;
    /**
     * 
     * @type {CustomerReservationDto}
     * @memberof PutReservationOrderRequest
     */
    'customer'?: CustomerReservationDto;
    /**
     * 
     * @type {CustomerReservationPaymentDto}
     * @memberof PutReservationOrderRequest
     */
    'payment'?: CustomerReservationPaymentDto;
    /**
     * ページID
     * @type {number}
     * @memberof PutReservationOrderRequest
     */
    'page_id'?: number;
}
/**
 * 
 * @export
 * @interface PutReservationPrepareOrderViaPaypal200Response
 */
export interface PutReservationPrepareOrderViaPaypal200Response {
    /**
     * 
     * @type {PutReservationPrepareOrderViaPaypal200ResponseData}
     * @memberof PutReservationPrepareOrderViaPaypal200Response
     */
    'data': PutReservationPrepareOrderViaPaypal200ResponseData;
}
/**
 * 
 * @export
 * @interface PutReservationPrepareOrderViaPaypal200ResponseData
 */
export interface PutReservationPrepareOrderViaPaypal200ResponseData {
    /**
     * 
     * @type {string}
     * @memberof PutReservationPrepareOrderViaPaypal200ResponseData
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface PutReservationPrepareOrderViaPaypalRequest
 */
export interface PutReservationPrepareOrderViaPaypalRequest {
    /**
     * 
     * @type {PutReservationPrepareOrderViaPaypalRequestService}
     * @memberof PutReservationPrepareOrderViaPaypalRequest
     */
    'service'?: PutReservationPrepareOrderViaPaypalRequestService;
    /**
     * 
     * @type {CustomerReservationDto}
     * @memberof PutReservationPrepareOrderViaPaypalRequest
     */
    'customer'?: CustomerReservationDto;
    /**
     * 
     * @type {CustomerReservationPaymentDto}
     * @memberof PutReservationPrepareOrderViaPaypalRequest
     */
    'payment'?: CustomerReservationPaymentDto;
    /**
     * ページID
     * @type {number}
     * @memberof PutReservationPrepareOrderViaPaypalRequest
     */
    'page_id'?: number;
}
/**
 * 予約申込登録(サービス)
 * @export
 * @interface PutReservationPrepareOrderViaPaypalRequestService
 */
export interface PutReservationPrepareOrderViaPaypalRequestService {
    /**
     * サービスID(services.id)
     * @type {number}
     * @memberof PutReservationPrepareOrderViaPaypalRequestService
     */
    'id': number;
    /**
     * 顧客が選択した開催日
     * @type {Array<number>}
     * @memberof PutReservationPrepareOrderViaPaypalRequestService
     */
    'service_detail_ids'?: Array<number>;
    /**
     * 顧客が選択したオプション
     * @type {Array<number>}
     * @memberof PutReservationPrepareOrderViaPaypalRequestService
     */
    'service_option_ids'?: Array<number>;
    /**
     * 
     * @type {PutReservationPrepareOrderViaPaypalRequestServiceServiceMenu}
     * @memberof PutReservationPrepareOrderViaPaypalRequestService
     */
    'service_menu'?: PutReservationPrepareOrderViaPaypalRequestServiceServiceMenu;
}
/**
 * 予約したサービメニュー情報
 * @export
 * @interface PutReservationPrepareOrderViaPaypalRequestServiceServiceMenu
 */
export interface PutReservationPrepareOrderViaPaypalRequestServiceServiceMenu {
    /**
     * サービスメニューID(service_menus.id)
     * @type {number}
     * @memberof PutReservationPrepareOrderViaPaypalRequestServiceServiceMenu
     */
    'id': number;
    /**
     * 顧客が予約した開始日時
     * @type {string}
     * @memberof PutReservationPrepareOrderViaPaypalRequestServiceServiceMenu
     */
    'reservation_datetime': string;
    /**
     * 選択したサービスメニューオプション
     * @type {Array<number>}
     * @memberof PutReservationPrepareOrderViaPaypalRequestServiceServiceMenu
     */
    'service_menu_option_ids'?: Array<number>;
}
/**
 * 
 * @export
 * @interface RegisterPostRequest
 */
export interface RegisterPostRequest {
    /**
     * 
     * @type {string}
     * @memberof RegisterPostRequest
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface RegisterVerifyTokenPostRequest
 */
export interface RegisterVerifyTokenPostRequest {
    /**
     * 
     * @type {string}
     * @memberof RegisterVerifyTokenPostRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterVerifyTokenPostRequest
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterVerifyTokenPostRequest
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterVerifyTokenPostRequest
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterVerifyTokenPostRequest
     */
    'last_name_kana'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterVerifyTokenPostRequest
     */
    'first_name_kana'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterVerifyTokenPostRequest
     */
    'tel'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterVerifyTokenPostRequest
     */
    'zip'?: string;
    /**
     * 
     * @type {number}
     * @memberof RegisterVerifyTokenPostRequest
     */
    'pref_master_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof RegisterVerifyTokenPostRequest
     */
    'address1'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterVerifyTokenPostRequest
     */
    'address2'?: string;
    /**
     * 
     * @type {number}
     * @memberof RegisterVerifyTokenPostRequest
     */
    'birthday_year'?: number;
    /**
     * 
     * @type {number}
     * @memberof RegisterVerifyTokenPostRequest
     */
    'birthday_month'?: number;
    /**
     * 
     * @type {number}
     * @memberof RegisterVerifyTokenPostRequest
     */
    'birthday_day'?: number;
    /**
     * 
     * @type {number}
     * @memberof RegisterVerifyTokenPostRequest
     */
    'gender'?: number;
}
/**
 * 予約情報取得(カレンダー)
 * @export
 * @interface ReservationCalendarDetail
 */
export interface ReservationCalendarDetail {
    /**
     * サービスID(services.id)
     * @type {number}
     * @memberof ReservationCalendarDetail
     */
    'service_id': number;
    /**
     * サービスID(service_menu.id)
     * @type {number}
     * @memberof ReservationCalendarDetail
     */
    'service_menu_id': number;
    /**
     * サービスメニュー名(service_menu.name)
     * @type {string}
     * @memberof ReservationCalendarDetail
     */
    'name': string;
    /**
     * 注文番号(customer_purchase_histories.purchase_id)
     * @type {string}
     * @memberof ReservationCalendarDetail
     */
    'purchase_id': string;
    /**
     * 注文番号(customer_purchase_histories.order_id)
     * @type {string}
     * @memberof ReservationCalendarDetail
     */
    'order_id': string;
    /**
     * 
     * @type {OrderStatus}
     * @memberof ReservationCalendarDetail
     */
    'order_status': OrderStatus;
    /**
     * 予約開始日時(order_menu_details.reservation_date start_hour : start_minute )
     * @type {string}
     * @memberof ReservationCalendarDetail
     */
    'reservation_start_date'?: string;
    /**
     * 予約終了日時(予約開始日時(reservation_start_date)に、order_menu_details.execution_timeを足す)
     * @type {string}
     * @memberof ReservationCalendarDetail
     */
    'reservation_end_date'?: string;
    /**
     * 
     * @type {ReservationCalendarDetailDetails}
     * @memberof ReservationCalendarDetail
     */
    'details': ReservationCalendarDetailDetails;
    /**
     * 
     * @type {Array<ReservationCalendarDetailOptionsInner>}
     * @memberof ReservationCalendarDetail
     */
    'options'?: Array<ReservationCalendarDetailOptionsInner>;
    /**
     * 
     * @type {ReservationCalendarDetailApplication}
     * @memberof ReservationCalendarDetail
     */
    'application'?: ReservationCalendarDetailApplication;
    /**
     * 
     * @type {ServiceCancelSettings}
     * @memberof ReservationCalendarDetail
     */
    'cancel_settings': ServiceCancelSettings;
    /**
     * キャンセル可否フラグ(条件判定) ※true: キャンセル可
     * @type {boolean}
     * @memberof ReservationCalendarDetail
     */
    'cancel_possible_flg': boolean;
    /**
     * キャンセル済みフラグ(条件判定) ※true: キャンセル済
     * @type {boolean}
     * @memberof ReservationCalendarDetail
     */
    'cancel_flg': boolean;
    /**
     * 備考(cancel_settings の値を使用して、文章を作って表示)
     * @type {string}
     * @memberof ReservationCalendarDetail
     */
    'remarks'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReservationCalendarDetail
     */
    'invoice_reissue_path'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReservationCalendarDetail
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReservationCalendarDetail
     */
    'proviso'?: string;
    /**
     * 
     * @type {OrderSettlementMethod}
     * @memberof ReservationCalendarDetail
     */
    'settlement_method'?: OrderSettlementMethod;
    /**
     * 
     * @type {BankAccount}
     * @memberof ReservationCalendarDetail
     */
    'bank_account_info'?: BankAccount;
    /**
     * 購入金額(order.purchase_price)
     * @type {number}
     * @memberof ReservationCalendarDetail
     */
    'purchase_price'?: number;
    /**
     * 
     * @type {CouponPriceBreakdown}
     * @memberof ReservationCalendarDetail
     */
    'coupon_price_breakdown'?: CouponPriceBreakdown;
}
/**
 * Service calendar menu
 * @export
 * @interface ReservationCalendarDetailApplication
 */
export interface ReservationCalendarDetailApplication {
    /**
     * 
     * @type {number}
     * @memberof ReservationCalendarDetailApplication
     */
    'meeting_type'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReservationCalendarDetailApplication
     */
    'meeting_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReservationCalendarDetailApplication
     */
    'meeting_zoom_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReservationCalendarDetailApplication
     */
    'meeting_pass_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReservationCalendarDetailApplication
     */
    'menu_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReservationCalendarDetailApplication
     */
    'prefecture_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReservationCalendarDetailApplication
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReservationCalendarDetailApplication
     */
    'location_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReservationCalendarDetailApplication
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReservationCalendarDetailApplication
     */
    'building'?: string;
}
/**
 * サービス詳細(開催地情報)
 * @export
 * @interface ReservationCalendarDetailDetails
 */
export interface ReservationCalendarDetailDetails {
    /**
     * 
     * @type {ServiceDetailType}
     * @memberof ReservationCalendarDetailDetails
     */
    'type': ServiceDetailType;
    /**
     * URL (service_details.url) 
     * @type {string}
     * @memberof ReservationCalendarDetailDetails
     */
    'url'?: string;
    /**
     * 場所名 (service_details.place_name) 
     * @type {string}
     * @memberof ReservationCalendarDetailDetails
     */
    'place_name'?: string;
    /**
     * 郵便番号 (service_details.zip) 
     * @type {string}
     * @memberof ReservationCalendarDetailDetails
     */
    'zip'?: string;
    /**
     * 都道府県 (service_details.pref_master_id) 
     * @type {number}
     * @memberof ReservationCalendarDetailDetails
     */
    'pref_master_id'?: number;
    /**
     * 住所 (service_details.address1) 
     * @type {string}
     * @memberof ReservationCalendarDetailDetails
     */
    'address1'?: string;
    /**
     * 建物名 (service_details.address2)
     * @type {string}
     * @memberof ReservationCalendarDetailDetails
     */
    'address2'?: string;
}
/**
 * サービスメニューオプション情報取得
 * @export
 * @interface ReservationCalendarDetailOptionsInner
 */
export interface ReservationCalendarDetailOptionsInner {
    /**
     * サービスメニューオプション名(service_menu_options.name)
     * @type {string}
     * @memberof ReservationCalendarDetailOptionsInner
     */
    'name': string;
    /**
     * 金額(service_menu_options.price)
     * @type {number}
     * @memberof ReservationCalendarDetailOptionsInner
     */
    'price': number;
    /**
     * 時間(service_menu_options.time)
     * @type {number}
     * @memberof ReservationCalendarDetailOptionsInner
     */
    'time': number;
}
/**
 * < * >:=YYYY-MM-DD
 * @export
 * @interface ReservationCalendarDtoValue
 */
export interface ReservationCalendarDtoValue {
    /**
     * 
     * @type {DayWeekFlag}
     * @memberof ReservationCalendarDtoValue
     */
    'day_of_week': DayWeekFlag;
    /**
     * 
     * @type {CalendarDefaultOpenings}
     * @memberof ReservationCalendarDtoValue
     */
    'day_of_week_openings': CalendarDefaultOpenings;
    /**
     * < * >:=HH:MM
     * @type {{ [key: string]: BookingAvailabilityLabel; }}
     * @memberof ReservationCalendarDtoValue
     */
    'time'?: { [key: string]: BookingAvailabilityLabel; };
}
/**
 * 予約サービス情報取得
 * @export
 * @interface ReservationDetail
 */
export interface ReservationDetail {
    /**
     * サービスID(services.id)
     * @type {number}
     * @memberof ReservationDetail
     */
    'service_id': number;
    /**
     * 注文番号(customer_purchase_histories.purchase_id)
     * @type {string}
     * @memberof ReservationDetail
     */
    'purchase_id': string;
    /**
     * 注文番号(customer_purchase_histories.order_id)
     * @type {string}
     * @memberof ReservationDetail
     */
    'order_id': string;
    /**
     * 
     * @type {OrderStatus}
     * @memberof ReservationDetail
     */
    'order_status': OrderStatus;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReservationDetail
     */
    'reservation_date_ids'?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReservationDetail
     */
    'reservation_dates'?: Array<string>;
    /**
     * 
     * @type {ServiceCancelSettings}
     * @memberof ReservationDetail
     */
    'cancel_settings': ServiceCancelSettings;
    /**
     * 
     * @type {ServiceScheduleChangeSettings}
     * @memberof ReservationDetail
     */
    'schedule_change_settings': ServiceScheduleChangeSettings;
    /**
     * 
     * @type {Array<ReservationDetailOptionsInner>}
     * @memberof ReservationDetail
     */
    'options'?: Array<ReservationDetailOptionsInner>;
    /**
     * キャンセル可否フラグ(条件判定) ※true: キャンセル可
     * @type {boolean}
     * @memberof ReservationDetail
     */
    'cancel_possible_flg': boolean;
    /**
     * キャンセル済みフラグ(条件判定) ※true: キャンセル済
     * @type {boolean}
     * @memberof ReservationDetail
     */
    'cancel_flg': boolean;
    /**
     * 
     * @type {string}
     * @memberof ReservationDetail
     */
    'order_uuid': string;
    /**
     * 予約日時変更可否フラグ(条件判定) ※true:変更可能 
     * @type {boolean}
     * @memberof ReservationDetail
     */
    'schedule_change_flg': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReservationDetail
     */
    'has_ticket_qr_code'?: boolean;
    /**
     * 備考(cancel_settings と schedule_change_settings の値を使用して、文章を作って表示)
     * @type {string}
     * @memberof ReservationDetail
     */
    'remarks': string;
    /**
     * 購入金額(order.purchase_price)
     * @type {number}
     * @memberof ReservationDetail
     */
    'purchase_price'?: number;
    /**
     * 
     * @type {CouponPriceBreakdown}
     * @memberof ReservationDetail
     */
    'coupon_price_breakdown'?: CouponPriceBreakdown;
    /**
     * 
     * @type {OrderSettlementMethod}
     * @memberof ReservationDetail
     */
    'settlement_method'?: OrderSettlementMethod;
    /**
     * 
     * @type {string}
     * @memberof ReservationDetail
     */
    'invoice_reissue_path'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReservationDetail
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReservationDetail
     */
    'proviso'?: string;
    /**
     * 
     * @type {BankAccount}
     * @memberof ReservationDetail
     */
    'bank_account_info'?: BankAccount;
    /**
     * 注文詳細情報
     * @type {Array<ReservationDetailOrderDetailsInner>}
     * @memberof ReservationDetail
     */
    'order_details'?: Array<ReservationDetailOrderDetailsInner>;
    /**
     * 
     * @type {ReservationSubscription}
     * @memberof ReservationDetail
     */
    'subscription'?: ReservationSubscription;
}
/**
 * オプション情報取得
 * @export
 * @interface ReservationDetailOptionsInner
 */
export interface ReservationDetailOptionsInner {
    /**
     * オプション名(service_options.name)
     * @type {string}
     * @memberof ReservationDetailOptionsInner
     */
    'name': string;
    /**
     * 金額(service_options.price)
     * @type {number}
     * @memberof ReservationDetailOptionsInner
     */
    'price': number;
}
/**
 * 
 * @export
 * @interface ReservationDetailOrderDetailsInner
 */
export interface ReservationDetailOrderDetailsInner {
    /**
     * サービス詳細ID(service_details.id)
     * @type {number}
     * @memberof ReservationDetailOrderDetailsInner
     */
    'service_detail_id'?: number;
    /**
     * サービスメニュー名
     * @type {string}
     * @memberof ReservationDetailOrderDetailsInner
     */
    'service_menu_name': string;
    /**
     * 数量
     * @type {number}
     * @memberof ReservationDetailOrderDetailsInner
     */
    'quantity': number;
    /**
     * 開始日時
     * @type {string}
     * @memberof ReservationDetailOrderDetailsInner
     */
    'start': string;
    /**
     * 終了日時
     * @type {string}
     * @memberof ReservationDetailOrderDetailsInner
     */
    'end': string;
}
/**
 * サブスクリプション補足情報
 * @export
 * @interface ReservationSubscription
 */
export interface ReservationSubscription {
    /**
     * 
     * @type {boolean}
     * @memberof ReservationSubscription
     */
    'is_trial'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReservationSubscription
     */
    'trial_period_days'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ReservationSubscription
     */
    'trial_end'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReservationSubscription
     */
    'trial_days_remaining'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReservationSubscription
     */
    'is_canceled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReservationSubscription
     */
    'canceled_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReservationSubscription
     */
    'subscription_end_at'?: string | null;
}
/**
 * 予約サービス情報取得
 * @export
 * @interface Service
 */
export interface Service {
    /**
     * サービスID(services.id)
     * @type {number}
     * @memberof Service
     */
    'id': number;
    /**
     * 
     * @type {ServiceType}
     * @memberof Service
     */
    'type': ServiceType;
    /**
     * サービス名(services.name)
     * @type {string}
     * @memberof Service
     */
    'name': string;
    /**
     * 
     * @type {ServiceWaitingListSettings}
     * @memberof Service
     */
    'waiting_list_settings': ServiceWaitingListSettings;
    /**
     * サービス画像 S3のURL(service_images.image_path)
     * @type {string}
     * @memberof Service
     */
    'image_url'?: string;
    /**
     * サービス画像(service_images.image_path)
     * @type {string}
     * @memberof Service
     */
    'image_path'?: string;
    /**
     * LPページURL(ドメイン + /lp/{page.uuid})
     * @type {string}
     * @memberof Service
     */
    'lp_page_url': string;
    /**
     * 講師(users.last_name, first_name)
     * @type {string}
     * @memberof Service
     */
    'user_name': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof Service
     */
    'service_detail_ids'?: Array<number>;
    /**
     * 
     * @type {ServiceReserveStatus}
     * @memberof Service
     */
    'reserve_status': ServiceReserveStatus;
    /**
     * 
     * @type {UserPlan}
     * @memberof Service
     */
    'plan'?: UserPlan;
    /**
     * 
     * @type {Array<ServiceContentsInner>}
     * @memberof Service
     */
    'contents'?: Array<ServiceContentsInner>;
    /**
     * 
     * @type {ServiceCancelSettings}
     * @memberof Service
     */
    'cancel_settings': ServiceCancelSettings;
    /**
     * 
     * @type {ServicePaidFlag}
     * @memberof Service
     */
    'paid_flag'?: ServicePaidFlag;
    /**
     * 
     * @type {ServiceCancelPriceSettings}
     * @memberof Service
     */
    'cancel_price_settings'?: ServiceCancelPriceSettings;
}
/**
 * 予約サービス(カレンダー)情報取得
 * @export
 * @interface ServiceCalendar
 */
export interface ServiceCalendar {
    /**
     * サービスID(services.id)
     * @type {number}
     * @memberof ServiceCalendar
     */
    'id': number;
    /**
     * 
     * @type {ServiceType}
     * @memberof ServiceCalendar
     */
    'type': ServiceType;
    /**
     * サービス名(services.name)
     * @type {string}
     * @memberof ServiceCalendar
     */
    'name': string;
    /**
     * 金額(service_menu.price)
     * @type {number}
     * @memberof ServiceCalendar
     */
    'price': number;
    /**
     * シンプルページURL(ドメイン + /simple/{page.uuid})
     * @type {string}
     * @memberof ServiceCalendar
     */
    'simple_page_url': string;
    /**
     * 講師(users.last_name, first_name)
     * @type {string}
     * @memberof ServiceCalendar
     */
    'user_name': string;
    /**
     * 
     * @type {ServiceCancelSettings}
     * @memberof ServiceCalendar
     */
    'cancel_settings': ServiceCancelSettings;
    /**
     * 
     * @type {ServicePaidFlag}
     * @memberof ServiceCalendar
     */
    'paid_flag'?: ServicePaidFlag;
    /**
     * 
     * @type {ServiceCancelPriceSettings}
     * @memberof ServiceCalendar
     */
    'cancel_price_settings'?: ServiceCancelPriceSettings;
    /**
     * 
     * @type {UserPlan}
     * @memberof ServiceCalendar
     */
    'plan'?: UserPlan;
}
/**
 * キャンセル料金設定 (services.cancel_price_settings)
 * @export
 * @enum {string}
 */

export const ServiceCancelPriceSettings = {
    /**
    * 無効
    */
    INVALID: 0,
    /**
    * 有効
    */
    VALID: 1
} as const;

export type ServiceCancelPriceSettings = typeof ServiceCancelPriceSettings[keyof typeof ServiceCancelPriceSettings];


/**
 * キャンセル受付 (services.cancel_settings) 
 * @export
 * @enum {string}
 */

export const ServiceCancelSettings = {
    /**
    * 無効
    */
    INVALID: 0,
    /**
    * 直前
    */
    JUST_BEFORE: 1,
    /**
    * 1日前
    */
    DAYS_AGO_1: 2,
    /**
    * 2日前
    */
    DAYS_AGO_2: 3,
    /**
    * 3日前
    */
    DAYS_AGO_3: 4,
    /**
    * 4日前
    */
    DAYS_AGO_4: 5,
    /**
    * 5日前
    */
    DAYS_AGO_5: 6,
    /**
    * 6日前
    */
    DAYS_AGO_6: 7,
    /**
    * 7日前
    */
    DAYS_AGO_7: 8,
    /**
    * 8日前
    */
    DAYS_AGO_8: 9,
    /**
    * 9日前
    */
    DAYS_AGO_9: 10,
    /**
    * 10日前
    */
    DAYS_AGO_10: 11,
    /**
    * 11日前
    */
    DAYS_AGO_11: 12,
    /**
    * 12日前
    */
    DAYS_AGO_12: 13,
    /**
    * 13日前
    */
    DAYS_AGO_13: 14,
    /**
    * 14日前
    */
    DAYS_AGO_14: 15,
    /**
    * 15日前
    */
    DAYS_AGO_15: 16,
    /**
    * 16日前
    */
    DAYS_AGO_16: 17,
    /**
    * 17日前
    */
    DAYS_AGO_17: 18,
    /**
    * 18日前
    */
    DAYS_AGO_18: 19,
    /**
    * 19日前
    */
    DAYS_AGO_19: 20,
    /**
    * 20日前
    */
    DAYS_AGO_20: 21,
    /**
    * 21日前
    */
    DAYS_AGO_21: 22,
    /**
    * 22日前
    */
    DAYS_AGO_22: 23,
    /**
    * 23日前
    */
    DAYS_AGO_23: 24,
    /**
    * 24日前
    */
    DAYS_AGO_24: 25,
    /**
    * 25日前
    */
    DAYS_AGO_25: 26,
    /**
    * 26日前
    */
    DAYS_AGO_26: 27,
    /**
    * 27日前
    */
    DAYS_AGO_27: 28,
    /**
    * 28日前
    */
    DAYS_AGO_28: 29,
    /**
    * 29日前
    */
    DAYS_AGO_29: 30,
    /**
    * 30日前
    */
    DAYS_AGO_30: 31
} as const;

export type ServiceCancelSettings = typeof ServiceCancelSettings[keyof typeof ServiceCancelSettings];


/**
 * コンテンツ情報
 * @export
 * @interface ServiceContentsInner
 */
export interface ServiceContentsInner {
    /**
     * 
     * @type {ServicesContentsType}
     * @memberof ServiceContentsInner
     */
    'type': ServicesContentsType;
    /**
     * 動画URL(services_contents.movie_url)
     * @type {string}
     * @memberof ServiceContentsInner
     */
    'movie_url'?: string;
    /**
     * コンテンツ(ダウンロードコンテンツはZIPファイルにまとめて、ZIPの署名付きURLになる)
     * @type {string}
     * @memberof ServiceContentsInner
     */
    'contents_path'?: string;
}
/**
 * Service custom forms file type
 * @export
 * @enum {string}
 */

export const ServiceCustomFormsFileType = {
    /**
    * jpeg, png, gif
    */
    IMAGE: 1,
    /**
    * pdf
    */
    PDF: 2,
    /**
    * jpeg, png, gif, pdf
    */
    ALL: 3
} as const;

export type ServiceCustomFormsFileType = typeof ServiceCustomFormsFileType[keyof typeof ServiceCustomFormsFileType];


/**
 * Service custom forms maximum file for upload
 * @export
 * @enum {string}
 */

export const ServiceCustomFormsMaximumFile = {
    /**
    * single upload
    */
    SINGLE: 1,
    /**
    * multiple upload
    */
    MULTIPLE: 2
} as const;

export type ServiceCustomFormsMaximumFile = typeof ServiceCustomFormsMaximumFile[keyof typeof ServiceCustomFormsMaximumFile];


/**
 * 必須フラグ (service_custom_forms.required_flag)
 * @export
 * @enum {string}
 */

export const ServiceCustomFormsRequiredFlag = {
    /**
    * 任意
    */
    OPTIONAL: 0,
    /**
    * 必須
    */
    REQUIRED: 1
} as const;

export type ServiceCustomFormsRequiredFlag = typeof ServiceCustomFormsRequiredFlag[keyof typeof ServiceCustomFormsRequiredFlag];


/**
 * インプットタイプ (service_custom_forms.type)
 * @export
 * @enum {string}
 */

export const ServiceCustomFormsType = {
    /**
    * input
    */
    INPUT: 1,
    /**
    * radio
    */
    RADIO: 2,
    /**
    * checkbox
    */
    CHECKBOX: 3,
    /**
    * textarea
    */
    TEXTAREA: 4,
    /**
    * pulldown
    */
    PULLDOWN: 5,
    /**
    * checkbox [all]
    */
    CHECKBOX_ALL: 6,
    /**
    * input for upload file
    */
    INPUT_UPLOAD: 7
} as const;

export type ServiceCustomFormsType = typeof ServiceCustomFormsType[keyof typeof ServiceCustomFormsType];


/**
 * 
 * @export
 * @interface ServiceDetail
 */
export interface ServiceDetail {
    /**
     * 
     * @type {number}
     * @memberof ServiceDetail
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ServiceDetail
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceDetail
     */
    'event_date': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceDetail
     */
    'event_start_time': string;
    /**
     * 
     * @type {number}
     * @memberof ServiceDetail
     */
    'start_hour': number;
    /**
     * 
     * @type {number}
     * @memberof ServiceDetail
     */
    'start_minute': number;
    /**
     * 
     * @type {number}
     * @memberof ServiceDetail
     */
    'end_hour': number;
    /**
     * 
     * @type {number}
     * @memberof ServiceDetail
     */
    'end_minute': number;
    /**
     * 
     * @type {number}
     * @memberof ServiceDetail
     */
    'pref_master_id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceDetail
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceDetail
     */
    'address1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceDetail
     */
    'address2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceDetail
     */
    'place_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServiceDetail
     */
    'url'?: string;
    /**
     * 
     * @type {number}
     * @memberof ServiceDetail
     */
    'type'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServiceDetail
     */
    'menu_name'?: string;
    /**
     * 
     * @type {Array<OrderTicket>}
     * @memberof ServiceDetail
     */
    'tickets': Array<OrderTicket>;
}
/**
 * サービス詳細タイプ(service_details.type)
 * @export
 * @enum {string}
 */

export const ServiceDetailType = {
    /**
    * オフライン
    */
    OFFLINE: 0,
    /**
    * オンライン
    */
    ONLINE: 1
} as const;

export type ServiceDetailType = typeof ServiceDetailType[keyof typeof ServiceDetailType];


/**
 * サービス詳細項目
 * @export
 * @interface ServiceDetailsDto
 */
export interface ServiceDetailsDto {
    /**
     * サービス詳細ID(service_details.id)
     * @type {number}
     * @memberof ServiceDetailsDto
     */
    'id'?: number;
    /**
     * イベント開始日時 (service_details.event_date,start_hour,start_minute)
     * @type {string}
     * @memberof ServiceDetailsDto
     */
    'event_start_time': string;
    /**
     * イベント終了日時 (service_details.event_date,end_hour,end_minute)
     * @type {string}
     * @memberof ServiceDetailsDto
     */
    'event_end_time': string;
    /**
     * 
     * @type {ServiceDetailType}
     * @memberof ServiceDetailsDto
     */
    'type': ServiceDetailType;
    /**
     * URL (service_details.url) 
     * @type {string}
     * @memberof ServiceDetailsDto
     */
    'url'?: string;
    /**
     * 場所名 (service_details.place_name) 
     * @type {string}
     * @memberof ServiceDetailsDto
     */
    'place_name'?: string;
    /**
     * 郵便番号 (service_details.zip) 
     * @type {string}
     * @memberof ServiceDetailsDto
     */
    'zip'?: string;
    /**
     * 都道府県 (service_details.pref_master_id) 
     * @type {number}
     * @memberof ServiceDetailsDto
     */
    'pref_master_id'?: number;
    /**
     * 住所 (service_details.address1) 
     * @type {string}
     * @memberof ServiceDetailsDto
     */
    'address1'?: string;
    /**
     * 建物名 (service_details.address2)
     * @type {string}
     * @memberof ServiceDetailsDto
     */
    'address2'?: string;
    /**
     * 定員 (service_details.maximum_number)
     * @type {number}
     * @memberof ServiceDetailsDto
     */
    'maximum_number'?: number | null;
    /**
     * 残予約数 (定員 -　予約数)
     * @type {number}
     * @memberof ServiceDetailsDto
     */
    'remaining_reservation_count'?: number;
    /**
     * 金額(service_details.price)
     * @type {number}
     * @memberof ServiceDetailsDto
     */
    'price'?: number;
    /**
     * 一度の申込で購入可能な最大チケット枚数
     * @type {number}
     * @memberof ServiceDetailsDto
     */
    'max_tickets_per_order'?: number;
    /**
     * 金額(service_details.name)
     * @type {string}
     * @memberof ServiceDetailsDto
     */
    'name'?: string;
    /**
     * 説明(service_details.describe)
     * @type {string}
     * @memberof ServiceDetailsDto
     */
    'describe'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceDetailsDto
     */
    'is_show_free'?: boolean;
}
/**
 * 項目種類 (service_forms.data_type)
 * @export
 * @enum {string}
 */

export const ServiceFormsType = {
    /**
    * アンケート
    */
    QUESTIONNAIRE: 0,
    /**
    * 氏名（姓、名）
    */
    NAME: 1,
    /**
    * フリガナ（セイ、メイ）
    */
    NAME_KANA: 2,
    /**
    * メールアドレス
    */
    MAIL_ADDRESS: 3,
    /**
    * メール配信
    */
    MAIL_DELIVERY: 4,
    /**
    * 電話番号
    */
    TEL: 5,
    /**
    * 郵便番号
    */
    ZIP: 6,
    /**
    * 都道府県
    */
    PREFECTURE: 7,
    /**
    * 住所（住所1）
    */
    ADDRESS1: 8,
    /**
    * 建物名（住所2）
    */
    ADDRESS2: 9,
    /**
    * 生年月日
    */
    BIRTHDAY: 10,
    /**
    * 年齢
    */
    AGE: 11,
    /**
    * 性別
    */
    GENDER: 12,
    /**
    * LINE ID
    */
    LINE_ID: 13,
    /**
    * フェイスブックID
    */
    FACEBOOK_ID: 14,
    /**
    * ツイッターID
    */
    TWITTER_ID: 15,
    /**
    * インスタID
    */
    INSTAGRAM_ID: 16,
    /**
    * 会社名
    */
    COMPANY_NAME: 17,
    /**
    * 業種
    */
    INDUSTRY: 18,
    /**
    * 役職
    */
    POSITION: 19,
    /**
    * 部署名
    */
    DEPARTMENT_NAME: 20,
    /**
    * 会社ホームページ
    */
    COMPANY_HP: 21,
    /**
    * 自由記述（1行）
    */
    SINGLE_LINE_DESCRIPTION: 22,
    /**
    * 自由記述（複数行）
    */
    MULTI_LINE_DESCRIPTION: 23,
    /**
    * 選択式
    */
    OPTIONS: 24,
    /**
    * Uploadfile
    */
    UPLOAD: 25
} as const;

export type ServiceFormsType = typeof ServiceFormsType[keyof typeof ServiceFormsType];


/**
 * @type ServiceInfo
 * @export
 */
export type ServiceInfo = ContentWebinarElement | DocumentRequestElement | EmailNewsLetterElement | EventSeminarElement | FormServiceElement | InquiryElement | SubscriptionElement | SurveyElement;

/**
 * 休憩時間 0:0分 1:5分 2:10分 3:15分 4:20分 5:25分 6:30分
 * @export
 * @enum {string}
 */

export const ServiceMenuBreakTime = {
    /**
    * 0分
    */
    MINUTES_0: 0,
    /**
    * 5分
    */
    MINUTES_5: 1,
    /**
    * 10分
    */
    MINUTES_10: 2,
    /**
    * 15分
    */
    MINUTES_15: 3,
    /**
    * 20分
    */
    MINUTES_20: 4,
    /**
    * 25分
    */
    MINUTES_25: 5,
    /**
    * 30分
    */
    MINUTES_30: 6,
    /**
    * 45分
    */
    MINUTES_45: 7,
    /**
    * 60分
    */
    MINUTES_60: 8
} as const;

export type ServiceMenuBreakTime = typeof ServiceMenuBreakTime[keyof typeof ServiceMenuBreakTime];


/**
 * サービスメニュー詳細
 * @export
 * @interface ServiceMenuDetailDto
 */
export interface ServiceMenuDetailDto {
    /**
     * サービスメニューID(service_menu.id)
     * @type {number}
     * @memberof ServiceMenuDetailDto
     */
    'id': number;
    /**
     * サービスメニュー名(service_menu.name)
     * @type {string}
     * @memberof ServiceMenuDetailDto
     */
    'menu_name': string;
    /**
     * メニュー画像URL(S3のURL)(service_menu.image_path)
     * @type {string}
     * @memberof ServiceMenuDetailDto
     */
    'menu_image_url'?: string;
    /**
     * 説明(service_menu.description)
     * @type {string}
     * @memberof ServiceMenuDetailDto
     */
    'description'?: string;
    /**
     * 
     * @type {ServiceMenuTimeRequired}
     * @memberof ServiceMenuDetailDto
     */
    'time_required': ServiceMenuTimeRequired;
    /**
     * 
     * @type {ServiceMenuBreakTime}
     * @memberof ServiceMenuDetailDto
     */
    'break_time': ServiceMenuBreakTime;
    /**
     * 色指定(デフォルト45BEAB)
     * @type {string}
     * @memberof ServiceMenuDetailDto
     */
    'color'?: string;
    /**
     * 金額(service_menu.price)
     * @type {number}
     * @memberof ServiceMenuDetailDto
     */
    'price'?: number;
    /**
     * 
     * @type {ServiceMenuPublicFlag}
     * @memberof ServiceMenuDetailDto
     */
    'public_flag'?: ServiceMenuPublicFlag;
    /**
     * 表示順(service_menu.display_order)
     * @type {number}
     * @memberof ServiceMenuDetailDto
     */
    'display_order'?: number;
    /**
     * 
     * @type {Array<ServiceMenuOptionDetail>}
     * @memberof ServiceMenuDetailDto
     */
    'options'?: Array<ServiceMenuOptionDetail>;
    /**
     * 画像URL(S3のURL)(service_menu.image_path)
     * @type {string}
     * @memberof ServiceMenuDetailDto
     */
    'image'?: string;
    /**
     * 
     * @type {number}
     * @memberof ServiceMenuDetailDto
     */
    'is_show_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServiceMenuDetailDto
     */
    'is_show_free'?: number;
}
/**
 * サービスメニュー情報
 * @export
 * @interface ServiceMenuInfo
 */
export interface ServiceMenuInfo {
    /**
     * サービスメニューID(service_menu.id)
     * @type {number}
     * @memberof ServiceMenuInfo
     */
    'id': number;
    /**
     * サービスメニュー名(service_menu.name)
     * @type {string}
     * @memberof ServiceMenuInfo
     */
    'name': string;
    /**
     * メニュー画像URL(S3のURL)(service_menu.image_path)
     * @type {string}
     * @memberof ServiceMenuInfo
     */
    'menu_image_url'?: string;
    /**
     * 説明(service_menu.description)
     * @type {string}
     * @memberof ServiceMenuInfo
     */
    'description'?: string;
    /**
     * 金額(service_menu.price)
     * @type {number}
     * @memberof ServiceMenuInfo
     */
    'price': number;
    /**
     * 
     * @type {ServiceMenuTimeRequired}
     * @memberof ServiceMenuInfo
     */
    'time_required': ServiceMenuTimeRequired;
    /**
     * 
     * @type {Array<ServiceMenuOptionDetail>}
     * @memberof ServiceMenuInfo
     */
    'options'?: Array<ServiceMenuOptionDetail>;
    /**
     * 
     * @type {CalendarServiceDetailsDto}
     * @memberof ServiceMenuInfo
     */
    'detail': CalendarServiceDetailsDto;
}
/**
 * サービスメニューオプション詳細
 * @export
 * @interface ServiceMenuOptionDetail
 */
export interface ServiceMenuOptionDetail {
    /**
     * オプションID(order_menu_option_details.id)
     * @type {number}
     * @memberof ServiceMenuOptionDetail
     */
    'id': number;
    /**
     * サービスID(service_menu.id)
     * @type {number}
     * @memberof ServiceMenuOptionDetail
     */
    'service_menu_id': number;
    /**
     * メニューオプション名(order_menu_option_details.name)
     * @type {string}
     * @memberof ServiceMenuOptionDetail
     */
    'name': string;
    /**
     * 金額(order_menu_option_details.price)
     * @type {number}
     * @memberof ServiceMenuOptionDetail
     */
    'amount': number;
    /**
     * 説明(order_menu_option_details.description)
     * @type {string}
     * @memberof ServiceMenuOptionDetail
     */
    'description'?: string;
    /**
     * 
     * @type {ServiceMenuOptionTime}
     * @memberof ServiceMenuOptionDetail
     */
    'time': ServiceMenuOptionTime;
    /**
     * 
     * @type {number}
     * @memberof ServiceMenuOptionDetail
     */
    'is_show_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof ServiceMenuOptionDetail
     */
    'is_show_free'?: number;
}
/**
 * 所要時間   0:15分   1:30分   2:45分   3:60分   4:75分   5:90分   6:120分   7:150分   8:180分   9:210分   10:0分   11:20分   12:25分   13:35分   14:40分   15:50分   16:55分   17:70分   18:80分   19:100分   20:240分   21:300分 
 * @export
 * @enum {string}
 */

export const ServiceMenuOptionTime = {
    /**
    * 15分
    */
    MINUTES_15: 0,
    /**
    * 30分
    */
    MINUTES_30: 1,
    /**
    * 45分
    */
    MINUTES_45: 2,
    /**
    * 60分
    */
    MINUTES_60: 3,
    /**
    * 75分
    */
    MINUTES_75: 4,
    /**
    * 90分
    */
    MINUTES_90: 5,
    /**
    * 120分
    */
    MINUTES_120: 6,
    /**
    * 150分
    */
    MINUTES_150: 7,
    /**
    * 180分
    */
    MINUTES_180: 8,
    /**
    * 210分
    */
    MINUTES_210: 9,
    /**
    * 0分
    */
    MINUTES_0: 10,
    /**
    * 20分
    */
    MINUTES_20: 11,
    /**
    * 25分
    */
    MINUTES_25: 12,
    /**
    * 35分
    */
    MINUTES_35: 13,
    /**
    * 40分
    */
    MINUTES_40: 14,
    /**
    * 50分
    */
    MINUTES_50: 15,
    /**
    * 55分
    */
    MINUTES_55: 16,
    /**
    * 70分
    */
    MINUTES_70: 17,
    /**
    * 80分
    */
    MINUTES_80: 18,
    /**
    * 100分
    */
    MINUTES_100: 19,
    /**
    * 240分
    */
    MINUTES_240: 20,
    /**
    * 300分
    */
    MINUTES_300: 21
} as const;

export type ServiceMenuOptionTime = typeof ServiceMenuOptionTime[keyof typeof ServiceMenuOptionTime];


/**
 * 公開設定 0:非公開 1:公開
 * @export
 * @enum {string}
 */

export const ServiceMenuPublicFlag = {
    /**
    * 非公開
    */
    PRIVATE: 0,
    /**
    * 公開
    */
    PUBLIC: 1
} as const;

export type ServiceMenuPublicFlag = typeof ServiceMenuPublicFlag[keyof typeof ServiceMenuPublicFlag];


/**
 * 所要時間 (サービス提供に必要な時間を分単位で表現)
 * @export
 * @enum {string}
 */

export const ServiceMenuTimeRequired = {
    /**
    * 15分
    */
    MINUTES_15: 0,
    /**
    * 30分
    */
    MINUTES_30: 1,
    /**
    * 45分
    */
    MINUTES_45: 2,
    /**
    * 60分
    */
    MINUTES_60: 3,
    /**
    * 75分
    */
    MINUTES_75: 4,
    /**
    * 90分
    */
    MINUTES_90: 5,
    /**
    * 120分
    */
    MINUTES_120: 6,
    /**
    * 150分
    */
    MINUTES_150: 7,
    /**
    * 180分
    */
    MINUTES_180: 8,
    /**
    * 210分
    */
    MINUTES_210: 9,
    /**
    * 0分
    */
    MINUTES_0: 10,
    /**
    * 20分
    */
    MINUTES_20: 11,
    /**
    * 25分
    */
    MINUTES_25: 12,
    /**
    * 35分
    */
    MINUTES_35: 13,
    /**
    * 40分
    */
    MINUTES_40: 14,
    /**
    * 50分
    */
    MINUTES_50: 15,
    /**
    * 55分
    */
    MINUTES_55: 16,
    /**
    * 70分
    */
    MINUTES_70: 17,
    /**
    * 80分
    */
    MINUTES_80: 18,
    /**
    * 100分
    */
    MINUTES_100: 19,
    /**
    * 240分
    */
    MINUTES_240: 20,
    /**
    * 300分
    */
    MINUTES_300: 21
} as const;

export type ServiceMenuTimeRequired = typeof ServiceMenuTimeRequired[keyof typeof ServiceMenuTimeRequired];


/**
 * ページ表示期間指定 (services.page_view_term)
 * @export
 * @enum {string}
 */

export const ServicePageViewTerm = {
    /**
    * 指定しない
    */
    UNSPECIFIED: 0,
    /**
    * 指定する
    */
    SPECIFIED: 1
} as const;

export type ServicePageViewTerm = typeof ServicePageViewTerm[keyof typeof ServicePageViewTerm];


/**
 * 有料フラグ(service.paid_flag)
 * @export
 * @enum {string}
 */

export const ServicePaidFlag = {
    /**
    * 無料
    */
    FREE: 0,
    /**
    * 有料
    */
    PAID: 1
} as const;

export type ServicePaidFlag = typeof ServicePaidFlag[keyof typeof ServicePaidFlag];


/**
 * 支払い方法(services_paymentmethod.type)
 * @export
 * @enum {string}
 */

export const ServicePaymentMethod = {
    /**
    * クレジットカード
    */
    CREDIT: 0,
    /**
    * 銀行振込
    */
    BANK: 1,
    /**
    * 現地払い
    */
    LOCAL_PAYMENT: 2,
    /**
    * PayPal
    */
    PAYPAL: 3
} as const;

export type ServicePaymentMethod = typeof ServicePaymentMethod[keyof typeof ServicePaymentMethod];


/**
 * サービス支払い方法情報
 * @export
 * @interface ServicePaymentMethodDto
 */
export interface ServicePaymentMethodDto {
    /**
     * サービス支払い方法ID(services_paymentmethod.id)
     * @type {number}
     * @memberof ServicePaymentMethodDto
     */
    'id'?: number;
    /**
     * 
     * @type {ServicePaymentMethod}
     * @memberof ServicePaymentMethodDto
     */
    'paymentmethod_type': ServicePaymentMethod;
}
/**
 * 受付期限締め切り(services.reservation_acceptance_settings)
 * @export
 * @enum {string}
 */

export const ServiceReservationAcceptanceSettings = {
    /**
    * 当日
    */
    TODAY: 0,
    /**
    * 1日前
    */
    DAYS_AGO_1: 1,
    /**
    * 2日前
    */
    DAYS_AGO_2: 2,
    /**
    * 3日前
    */
    DAYS_AGO_3: 3,
    /**
    * 4日前
    */
    DAYS_AGO_4: 4,
    /**
    * 5日前
    */
    DAYS_AGO_5: 5,
    /**
    * 6日前
    */
    DAYS_AGO_6: 6,
    /**
    * 7日前
    */
    DAYS_AGO_7: 7,
    /**
    * 8日前
    */
    DAYS_AGO_8: 8,
    /**
    * 9日前
    */
    DAYS_AGO_9: 9,
    /**
    * 10日前
    */
    DAYS_AGO_10: 10,
    /**
    * 11日前
    */
    DAYS_AGO_11: 11,
    /**
    * 12日前
    */
    DAYS_AGO_12: 12,
    /**
    * 13日前
    */
    DAYS_AGO_13: 13,
    /**
    * 14日前
    */
    DAYS_AGO_14: 14,
    /**
    * 15日前
    */
    DAYS_AGO_15: 15,
    /**
    * 16日前
    */
    DAYS_AGO_16: 16,
    /**
    * 17日前
    */
    DAYS_AGO_17: 17,
    /**
    * 18日前
    */
    DAYS_AGO_18: 18,
    /**
    * 19日前
    */
    DAYS_AGO_19: 19,
    /**
    * 20日前
    */
    DAYS_AGO_20: 20,
    /**
    * 21日前
    */
    DAYS_AGO_21: 21,
    /**
    * 22日前
    */
    DAYS_AGO_22: 22,
    /**
    * 23日前
    */
    DAYS_AGO_23: 23,
    /**
    * 24日前
    */
    DAYS_AGO_24: 24,
    /**
    * 25日前
    */
    DAYS_AGO_25: 25,
    /**
    * 26日前
    */
    DAYS_AGO_26: 26,
    /**
    * 27日前
    */
    DAYS_AGO_27: 27,
    /**
    * 28日前
    */
    DAYS_AGO_28: 28,
    /**
    * 29日前
    */
    DAYS_AGO_29: 29,
    /**
    * 30日前
    */
    DAYS_AGO_30: 30
} as const;

export type ServiceReservationAcceptanceSettings = typeof ServiceReservationAcceptanceSettings[keyof typeof ServiceReservationAcceptanceSettings];


/**
 * 受付期限締め切り時間 (services.reservation_acceptance_time)
 * @export
 * @enum {string}
 */

export const ServiceReservationAcceptanceTime = {
    /**
    * 0時間前
    */
    HOURS_AGO_0: 0,
    /**
    * 1時間前
    */
    HOURS_AGO_1: 1,
    /**
    * 2時間前
    */
    HOURS_AGO_2: 2,
    /**
    * 3時間前
    */
    HOURS_AGO_3: 3,
    /**
    * 4時間前
    */
    HOURS_AGO_4: 4,
    /**
    * 5時間前
    */
    HOURS_AGO_5: 5,
    /**
    * 6時間前
    */
    HOURS_AGO_6: 6,
    /**
    * 7時間前
    */
    HOURS_AGO_7: 7,
    /**
    * 8時間前
    */
    HOURS_AGO_8: 8,
    /**
    * 9時間前
    */
    HOURS_AGO_9: 9,
    /**
    * 10時間前
    */
    HOURS_AGO_10: 10,
    /**
    * 11時間前
    */
    HOURS_AGO_11: 11,
    /**
    * 12時間前
    */
    HOURS_AGO_12: 12,
    /**
    * 13時間前
    */
    HOURS_AGO_13: 13,
    /**
    * 14時間前
    */
    HOURS_AGO_14: 14,
    /**
    * 15時間前
    */
    HOURS_AGO_15: 15,
    /**
    * 16時間前
    */
    HOURS_AGO_16: 16,
    /**
    * 17時間前
    */
    HOURS_AGO_17: 17,
    /**
    * 18時間前
    */
    HOURS_AGO_18: 18,
    /**
    * 19時間前
    */
    HOURS_AGO_19: 19,
    /**
    * 20時間前
    */
    HOURS_AGO_20: 20,
    /**
    * 21時間前
    */
    HOURS_AGO_21: 21,
    /**
    * 22時間前
    */
    HOURS_AGO_22: 22,
    /**
    * 23時間前
    */
    HOURS_AGO_23: 23
} as const;

export type ServiceReservationAcceptanceTime = typeof ServiceReservationAcceptanceTime[keyof typeof ServiceReservationAcceptanceTime];


/**
 * 予約受付フラグ(service.reservation_period_flag)
 * @export
 * @enum {string}
 */

export const ServiceReservationPeriodFlag = {
    /**
    * 受付なし
    */
    WITHOUT_RESERVATION: 0,
    /**
    * 受付あり
    */
    RESERVATION: 1
} as const;

export type ServiceReservationPeriodFlag = typeof ServiceReservationPeriodFlag[keyof typeof ServiceReservationPeriodFlag];


/**
 * 予約受付期間フラグ(service.reservation_specified_period_flag)
 * @export
 * @enum {string}
 */

export const ServiceReservationSpecifiedPeriodFlag = {
    /**
    * 期間指定あり
    */
    SPECIFIED: 0,
    /**
    * 期間指定なし
    */
    UNSPECIFIED: 1
} as const;

export type ServiceReservationSpecifiedPeriodFlag = typeof ServiceReservationSpecifiedPeriodFlag[keyof typeof ServiceReservationSpecifiedPeriodFlag];


/**
 * 予約区分(service.reserve_status)
 * @export
 * @enum {string}
 */

export const ServiceReserveStatus = {
    /**
    * 全ての日程
    */
    ALL: 0,
    /**
    * いずれかの日程を選択する
    */
    SINGLE_SELECT: 1,
    /**
    * 複数の日程を選択可にする
    */
    MULTIPLE_SELECT: 2
} as const;

export type ServiceReserveStatus = typeof ServiceReserveStatus[keyof typeof ServiceReserveStatus];


/**
 * 変更受付(services.schedule_change_settings) 
 * @export
 * @enum {string}
 */

export const ServiceScheduleChangeSettings = {
    /**
    * 無効
    */
    INVALID: 0,
    /**
    * 直前
    */
    JUST_BEFORE: 1,
    /**
    * 1日前
    */
    DAYS_AGO_1: 2,
    /**
    * 2日前
    */
    DAYS_AGO_2: 3,
    /**
    * 3日前
    */
    DAYS_AGO_3: 4,
    /**
    * 4日前
    */
    DAYS_AGO_4: 5,
    /**
    * 5日前
    */
    DAYS_AGO_5: 6,
    /**
    * 6日前
    */
    DAYS_AGO_6: 7,
    /**
    * 7日前
    */
    DAYS_AGO_7: 8,
    /**
    * 8日前
    */
    DAYS_AGO_8: 9,
    /**
    * 9日前
    */
    DAYS_AGO_9: 10,
    /**
    * 10日前
    */
    DAYS_AGO_10: 11,
    /**
    * 11日前
    */
    DAYS_AGO_11: 12,
    /**
    * 12日前
    */
    DAYS_AGO_12: 13,
    /**
    * 13日前
    */
    DAYS_AGO_13: 14,
    /**
    * 14日前
    */
    DAYS_AGO_14: 15,
    /**
    * 15日前
    */
    DAYS_AGO_15: 16,
    /**
    * 16日前
    */
    DAYS_AGO_16: 17,
    /**
    * 17日前
    */
    DAYS_AGO_17: 18,
    /**
    * 18日前
    */
    DAYS_AGO_18: 19,
    /**
    * 19日前
    */
    DAYS_AGO_19: 20,
    /**
    * 20日前
    */
    DAYS_AGO_20: 21,
    /**
    * 21日前
    */
    DAYS_AGO_21: 22,
    /**
    * 22日前
    */
    DAYS_AGO_22: 23,
    /**
    * 23日前
    */
    DAYS_AGO_23: 24,
    /**
    * 24日前
    */
    DAYS_AGO_24: 25,
    /**
    * 25日前
    */
    DAYS_AGO_25: 26,
    /**
    * 26日前
    */
    DAYS_AGO_26: 27,
    /**
    * 27日前
    */
    DAYS_AGO_27: 28,
    /**
    * 28日前
    */
    DAYS_AGO_28: 29,
    /**
    * 29日前
    */
    DAYS_AGO_29: 30,
    /**
    * 30日前
    */
    DAYS_AGO_30: 31
} as const;

export type ServiceScheduleChangeSettings = typeof ServiceScheduleChangeSettings[keyof typeof ServiceScheduleChangeSettings];


/**
 * ステータス(service.status)
 * @export
 * @enum {string}
 */

export const ServiceStatus = {
    /**
    * 非公開
    */
    UNPUBLISHED: 0,
    /**
    * 公開中
    */
    PUBLISHING: 1,
    /**
    * 終了
    */
    CLOSE: 2,
    /**
    * 下書き
    */
    DRAFT: 3
} as const;

export type ServiceStatus = typeof ServiceStatus[keyof typeof ServiceStatus];


/**
 * ServiceTermsPage
 * @export
 * @interface ServiceTermsPage
 */
export interface ServiceTermsPage {
    /**
     * サービスID(services.id)
     * @type {number}
     * @memberof ServiceTermsPage
     */
    'id'?: number;
    /**
     * 
     * @type {ServiceTermsPageTermJson}
     * @memberof ServiceTermsPage
     */
    'term_json'?: ServiceTermsPageTermJson;
}
/**
 * 
 * @export
 * @interface ServiceTermsPageTermJson
 */
export interface ServiceTermsPageTermJson {
    /**
     * RawDraftContentState
     * @type {object}
     * @memberof ServiceTermsPageTermJson
     */
    'content'?: object;
    /**
     * 
     * @type {object}
     * @memberof ServiceTermsPageTermJson
     */
    'textAreaStyle'?: object;
}
/**
 * タイプ(service.type)
 * @export
 * @enum {string}
 */

export const ServiceType = {
    /**
    * イベント・セミナー（有料）
    */
    EVENT_SEMINAR: 1,
    /**
    * カレンダー予約
    */
    CALENDAR_RESERVATION: 2,
    /**
    * サブスクサービス
    */
    SUBSCRIPTION_SERVICE: 3,
    /**
    * フォーム
    */
    FORM: 12,
    /**
    * アンケート
    */
    SURVEY: 13,
    /**
    * 資料請求
    */
    DOCUMENT_REQUEST: 14,
    /**
    * 問い合わせ
    */
    INQUIRY: 15,
    /**
    * メルマガ登録
    */
    EMAIL_NEWSLETTER: 16,
    /**
    * Top page
    */
    GENERAL_PURPOSE: 17
} as const;

export type ServiceType = typeof ServiceType[keyof typeof ServiceType];


/**
 * 残席数表示(service.view_seats_left) 
 * @export
 * @enum {string}
 */

export const ServiceViewSeatsLeft = {
    /**
    * 非表示
    */
    HIDE: 0,
    /**
    * 表示
    */
    SHOW: 1
} as const;

export type ServiceViewSeatsLeft = typeof ServiceViewSeatsLeft[keyof typeof ServiceViewSeatsLeft];


/**
 * 残席数表示(service.view_term_flag) 
 * @export
 * @enum {string}
 */

export const ServiceViewTermFlag = {
    /**
    * 非表示
    */
    HIDE: 0,
    /**
    * 表示
    */
    SHOW: 1
} as const;

export type ServiceViewTermFlag = typeof ServiceViewTermFlag[keyof typeof ServiceViewTermFlag];


/**
 * 表示形式(service.view_type)
 * @export
 * @enum {string}
 */

export const ServiceViewType = {
    /**
    * ボタン
    */
    BUTTON: 1,
    /**
    * フォーム
    */
    FORM: 0
} as const;

export type ServiceViewType = typeof ServiceViewType[keyof typeof ServiceViewType];


/**
 * キャンセル待ち設定(services.waiting_list_settings)
 * @export
 * @enum {string}
 */

export const ServiceWaitingListSettings = {
    /**
    * 受け付けない
    */
    NUMBER_0: 0,
    /**
    * 受け付ける
    */
    NUMBER_1: 1
} as const;

export type ServiceWaitingListSettings = typeof ServiceWaitingListSettings[keyof typeof ServiceWaitingListSettings];


/**
 * サービスコンテンツタイプ(services_contents.type)
 * @export
 * @enum {string}
 */

export const ServicesContentsType = {
    /**
    * URL
    */
    NUMBER_0: 0,
    /**
    * file
    */
    NUMBER_1: 1
} as const;

export type ServicesContentsType = typeof ServicesContentsType[keyof typeof ServicesContentsType];


/**
 * Simpleページテンプレート取得
 * @export
 * @interface SimplePage
 */
export interface SimplePage {
    /**
     * サービスID(services.id)
     * @type {number}
     * @memberof SimplePage
     */
    'service_id'?: number;
    /**
     * サービス名(services.name)
     * @type {string}
     * @memberof SimplePage
     */
    'service_name'?: string;
    /**
     * サービスが紐づいたテンプレートブロックID
     * @type {string}
     * @memberof SimplePage
     */
    'service_templatepart_id'?: string;
    /**
     * フォーム情報のUUID(pages.uuid)
     * @type {string}
     * @memberof SimplePage
     */
    'form_uuid': string;
    /**
     * 
     * @type {PageEditorContent}
     * @memberof SimplePage
     */
    'page_editor_content': PageEditorContent;
    /**
     * 
     * @type {PageOgp}
     * @memberof SimplePage
     */
    'page_ogp': PageOgp;
    /**
     * 
     * @type {UserPlan}
     * @memberof SimplePage
     */
    'plan'?: UserPlan;
}
/**
 * 特定商取引法情報
 * @export
 * @interface SpecialCommercialLaw
 */
export interface SpecialCommercialLaw {
    /**
     * 事業者名(user_special_commercial_law.business_name)
     * @type {string}
     * @memberof SpecialCommercialLaw
     */
    'business_name': string;
    /**
     * 代表者名(user_special_commercial_law.representatives_name)
     * @type {string}
     * @memberof SpecialCommercialLaw
     */
    'representatives_name'?: string;
    /**
     * 都道府県ID (user_special_commercial_law.pref_master_id) 
     * @type {number}
     * @memberof SpecialCommercialLaw
     */
    'pref_master_id': number;
    /**
     * 郵便番号(user_special_commercial_law.zip)
     * @type {string}
     * @memberof SpecialCommercialLaw
     */
    'zip': string;
    /**
     * 住所(user_special_commercial_law.address)
     * @type {string}
     * @memberof SpecialCommercialLaw
     */
    'address': string;
    /**
     * 電話番号(user_special_commercial_law.tel)
     * @type {string}
     * @memberof SpecialCommercialLaw
     */
    'tel': string;
    /**
     * Email(user_special_commercial_law.email)
     * @type {string}
     * @memberof SpecialCommercialLaw
     */
    'email': string;
    /**
     * 住所・電話番号非公開設定(user_special_commercial_law.hide_address_tel)
     * @type {boolean}
     * @memberof SpecialCommercialLaw
     */
    'hide_address_tel'?: boolean;
    /**
     * 開示請求の受付先URL(user_special_commercial_law.disclosure_request_url)
     * @type {string}
     * @memberof SpecialCommercialLaw
     */
    'disclosure_request_url'?: string | null;
    /**
     * 商品代金以外の必要料金(user_special_commercial_law.necessary_fee)
     * @type {string}
     * @memberof SpecialCommercialLaw
     */
    'necessary_fee'?: string;
    /**
     * インボイス番号(user_special_commercial_law.invoice_number)
     * @type {string}
     * @memberof SpecialCommercialLaw
     */
    'invoice_number'?: string;
    /**
     * 営業時間(user_special_commercial_law.business_hours)
     * @type {string}
     * @memberof SpecialCommercialLaw
     */
    'business_hours': string;
    /**
     * 商品の引渡し時期(user_special_commercial_law.delivery_time)
     * @type {string}
     * @memberof SpecialCommercialLaw
     */
    'delivery_time': string;
    /**
     * キャンセルについて(user_special_commercial_law.cancellation)
     * @type {string}
     * @memberof SpecialCommercialLaw
     */
    'cancellation': string;
    /**
     * 動作環境(user_special_commercial_law.system_requirements)
     * @type {string}
     * @memberof SpecialCommercialLaw
     */
    'system_requirements'?: string;
    /**
     * その他(user_special_commercial_law.others)
     * @type {string}
     * @memberof SpecialCommercialLaw
     */
    'others'?: string;
    /**
     * 改訂日時(user_special_commercial_law.updated_at)
     * @type {string}
     * @memberof SpecialCommercialLaw
     */
    'updated_at': string;
}
/**
 * サブスクサービス項目<作成専用>
 * @export
 * @interface SubscriptionElement
 */
export interface SubscriptionElement {
    /**
     * 
     * @type {ServiceStatus}
     * @memberof SubscriptionElement
     */
    'status': ServiceStatus;
    /**
     * 
     * @type {CapacityStatus}
     * @memberof SubscriptionElement
     */
    'capacity_status': CapacityStatus;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionElement
     */
    'maximum_capacity'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionElement
     */
    'remaining_capacity': number;
    /**
     * 
     * @type {ServiceType}
     * @memberof SubscriptionElement
     */
    'type': ServiceType;
    /**
     * サービス名(services.name)
     * @type {string}
     * @memberof SubscriptionElement
     */
    'service_name': string;
    /**
     * サービス説明(services.description)
     * @type {string}
     * @memberof SubscriptionElement
     */
    'description'?: string;
    /**
     * 
     * @type {ServiceReserveStatus}
     * @memberof SubscriptionElement
     */
    'reserve_status': ServiceReserveStatus;
    /**
     * 
     * @type {ServiceReservationPeriodFlag}
     * @memberof SubscriptionElement
     */
    'reservation_period_flag': ServiceReservationPeriodFlag;
    /**
     * 予約受付公開開始日時
     * @type {string}
     * @memberof SubscriptionElement
     */
    'reservation_period_start_time'?: string;
    /**
     * 予約受付公開終了日時
     * @type {string}
     * @memberof SubscriptionElement
     */
    'reservation_period_end_time'?: string;
    /**
     * 
     * @type {ServiceReservationSpecifiedPeriodFlag}
     * @memberof SubscriptionElement
     */
    'reservation_specified_period_flag': ServiceReservationSpecifiedPeriodFlag;
    /**
     * 支払い周期
     * @type {number}
     * @memberof SubscriptionElement
     */
    'payment_cycle': number;
    /**
     * 
     * @type {Array<ServicePaymentMethodDto>}
     * @memberof SubscriptionElement
     */
    'paymentmethod'?: Array<ServicePaymentMethodDto>;
    /**
     * 
     * @type {ServiceViewSeatsLeft}
     * @memberof SubscriptionElement
     */
    'view_seats_left': ServiceViewSeatsLeft;
    /**
     * 
     * @type {ServiceViewTermFlag}
     * @memberof SubscriptionElement
     */
    'view_term_flag': ServiceViewTermFlag;
    /**
     * 
     * @type {ServiceViewType}
     * @memberof SubscriptionElement
     */
    'view_type': ServiceViewType;
    /**
     * 問い合わせ先_名前(services.contact_name)
     * @type {string}
     * @memberof SubscriptionElement
     */
    'contact_name': string;
    /**
     * 問い合わせ先_メールアドレス(services.contact_mail)
     * @type {string}
     * @memberof SubscriptionElement
     */
    'contact_mail': string;
    /**
     * 問い合わせ先_電話番号(services.contact_tel)
     * @type {string}
     * @memberof SubscriptionElement
     */
    'contact_tel': string;
    /**
     * 
     * @type {Array<SubscriptionMenu>}
     * @memberof SubscriptionElement
     */
    'service_menus': Array<SubscriptionMenu>;
    /**
     * フォーム情報（複数）
     * @type {Array<Form>}
     * @memberof SubscriptionElement
     */
    'forms': Array<Form>;
    /**
     * 
     * @type {UserPlan}
     * @memberof SubscriptionElement
     */
    'plan': UserPlan;
    /**
     * 
     * @type {UserSpecialCommercialLaw}
     * @memberof SubscriptionElement
     */
    'special_commercial_law': UserSpecialCommercialLaw;
    /**
     * ga tracking id
     * @type {string}
     * @memberof SubscriptionElement
     */
    'ga_tag'?: string;
    /**
     * ga cross domain
     * @type {Array<string>}
     * @memberof SubscriptionElement
     */
    'ga_cross_domain_tag'?: Array<string>;
    /**
     * gtm id
     * @type {string}
     * @memberof SubscriptionElement
     */
    'gtm_id'?: string;
}
/**
 * サブスクメニュー項目<作成専用>
 * @export
 * @interface SubscriptionMenu
 */
export interface SubscriptionMenu {
    /**
     * サービス詳細ID(service_details.id)
     * @type {number}
     * @memberof SubscriptionMenu
     */
    'id'?: number;
    /**
     * メニュー名
     * @type {string}
     * @memberof SubscriptionMenu
     */
    'menu_name'?: string;
    /**
     * 価格
     * @type {number}
     * @memberof SubscriptionMenu
     */
    'price': number;
    /**
     * 最大契約数フラグ
     * @type {number}
     * @memberof SubscriptionMenu
     */
    'maximum_number_flag': number;
    /**
     * 最大契約数
     * @type {number}
     * @memberof SubscriptionMenu
     */
    'maximum_number'?: number;
    /**
     * トライアル期間フラグ
     * @type {number}
     * @memberof SubscriptionMenu
     */
    'trial_period_flag': number;
    /**
     * トライアル期間(日数)
     * @type {number}
     * @memberof SubscriptionMenu
     */
    'trial_period_days'?: number;
    /**
     * 契約期間フラグ
     * @type {number}
     * @memberof SubscriptionMenu
     */
    'contract_period_flag': number;
    /**
     * 契約期間(月数)
     * @type {number}
     * @memberof SubscriptionMenu
     */
    'contract_period_months'?: number;
    /**
     * 残予約数 (定員 - 予約数)
     * @type {number}
     * @memberof SubscriptionMenu
     */
    'remaining_reservation_count'?: number | null;
    /**
     * メニュー説明
     * @type {string}
     * @memberof SubscriptionMenu
     */
    'description'?: string;
}
/**
 * サービス情報(コンテンツ・ウェビナー)
 * @export
 * @interface SurveyElement
 */
export interface SurveyElement {
    /**
     * 
     * @type {ServiceStatus}
     * @memberof SurveyElement
     */
    'status': ServiceStatus;
    /**
     * 
     * @type {ServiceType}
     * @memberof SurveyElement
     */
    'type': ServiceType;
    /**
     * サービス名(services.name)
     * @type {string}
     * @memberof SurveyElement
     */
    'service_name': string;
    /**
     * 
     * @type {ServiceReservationPeriodFlag}
     * @memberof SurveyElement
     */
    'reservation_period_flag': ServiceReservationPeriodFlag;
    /**
     * 予約受付公開開始日時
     * @type {string}
     * @memberof SurveyElement
     */
    'reservation_period_start_time'?: string;
    /**
     * 予約受付公開終了日時
     * @type {string}
     * @memberof SurveyElement
     */
    'reservation_period_end_time'?: string;
    /**
     * 
     * @type {ServiceReservationSpecifiedPeriodFlag}
     * @memberof SurveyElement
     */
    'reservation_specified_period_flag': ServiceReservationSpecifiedPeriodFlag;
    /**
     * 
     * @type {ServicePaidFlag}
     * @memberof SurveyElement
     */
    'paid_flag': ServicePaidFlag;
    /**
     * 
     * @type {ServiceViewType}
     * @memberof SurveyElement
     */
    'view_type': ServiceViewType;
    /**
     * 
     * @type {ServicePageViewTerm}
     * @memberof SurveyElement
     */
    'page_view_term': ServicePageViewTerm;
    /**
     * 
     * @type {ServiceViewTermFlag}
     * @memberof SurveyElement
     */
    'view_term_flag': ServiceViewTermFlag;
    /**
     * ページ表示開始日時(services.page_view_start_date,page_view_start_hour,page_view_start_minute)
     * @type {string}
     * @memberof SurveyElement
     */
    'page_view_start_time'?: string;
    /**
     * ページ表示終了日時(services.page_view_end_date,page_view_end_hour,page_view_end_minute)
     * @type {string}
     * @memberof SurveyElement
     */
    'page_view_end_time'?: string;
    /**
     * フォーム情報（複数）
     * @type {Array<Form>}
     * @memberof SurveyElement
     */
    'forms': Array<Form>;
    /**
     * 
     * @type {UserPlan}
     * @memberof SurveyElement
     */
    'plan': UserPlan;
    /**
     * 
     * @type {UserSpecialCommercialLaw}
     * @memberof SurveyElement
     */
    'special_commercial_law': UserSpecialCommercialLaw;
    /**
     * ga tracking id
     * @type {string}
     * @memberof SurveyElement
     */
    'ga_tag'?: string;
    /**
     * ga cross domain
     * @type {Array<string>}
     * @memberof SurveyElement
     */
    'ga_cross_domain_tag'?: Array<string>;
    /**
     * gtm id
     * @type {string}
     * @memberof SurveyElement
     */
    'gtm_id'?: string;
}
/**
 * サンクスページ情報取得
 * @export
 * @interface ThanksPage
 */
export interface ThanksPage {
    /**
     * サービスID(services.id)
     * @type {number}
     * @memberof ThanksPage
     */
    'service_id': number;
    /**
     * 
     * @type {ThanksPageEditorContent}
     * @memberof ThanksPage
     */
    'page_editor_content': ThanksPageEditorContent;
    /**
     * 
     * @type {UserPlan}
     * @memberof ThanksPage
     */
    'plan'?: UserPlan;
    /**
     * GAトラッキングID
     * @type {string}
     * @memberof ThanksPage
     */
    'ga_tag': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ThanksPage
     */
    'ga_cross_domain_tag': Array<string>;
    /**
     * GTM コンテナID
     * @type {string}
     * @memberof ThanksPage
     */
    'gtm_id': string | null;
}
/**
 * サンクスページのJSON表現
 * @export
 * @interface ThanksPageEditorContent
 */
export interface ThanksPageEditorContent {
    /**
     * メイン画像のUUID
     * @type {string}
     * @memberof ThanksPageEditorContent
     */
    'image_uuid'?: string;
    /**
     * メイン画像のS3のパス
     * @type {string}
     * @memberof ThanksPageEditorContent
     */
    'src'?: string;
    /**
     * 
     * @type {object}
     * @memberof ThanksPageEditorContent
     */
    'draftContentState': object;
}
/**
 * 
 * @export
 * @interface UnsubcribeEmailRequest
 */
export interface UnsubcribeEmailRequest {
    /**
     * sample@gmail.com
     * @type {string}
     * @memberof UnsubcribeEmailRequest
     */
    'email'?: string;
}
/**
 * ユーザー業種マスタ情報
 * @export
 * @interface UserIndustryMaster
 */
export interface UserIndustryMaster {
    /**
     * user_industry_maste.id
     * @type {number}
     * @memberof UserIndustryMaster
     */
    'id': number;
    /**
     * user_industry_maste.industry_name
     * @type {string}
     * @memberof UserIndustryMaster
     */
    'industry_name': string;
}
/**
 * 属性(条件判定)
 * @export
 * @enum {string}
 */

export const UserPlan = {
    /**
    * 無料
    */
    FREE: 0,
    /**
    * お試しプラン
    */
    FREE_TRIAL: 1,
    /**
    * ライト
    */
    LITE_PLAN: 2,
    /**
    * スタンダード
    */
    STANDARD: 3,
    /**
    * ビジネス
    */
    BUSINESS_PLAN: 4
} as const;

export type UserPlan = typeof UserPlan[keyof typeof UserPlan];


/**
 * User Plan Config
 * @export
 * @interface UserPlanConfig
 */
export interface UserPlanConfig {
    /**
     * 広告
     * @type {boolean}
     * @memberof UserPlanConfig
     */
    'advertisement'?: boolean;
}
/**
 * 属性(条件判定)
 * @export
 * @enum {string}
 */

export const UserSpecialCommercialLaw = {
    /**
    * 無効
    */
    INVALID: 0,
    /**
    * 有効
    */
    VALID: 1
} as const;

export type UserSpecialCommercialLaw = typeof UserSpecialCommercialLaw[keyof typeof UserSpecialCommercialLaw];


/**
 * APIから返されるバリデーションエラーのレスポンスボディ
 * @export
 * @interface ValidationErrorResponseBody
 */
export interface ValidationErrorResponseBody {
    /**
     * 
     * @type {string}
     * @memberof ValidationErrorResponseBody
     */
    'message': string;
    /**
     * エラー内容。キーに対してエラー文言の文字列を配列で持ちます
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ValidationErrorResponseBody
     */
    'errors': { [key: string]: Array<string>; };
}

/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 認証情報の取得
         * @summary 認証情報取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary パスワード忘れ
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postForgotPassword: async (email?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/forgot-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (email !== undefined) { 
                localVarFormParams.set('email', email as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostLoginRequest} postLoginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLogin: async (postLoginRequest: PostLoginRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postLoginRequest' is not null or undefined
            assertParamExists('postLogin', 'postLoginRequest', postLoginRequest)
            const localVarPath = `/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ログインセッションを削除する
         * @summary ログインセッション削除
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLogout: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary パスワードリセット
         * @param {PostResetPasswordRequest} postResetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResetPassword: async (postResetPasswordRequest: PostResetPasswordRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postResetPasswordRequest' is not null or undefined
            assertParamExists('postResetPassword', 'postResetPasswordRequest', postResetPasswordRequest)
            const localVarPath = `/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postResetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPost: async (email?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (email !== undefined) { 
                localVarFormParams.set('email', email as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} verify verify token
         * @param {string} [email] 
         * @param {string} [password] 
         * @param {string} [lastName] 
         * @param {string} [firstName] 
         * @param {string} [lastNameKana] 
         * @param {string} [firstNameKana] 
         * @param {string} [tel] 
         * @param {string} [zip] 
         * @param {number} [prefMasterId] 
         * @param {string} [address1] 
         * @param {string} [address2] 
         * @param {number} [birthdayYear] 
         * @param {number} [birthdayMonth] 
         * @param {number} [birthdayDay] 
         * @param {number} [gender] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerVerifyTokenPost: async (verify: string, email?: string, password?: string, lastName?: string, firstName?: string, lastNameKana?: string, firstNameKana?: string, tel?: string, zip?: string, prefMasterId?: number, address1?: string, address2?: string, birthdayYear?: number, birthdayMonth?: number, birthdayDay?: number, gender?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verify' is not null or undefined
            assertParamExists('registerVerifyTokenPost', 'verify', verify)
            const localVarPath = `/register/verify/{token}`
                .replace(`{${"verify"}}`, encodeURIComponent(String(verify)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (email !== undefined) { 
                localVarFormParams.set('email', email as any);
            }
    
            if (password !== undefined) { 
                localVarFormParams.set('password', password as any);
            }
    
            if (lastName !== undefined) { 
                localVarFormParams.set('last_name', lastName as any);
            }
    
            if (firstName !== undefined) { 
                localVarFormParams.set('first_name', firstName as any);
            }
    
            if (lastNameKana !== undefined) { 
                localVarFormParams.set('last_name_kana', lastNameKana as any);
            }
    
            if (firstNameKana !== undefined) { 
                localVarFormParams.set('first_name_kana', firstNameKana as any);
            }
    
            if (tel !== undefined) { 
                localVarFormParams.set('tel', tel as any);
            }
    
            if (zip !== undefined) { 
                localVarFormParams.set('zip', zip as any);
            }
    
            if (prefMasterId !== undefined) { 
                localVarFormParams.set('pref_master_id', prefMasterId as any);
            }
    
            if (address1 !== undefined) { 
                localVarFormParams.set('address1', address1 as any);
            }
    
            if (address2 !== undefined) { 
                localVarFormParams.set('address2', address2 as any);
            }
    
            if (birthdayYear !== undefined) { 
                localVarFormParams.set('birthday_year', birthdayYear as any);
            }
    
            if (birthdayMonth !== undefined) { 
                localVarFormParams.set('birthday_month', birthdayMonth as any);
            }
    
            if (birthdayDay !== undefined) { 
                localVarFormParams.set('birthday_day', birthdayDay as any);
            }
    
            if (gender !== undefined) { 
                localVarFormParams.set('gender', gender as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 認証情報の取得
         * @summary 認証情報取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary パスワード忘れ
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postForgotPassword(email?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postForgotPassword(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostLoginRequest} postLoginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postLogin(postLoginRequest: PostLoginRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostLogin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postLogin(postLoginRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ログインセッションを削除する
         * @summary ログインセッション削除
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postLogout(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postLogout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary パスワードリセット
         * @param {PostResetPasswordRequest} postResetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postResetPassword(postResetPasswordRequest: PostResetPasswordRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postResetPassword(postResetPasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerPost(email?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerPost(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} verify verify token
         * @param {string} [email] 
         * @param {string} [password] 
         * @param {string} [lastName] 
         * @param {string} [firstName] 
         * @param {string} [lastNameKana] 
         * @param {string} [firstNameKana] 
         * @param {string} [tel] 
         * @param {string} [zip] 
         * @param {number} [prefMasterId] 
         * @param {string} [address1] 
         * @param {string} [address2] 
         * @param {number} [birthdayYear] 
         * @param {number} [birthdayMonth] 
         * @param {number} [birthdayDay] 
         * @param {number} [gender] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerVerifyTokenPost(verify: string, email?: string, password?: string, lastName?: string, firstName?: string, lastNameKana?: string, firstNameKana?: string, tel?: string, zip?: string, prefMasterId?: number, address1?: string, address2?: string, birthdayYear?: number, birthdayMonth?: number, birthdayDay?: number, gender?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerVerifyTokenPost(verify, email, password, lastName, firstName, lastNameKana, firstNameKana, tel, zip, prefMasterId, address1, address2, birthdayYear, birthdayMonth, birthdayDay, gender, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 認証情報の取得
         * @summary 認証情報取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authGet(options?: any): AxiosPromise<AuthGet200Response> {
            return localVarFp.authGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary パスワード忘れ
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postForgotPassword(email?: string, options?: any): AxiosPromise<object> {
            return localVarFp.postForgotPassword(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostLoginRequest} postLoginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLogin(postLoginRequest: PostLoginRequest, options?: any): AxiosPromise<PostLogin200Response> {
            return localVarFp.postLogin(postLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ログインセッションを削除する
         * @summary ログインセッション削除
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLogout(options?: any): AxiosPromise<void> {
            return localVarFp.postLogout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary パスワードリセット
         * @param {PostResetPasswordRequest} postResetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResetPassword(postResetPasswordRequest: PostResetPasswordRequest, options?: any): AxiosPromise<object> {
            return localVarFp.postResetPassword(postResetPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPost(email?: string, options?: any): AxiosPromise<object> {
            return localVarFp.registerPost(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} verify verify token
         * @param {string} [email] 
         * @param {string} [password] 
         * @param {string} [lastName] 
         * @param {string} [firstName] 
         * @param {string} [lastNameKana] 
         * @param {string} [firstNameKana] 
         * @param {string} [tel] 
         * @param {string} [zip] 
         * @param {number} [prefMasterId] 
         * @param {string} [address1] 
         * @param {string} [address2] 
         * @param {number} [birthdayYear] 
         * @param {number} [birthdayMonth] 
         * @param {number} [birthdayDay] 
         * @param {number} [gender] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerVerifyTokenPost(verify: string, email?: string, password?: string, lastName?: string, firstName?: string, lastNameKana?: string, firstNameKana?: string, tel?: string, zip?: string, prefMasterId?: number, address1?: string, address2?: string, birthdayYear?: number, birthdayMonth?: number, birthdayDay?: number, gender?: number, options?: any): AxiosPromise<object> {
            return localVarFp.registerVerifyTokenPost(verify, email, password, lastName, firstName, lastNameKana, firstNameKana, tel, zip, prefMasterId, address1, address2, birthdayYear, birthdayMonth, birthdayDay, gender, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for postForgotPassword operation in AuthApi.
 * @export
 * @interface AuthApiPostForgotPasswordRequest
 */
export interface AuthApiPostForgotPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthApiPostForgotPassword
     */
    readonly email?: string
}

/**
 * Request parameters for postLogin operation in AuthApi.
 * @export
 * @interface AuthApiPostLoginRequest
 */
export interface AuthApiPostLoginRequest {
    /**
     * 
     * @type {PostLoginRequest}
     * @memberof AuthApiPostLogin
     */
    readonly postLoginRequest: PostLoginRequest
}

/**
 * Request parameters for postResetPassword operation in AuthApi.
 * @export
 * @interface AuthApiPostResetPasswordRequest
 */
export interface AuthApiPostResetPasswordRequest {
    /**
     * 
     * @type {PostResetPasswordRequest}
     * @memberof AuthApiPostResetPassword
     */
    readonly postResetPasswordRequest: PostResetPasswordRequest
}

/**
 * Request parameters for registerPost operation in AuthApi.
 * @export
 * @interface AuthApiRegisterPostRequest
 */
export interface AuthApiRegisterPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthApiRegisterPost
     */
    readonly email?: string
}

/**
 * Request parameters for registerVerifyTokenPost operation in AuthApi.
 * @export
 * @interface AuthApiRegisterVerifyTokenPostRequest
 */
export interface AuthApiRegisterVerifyTokenPostRequest {
    /**
     * verify token
     * @type {string}
     * @memberof AuthApiRegisterVerifyTokenPost
     */
    readonly verify: string

    /**
     * 
     * @type {string}
     * @memberof AuthApiRegisterVerifyTokenPost
     */
    readonly email?: string

    /**
     * 
     * @type {string}
     * @memberof AuthApiRegisterVerifyTokenPost
     */
    readonly password?: string

    /**
     * 
     * @type {string}
     * @memberof AuthApiRegisterVerifyTokenPost
     */
    readonly lastName?: string

    /**
     * 
     * @type {string}
     * @memberof AuthApiRegisterVerifyTokenPost
     */
    readonly firstName?: string

    /**
     * 
     * @type {string}
     * @memberof AuthApiRegisterVerifyTokenPost
     */
    readonly lastNameKana?: string

    /**
     * 
     * @type {string}
     * @memberof AuthApiRegisterVerifyTokenPost
     */
    readonly firstNameKana?: string

    /**
     * 
     * @type {string}
     * @memberof AuthApiRegisterVerifyTokenPost
     */
    readonly tel?: string

    /**
     * 
     * @type {string}
     * @memberof AuthApiRegisterVerifyTokenPost
     */
    readonly zip?: string

    /**
     * 
     * @type {number}
     * @memberof AuthApiRegisterVerifyTokenPost
     */
    readonly prefMasterId?: number

    /**
     * 
     * @type {string}
     * @memberof AuthApiRegisterVerifyTokenPost
     */
    readonly address1?: string

    /**
     * 
     * @type {string}
     * @memberof AuthApiRegisterVerifyTokenPost
     */
    readonly address2?: string

    /**
     * 
     * @type {number}
     * @memberof AuthApiRegisterVerifyTokenPost
     */
    readonly birthdayYear?: number

    /**
     * 
     * @type {number}
     * @memberof AuthApiRegisterVerifyTokenPost
     */
    readonly birthdayMonth?: number

    /**
     * 
     * @type {number}
     * @memberof AuthApiRegisterVerifyTokenPost
     */
    readonly birthdayDay?: number

    /**
     * 
     * @type {number}
     * @memberof AuthApiRegisterVerifyTokenPost
     */
    readonly gender?: number
}

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 認証情報の取得
     * @summary 認証情報取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authGet(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary パスワード忘れ
     * @param {AuthApiPostForgotPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public postForgotPassword(requestParameters: AuthApiPostForgotPasswordRequest = {}, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).postForgotPassword(requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiPostLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public postLogin(requestParameters: AuthApiPostLoginRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).postLogin(requestParameters.postLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ログインセッションを削除する
     * @summary ログインセッション削除
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public postLogout(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).postLogout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary パスワードリセット
     * @param {AuthApiPostResetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public postResetPassword(requestParameters: AuthApiPostResetPasswordRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).postResetPassword(requestParameters.postResetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiRegisterPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public registerPost(requestParameters: AuthApiRegisterPostRequest = {}, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).registerPost(requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AuthApiRegisterVerifyTokenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public registerVerifyTokenPost(requestParameters: AuthApiRegisterVerifyTokenPostRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).registerVerifyTokenPost(requestParameters.verify, requestParameters.email, requestParameters.password, requestParameters.lastName, requestParameters.firstName, requestParameters.lastNameKana, requestParameters.firstNameKana, requestParameters.tel, requestParameters.zip, requestParameters.prefMasterId, requestParameters.address1, requestParameters.address2, requestParameters.birthdayYear, requestParameters.birthdayMonth, requestParameters.birthdayDay, requestParameters.gender, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CommonApi - axios parameter creator
 * @export
 */
export const CommonApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * CSRFトークンを取得します
         * @summary CSRFトークン取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCsrfCookie: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/csrf-cookie`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommonApi - functional programming interface
 * @export
 */
export const CommonApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommonApiAxiosParamCreator(configuration)
    return {
        /**
         * CSRFトークンを取得します
         * @summary CSRFトークン取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCsrfCookie(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCsrfCookie(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CommonApi - factory interface
 * @export
 */
export const CommonApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommonApiFp(configuration)
    return {
        /**
         * CSRFトークンを取得します
         * @summary CSRFトークン取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCsrfCookie(options?: any): AxiosPromise<void> {
            return localVarFp.getCsrfCookie(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommonApi - object-oriented interface
 * @export
 * @class CommonApi
 * @extends {BaseAPI}
 */
export class CommonApi extends BaseAPI {
    /**
     * CSRFトークンを取得します
     * @summary CSRFトークン取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonApi
     */
    public getCsrfCookie(options?: AxiosRequestConfig) {
        return CommonApiFp(this.configuration).getCsrfCookie(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ContentAccessLogApi - axios parameter creator
 * @export
 */
export const ContentAccessLogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * LPページ閲覧時のアクセスログを記録する
         * @summary コンテンツアクセスログ作成
         * @param {string} pageUuid ページUUID（URLの/lp/[uuid]から取得）
         * @param {number} [serviceId] サービスID
         * @param {number} [customerId] 顧客ID（未認証時はnull）
         * @param {number} [orderId] 注文ID（任意）
         * @param {string} [orderUuid] 注文UUID（任意）
         * @param {string} [email] Email from localStorage customer_form（任意）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postContentAccessLog: async (pageUuid: string, serviceId?: number, customerId?: number, orderId?: number, orderUuid?: string, email?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageUuid' is not null or undefined
            assertParamExists('postContentAccessLog', 'pageUuid', pageUuid)
            const localVarPath = `/content-access-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (serviceId !== undefined) { 
                localVarFormParams.append('service_id', serviceId as any);
            }
    
            if (pageUuid !== undefined) { 
                localVarFormParams.append('page_uuid', pageUuid as any);
            }
    
            if (customerId !== undefined) { 
                localVarFormParams.append('customer_id', customerId as any);
            }
    
            if (orderId !== undefined) { 
                localVarFormParams.append('order_id', orderId as any);
            }
    
            if (orderUuid !== undefined) { 
                localVarFormParams.append('order_uuid', orderUuid as any);
            }
    
            if (email !== undefined) { 
                localVarFormParams.append('email', email as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContentAccessLogApi - functional programming interface
 * @export
 */
export const ContentAccessLogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContentAccessLogApiAxiosParamCreator(configuration)
    return {
        /**
         * LPページ閲覧時のアクセスログを記録する
         * @summary コンテンツアクセスログ作成
         * @param {string} pageUuid ページUUID（URLの/lp/[uuid]から取得）
         * @param {number} [serviceId] サービスID
         * @param {number} [customerId] 顧客ID（未認証時はnull）
         * @param {number} [orderId] 注文ID（任意）
         * @param {string} [orderUuid] 注文UUID（任意）
         * @param {string} [email] Email from localStorage customer_form（任意）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postContentAccessLog(pageUuid: string, serviceId?: number, customerId?: number, orderId?: number, orderUuid?: string, email?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postContentAccessLog(pageUuid, serviceId, customerId, orderId, orderUuid, email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContentAccessLogApi - factory interface
 * @export
 */
export const ContentAccessLogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContentAccessLogApiFp(configuration)
    return {
        /**
         * LPページ閲覧時のアクセスログを記録する
         * @summary コンテンツアクセスログ作成
         * @param {string} pageUuid ページUUID（URLの/lp/[uuid]から取得）
         * @param {number} [serviceId] サービスID
         * @param {number} [customerId] 顧客ID（未認証時はnull）
         * @param {number} [orderId] 注文ID（任意）
         * @param {string} [orderUuid] 注文UUID（任意）
         * @param {string} [email] Email from localStorage customer_form（任意）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postContentAccessLog(pageUuid: string, serviceId?: number, customerId?: number, orderId?: number, orderUuid?: string, email?: string, options?: any): AxiosPromise<void> {
            return localVarFp.postContentAccessLog(pageUuid, serviceId, customerId, orderId, orderUuid, email, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for postContentAccessLog operation in ContentAccessLogApi.
 * @export
 * @interface ContentAccessLogApiPostContentAccessLogRequest
 */
export interface ContentAccessLogApiPostContentAccessLogRequest {
    /**
     * ページUUID（URLの/lp/[uuid]から取得）
     * @type {string}
     * @memberof ContentAccessLogApiPostContentAccessLog
     */
    readonly pageUuid: string

    /**
     * サービスID
     * @type {number}
     * @memberof ContentAccessLogApiPostContentAccessLog
     */
    readonly serviceId?: number

    /**
     * 顧客ID（未認証時はnull）
     * @type {number}
     * @memberof ContentAccessLogApiPostContentAccessLog
     */
    readonly customerId?: number

    /**
     * 注文ID（任意）
     * @type {number}
     * @memberof ContentAccessLogApiPostContentAccessLog
     */
    readonly orderId?: number

    /**
     * 注文UUID（任意）
     * @type {string}
     * @memberof ContentAccessLogApiPostContentAccessLog
     */
    readonly orderUuid?: string

    /**
     * Email from localStorage customer_form（任意）
     * @type {string}
     * @memberof ContentAccessLogApiPostContentAccessLog
     */
    readonly email?: string
}

/**
 * ContentAccessLogApi - object-oriented interface
 * @export
 * @class ContentAccessLogApi
 * @extends {BaseAPI}
 */
export class ContentAccessLogApi extends BaseAPI {
    /**
     * LPページ閲覧時のアクセスログを記録する
     * @summary コンテンツアクセスログ作成
     * @param {ContentAccessLogApiPostContentAccessLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentAccessLogApi
     */
    public postContentAccessLog(requestParameters: ContentAccessLogApiPostContentAccessLogRequest, options?: AxiosRequestConfig) {
        return ContentAccessLogApiFp(this.configuration).postContentAccessLog(requestParameters.pageUuid, requestParameters.serviceId, requestParameters.customerId, requestParameters.orderId, requestParameters.orderUuid, requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CouponApi - axios parameter creator
 * @export
 */
export const CouponApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary クーポン入力欄表示可否
         * @param {CouponAvailabilityRequest} couponAvailabilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCouponAvailability: async (couponAvailabilityRequest: CouponAvailabilityRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'couponAvailabilityRequest' is not null or undefined
            assertParamExists('postCouponAvailability', 'couponAvailabilityRequest', couponAvailabilityRequest)
            const localVarPath = `/coupons/availability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(couponAvailabilityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary クーポン検証
         * @param {CouponValidateRequest} couponValidateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCouponValidate: async (couponValidateRequest: CouponValidateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'couponValidateRequest' is not null or undefined
            assertParamExists('postCouponValidate', 'couponValidateRequest', couponValidateRequest)
            const localVarPath = `/coupons/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(couponValidateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CouponApi - functional programming interface
 * @export
 */
export const CouponApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CouponApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary クーポン入力欄表示可否
         * @param {CouponAvailabilityRequest} couponAvailabilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCouponAvailability(couponAvailabilityRequest: CouponAvailabilityRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponAvailabilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCouponAvailability(couponAvailabilityRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary クーポン検証
         * @param {CouponValidateRequest} couponValidateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCouponValidate(couponValidateRequest: CouponValidateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CouponValidateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCouponValidate(couponValidateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CouponApi - factory interface
 * @export
 */
export const CouponApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CouponApiFp(configuration)
    return {
        /**
         * 
         * @summary クーポン入力欄表示可否
         * @param {CouponAvailabilityRequest} couponAvailabilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCouponAvailability(couponAvailabilityRequest: CouponAvailabilityRequest, options?: any): AxiosPromise<CouponAvailabilityResponse> {
            return localVarFp.postCouponAvailability(couponAvailabilityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary クーポン検証
         * @param {CouponValidateRequest} couponValidateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCouponValidate(couponValidateRequest: CouponValidateRequest, options?: any): AxiosPromise<CouponValidateResponse> {
            return localVarFp.postCouponValidate(couponValidateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for postCouponAvailability operation in CouponApi.
 * @export
 * @interface CouponApiPostCouponAvailabilityRequest
 */
export interface CouponApiPostCouponAvailabilityRequest {
    /**
     * 
     * @type {CouponAvailabilityRequest}
     * @memberof CouponApiPostCouponAvailability
     */
    readonly couponAvailabilityRequest: CouponAvailabilityRequest
}

/**
 * Request parameters for postCouponValidate operation in CouponApi.
 * @export
 * @interface CouponApiPostCouponValidateRequest
 */
export interface CouponApiPostCouponValidateRequest {
    /**
     * 
     * @type {CouponValidateRequest}
     * @memberof CouponApiPostCouponValidate
     */
    readonly couponValidateRequest: CouponValidateRequest
}

/**
 * CouponApi - object-oriented interface
 * @export
 * @class CouponApi
 * @extends {BaseAPI}
 */
export class CouponApi extends BaseAPI {
    /**
     * 
     * @summary クーポン入力欄表示可否
     * @param {CouponApiPostCouponAvailabilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponApi
     */
    public postCouponAvailability(requestParameters: CouponApiPostCouponAvailabilityRequest, options?: AxiosRequestConfig) {
        return CouponApiFp(this.configuration).postCouponAvailability(requestParameters.couponAvailabilityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary クーポン検証
     * @param {CouponApiPostCouponValidateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponApi
     */
    public postCouponValidate(requestParameters: CouponApiPostCouponValidateRequest, options?: AxiosRequestConfig) {
        return CouponApiFp(this.configuration).postCouponValidate(requestParameters.couponValidateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustomerIndustryMasterApi - axios parameter creator
 * @export
 */
export const CustomerIndustryMasterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 顧客業種マスタ一覧の取得API
         * @summary 顧客業種マスタ一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerIndustries: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer-industry-master`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerIndustryMasterApi - functional programming interface
 * @export
 */
export const CustomerIndustryMasterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerIndustryMasterApiAxiosParamCreator(configuration)
    return {
        /**
         * 顧客業種マスタ一覧の取得API
         * @summary 顧客業種マスタ一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerIndustries(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomerIndustries200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerIndustries(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomerIndustryMasterApi - factory interface
 * @export
 */
export const CustomerIndustryMasterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerIndustryMasterApiFp(configuration)
    return {
        /**
         * 顧客業種マスタ一覧の取得API
         * @summary 顧客業種マスタ一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerIndustries(options?: any): AxiosPromise<GetCustomerIndustries200Response> {
            return localVarFp.getCustomerIndustries(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerIndustryMasterApi - object-oriented interface
 * @export
 * @class CustomerIndustryMasterApi
 * @extends {BaseAPI}
 */
export class CustomerIndustryMasterApi extends BaseAPI {
    /**
     * 顧客業種マスタ一覧の取得API
     * @summary 顧客業種マスタ一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerIndustryMasterApi
     */
    public getCustomerIndustries(options?: AxiosRequestConfig) {
        return CustomerIndustryMasterApiFp(this.configuration).getCustomerIndustries(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FileApi - axios parameter creator
 * @export
 */
export const FileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * S3の署名付きURLを取得する。URLからダウンロードされる資料はサービス資料をまとめてzipにしたもの
         * @summary 資料ダウンロードURL取得
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileDownload: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getFileDownload', 'uuid', uuid)
            const localVarPath = `/download/file/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 画像をS3へアップロードする
         * @summary ページに関する画像をアップロード
         * @param {PostUploadFileRequest} [postUploadFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUploadFile: async (postUploadFileRequest?: PostUploadFileRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/upload/file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postUploadFileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileApi - functional programming interface
 * @export
 */
export const FileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FileApiAxiosParamCreator(configuration)
    return {
        /**
         * S3の署名付きURLを取得する。URLからダウンロードされる資料はサービス資料をまとめてzipにしたもの
         * @summary 資料ダウンロードURL取得
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileDownload(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFileDownload200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileDownload(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 画像をS3へアップロードする
         * @summary ページに関する画像をアップロード
         * @param {PostUploadFileRequest} [postUploadFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUploadFile(postUploadFileRequest?: PostUploadFileRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostUploadFile200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUploadFile(postUploadFileRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FileApi - factory interface
 * @export
 */
export const FileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FileApiFp(configuration)
    return {
        /**
         * S3の署名付きURLを取得する。URLからダウンロードされる資料はサービス資料をまとめてzipにしたもの
         * @summary 資料ダウンロードURL取得
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileDownload(uuid: string, options?: any): AxiosPromise<GetFileDownload200Response> {
            return localVarFp.getFileDownload(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 画像をS3へアップロードする
         * @summary ページに関する画像をアップロード
         * @param {PostUploadFileRequest} [postUploadFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUploadFile(postUploadFileRequest?: PostUploadFileRequest, options?: any): AxiosPromise<PostUploadFile200Response> {
            return localVarFp.postUploadFile(postUploadFileRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getFileDownload operation in FileApi.
 * @export
 * @interface FileApiGetFileDownloadRequest
 */
export interface FileApiGetFileDownloadRequest {
    /**
     * 注文ユニークID(orders.uuid)
     * @type {string}
     * @memberof FileApiGetFileDownload
     */
    readonly uuid: string
}

/**
 * Request parameters for postUploadFile operation in FileApi.
 * @export
 * @interface FileApiPostUploadFileRequest
 */
export interface FileApiPostUploadFileRequest {
    /**
     * 
     * @type {PostUploadFileRequest}
     * @memberof FileApiPostUploadFile
     */
    readonly postUploadFileRequest?: PostUploadFileRequest
}

/**
 * FileApi - object-oriented interface
 * @export
 * @class FileApi
 * @extends {BaseAPI}
 */
export class FileApi extends BaseAPI {
    /**
     * S3の署名付きURLを取得する。URLからダウンロードされる資料はサービス資料をまとめてzipにしたもの
     * @summary 資料ダウンロードURL取得
     * @param {FileApiGetFileDownloadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public getFileDownload(requestParameters: FileApiGetFileDownloadRequest, options?: AxiosRequestConfig) {
        return FileApiFp(this.configuration).getFileDownload(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 画像をS3へアップロードする
     * @summary ページに関する画像をアップロード
     * @param {FileApiPostUploadFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public postUploadFile(requestParameters: FileApiPostUploadFileRequest = {}, options?: AxiosRequestConfig) {
        return FileApiFp(this.configuration).postUploadFile(requestParameters.postUploadFileRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MailsApi - axios parameter creator
 * @export
 */
export const MailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * getUserName
         * @summary getUserName
         * @param {string} userId supplier\&#39;s id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserName: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserName', 'userId', userId)
            const localVarPath = `/mails/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * unsubcribeEmail
         * @summary unsubcribeEmail
         * @param {string} userId supplier\&#39;s id
         * @param {UnsubcribeEmailRequest} [unsubcribeEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubcribeEmail: async (userId: string, unsubcribeEmailRequest?: UnsubcribeEmailRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('unsubcribeEmail', 'userId', userId)
            const localVarPath = `/mails/{user_id}/unsubcribe`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unsubcribeEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MailsApi - functional programming interface
 * @export
 */
export const MailsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MailsApiAxiosParamCreator(configuration)
    return {
        /**
         * getUserName
         * @summary getUserName
         * @param {string} userId supplier\&#39;s id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserName(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserName200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserName(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * unsubcribeEmail
         * @summary unsubcribeEmail
         * @param {string} userId supplier\&#39;s id
         * @param {UnsubcribeEmailRequest} [unsubcribeEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unsubcribeEmail(userId: string, unsubcribeEmailRequest?: UnsubcribeEmailRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unsubcribeEmail(userId, unsubcribeEmailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MailsApi - factory interface
 * @export
 */
export const MailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MailsApiFp(configuration)
    return {
        /**
         * getUserName
         * @summary getUserName
         * @param {string} userId supplier\&#39;s id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserName(userId: string, options?: any): AxiosPromise<GetUserName200Response> {
            return localVarFp.getUserName(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * unsubcribeEmail
         * @summary unsubcribeEmail
         * @param {string} userId supplier\&#39;s id
         * @param {UnsubcribeEmailRequest} [unsubcribeEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubcribeEmail(userId: string, unsubcribeEmailRequest?: UnsubcribeEmailRequest, options?: any): AxiosPromise<void> {
            return localVarFp.unsubcribeEmail(userId, unsubcribeEmailRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getUserName operation in MailsApi.
 * @export
 * @interface MailsApiGetUserNameRequest
 */
export interface MailsApiGetUserNameRequest {
    /**
     * supplier\&#39;s id
     * @type {string}
     * @memberof MailsApiGetUserName
     */
    readonly userId: string
}

/**
 * Request parameters for unsubcribeEmail operation in MailsApi.
 * @export
 * @interface MailsApiUnsubcribeEmailRequest
 */
export interface MailsApiUnsubcribeEmailRequest {
    /**
     * supplier\&#39;s id
     * @type {string}
     * @memberof MailsApiUnsubcribeEmail
     */
    readonly userId: string

    /**
     * 
     * @type {UnsubcribeEmailRequest}
     * @memberof MailsApiUnsubcribeEmail
     */
    readonly unsubcribeEmailRequest?: UnsubcribeEmailRequest
}

/**
 * MailsApi - object-oriented interface
 * @export
 * @class MailsApi
 * @extends {BaseAPI}
 */
export class MailsApi extends BaseAPI {
    /**
     * getUserName
     * @summary getUserName
     * @param {MailsApiGetUserNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailsApi
     */
    public getUserName(requestParameters: MailsApiGetUserNameRequest, options?: AxiosRequestConfig) {
        return MailsApiFp(this.configuration).getUserName(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * unsubcribeEmail
     * @summary unsubcribeEmail
     * @param {MailsApiUnsubcribeEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MailsApi
     */
    public unsubcribeEmail(requestParameters: MailsApiUnsubcribeEmailRequest, options?: AxiosRequestConfig) {
        return MailsApiFp(this.configuration).unsubcribeEmail(requestParameters.userId, requestParameters.unsubcribeEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrderApi - axios parameter creator
 * @export
 */
export const OrderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getDetailTicket
         * @param {string} uuid lp id
         * @param {string} ticketId ticket id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetailTicket: async (uuid: string, ticketId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getDetailTicket', 'uuid', uuid)
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('getDetailTicket', 'ticketId', ticketId)
            const localVarPath = `/page/lp/{uuid}/tickets/{ticket_id}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)))
                .replace(`{${"ticket_id"}}`, encodeURIComponent(String(ticketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 注文番号でチケットを取得する
         * @param {string} orderUuid order uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListOrders: async (orderUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderUuid' is not null or undefined
            assertParamExists('getListOrders', 'orderUuid', orderUuid)
            const localVarPath = `/orders/{order_uuid}`
                .replace(`{${"order_uuid"}}`, encodeURIComponent(String(orderUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderApi - functional programming interface
 * @export
 */
export const OrderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary getDetailTicket
         * @param {string} uuid lp id
         * @param {string} ticketId ticket id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetailTicket(uuid: string, ticketId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDetailTicket200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetailTicket(uuid, ticketId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary 注文番号でチケットを取得する
         * @param {string} orderUuid order uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListOrders(orderUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetListOrders200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListOrders(orderUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrderApi - factory interface
 * @export
 */
export const OrderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderApiFp(configuration)
    return {
        /**
         * 
         * @summary getDetailTicket
         * @param {string} uuid lp id
         * @param {string} ticketId ticket id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetailTicket(uuid: string, ticketId: string, options?: any): AxiosPromise<GetDetailTicket200Response> {
            return localVarFp.getDetailTicket(uuid, ticketId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 注文番号でチケットを取得する
         * @param {string} orderUuid order uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListOrders(orderUuid: string, options?: any): AxiosPromise<GetListOrders200Response> {
            return localVarFp.getListOrders(orderUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getDetailTicket operation in OrderApi.
 * @export
 * @interface OrderApiGetDetailTicketRequest
 */
export interface OrderApiGetDetailTicketRequest {
    /**
     * lp id
     * @type {string}
     * @memberof OrderApiGetDetailTicket
     */
    readonly uuid: string

    /**
     * ticket id
     * @type {string}
     * @memberof OrderApiGetDetailTicket
     */
    readonly ticketId: string
}

/**
 * Request parameters for getListOrders operation in OrderApi.
 * @export
 * @interface OrderApiGetListOrdersRequest
 */
export interface OrderApiGetListOrdersRequest {
    /**
     * order uuid
     * @type {string}
     * @memberof OrderApiGetListOrders
     */
    readonly orderUuid: string
}

/**
 * OrderApi - object-oriented interface
 * @export
 * @class OrderApi
 * @extends {BaseAPI}
 */
export class OrderApi extends BaseAPI {
    /**
     * 
     * @summary getDetailTicket
     * @param {OrderApiGetDetailTicketRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public getDetailTicket(requestParameters: OrderApiGetDetailTicketRequest, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).getDetailTicket(requestParameters.uuid, requestParameters.ticketId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 注文番号でチケットを取得する
     * @param {OrderApiGetListOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public getListOrders(requestParameters: OrderApiGetListOrdersRequest, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).getListOrders(requestParameters.orderUuid, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PageApi - axios parameter creator
 * @export
 */
export const PageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ページのUUIDに紐づく入力フォーム情報を取得
         * @summary 入力フォーム情報取得
         * @param {string} uuid UUID(pages.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForm: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getForm', 'uuid', uuid)
            const localVarPath = `/page/form/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ページのUUIDに紐づくLP画面のテンプレート情報を取得
         * @summary LP画面テンプレート取得
         * @param {string} uuid UUID(pages.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPage: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getPage', 'uuid', uuid)
            const localVarPath = `/page/lp/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * getServiceTermPage
         * @summary getServiceTermPage
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceTermPage: async (serviceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('getServiceTermPage', 'serviceId', serviceId)
            const localVarPath = `/term/{service_id}`
                .replace(`{${"service_id"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ページのUUIDに紐づくSimpleタイプの画面テンプレート情報を取得
         * @summary シンプルページ画面テンプレート取得
         * @param {string} uuid UUID(pages.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimplePage: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getSimplePage', 'uuid', uuid)
            const localVarPath = `/page/simple/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ページのUUIDに紐づくテンプレート情報を取得
         * @summary サンクスページ画面テンプレート取得
         * @param {string} uuid UUID(pages.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThanksPage: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getThanksPage', 'uuid', uuid)
            const localVarPath = `/page/thanks/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary シークレットパスワード
         * @param {string} uuid UUID(pages.uuid)
         * @param {PostPageSecretPasswordRequest} postPageSecretPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPageSecretPassword: async (uuid: string, postPageSecretPasswordRequest: PostPageSecretPasswordRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('postPageSecretPassword', 'uuid', uuid)
            // verify required parameter 'postPageSecretPasswordRequest' is not null or undefined
            assertParamExists('postPageSecretPassword', 'postPageSecretPasswordRequest', postPageSecretPasswordRequest)
            const localVarPath = `/page/lp/{uuid}/password`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postPageSecretPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PageApi - functional programming interface
 * @export
 */
export const PageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PageApiAxiosParamCreator(configuration)
    return {
        /**
         * ページのUUIDに紐づく入力フォーム情報を取得
         * @summary 入力フォーム情報取得
         * @param {string} uuid UUID(pages.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForm(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetForm200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getForm(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ページのUUIDに紐づくLP画面のテンプレート情報を取得
         * @summary LP画面テンプレート取得
         * @param {string} uuid UUID(pages.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPage(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPage200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPage(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * getServiceTermPage
         * @summary getServiceTermPage
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceTermPage(serviceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetServiceTermPage200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceTermPage(serviceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ページのUUIDに紐づくSimpleタイプの画面テンプレート情報を取得
         * @summary シンプルページ画面テンプレート取得
         * @param {string} uuid UUID(pages.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimplePage(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSimplePage200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSimplePage(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ページのUUIDに紐づくテンプレート情報を取得
         * @summary サンクスページ画面テンプレート取得
         * @param {string} uuid UUID(pages.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getThanksPage(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetThanksPage200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getThanksPage(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary シークレットパスワード
         * @param {string} uuid UUID(pages.uuid)
         * @param {PostPageSecretPasswordRequest} postPageSecretPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPageSecretPassword(uuid: string, postPageSecretPasswordRequest: PostPageSecretPasswordRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPage200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPageSecretPassword(uuid, postPageSecretPasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PageApi - factory interface
 * @export
 */
export const PageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PageApiFp(configuration)
    return {
        /**
         * ページのUUIDに紐づく入力フォーム情報を取得
         * @summary 入力フォーム情報取得
         * @param {string} uuid UUID(pages.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForm(uuid: string, options?: any): AxiosPromise<GetForm200Response> {
            return localVarFp.getForm(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * ページのUUIDに紐づくLP画面のテンプレート情報を取得
         * @summary LP画面テンプレート取得
         * @param {string} uuid UUID(pages.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPage(uuid: string, options?: any): AxiosPromise<GetPage200Response> {
            return localVarFp.getPage(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * getServiceTermPage
         * @summary getServiceTermPage
         * @param {string} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceTermPage(serviceId: string, options?: any): AxiosPromise<GetServiceTermPage200Response> {
            return localVarFp.getServiceTermPage(serviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * ページのUUIDに紐づくSimpleタイプの画面テンプレート情報を取得
         * @summary シンプルページ画面テンプレート取得
         * @param {string} uuid UUID(pages.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimplePage(uuid: string, options?: any): AxiosPromise<GetSimplePage200Response> {
            return localVarFp.getSimplePage(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * ページのUUIDに紐づくテンプレート情報を取得
         * @summary サンクスページ画面テンプレート取得
         * @param {string} uuid UUID(pages.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThanksPage(uuid: string, options?: any): AxiosPromise<GetThanksPage200Response> {
            return localVarFp.getThanksPage(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary シークレットパスワード
         * @param {string} uuid UUID(pages.uuid)
         * @param {PostPageSecretPasswordRequest} postPageSecretPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPageSecretPassword(uuid: string, postPageSecretPasswordRequest: PostPageSecretPasswordRequest, options?: any): AxiosPromise<GetPage200Response> {
            return localVarFp.postPageSecretPassword(uuid, postPageSecretPasswordRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getForm operation in PageApi.
 * @export
 * @interface PageApiGetFormRequest
 */
export interface PageApiGetFormRequest {
    /**
     * UUID(pages.uuid)
     * @type {string}
     * @memberof PageApiGetForm
     */
    readonly uuid: string
}

/**
 * Request parameters for getPage operation in PageApi.
 * @export
 * @interface PageApiGetPageRequest
 */
export interface PageApiGetPageRequest {
    /**
     * UUID(pages.uuid)
     * @type {string}
     * @memberof PageApiGetPage
     */
    readonly uuid: string
}

/**
 * Request parameters for getServiceTermPage operation in PageApi.
 * @export
 * @interface PageApiGetServiceTermPageRequest
 */
export interface PageApiGetServiceTermPageRequest {
    /**
     * 
     * @type {string}
     * @memberof PageApiGetServiceTermPage
     */
    readonly serviceId: string
}

/**
 * Request parameters for getSimplePage operation in PageApi.
 * @export
 * @interface PageApiGetSimplePageRequest
 */
export interface PageApiGetSimplePageRequest {
    /**
     * UUID(pages.uuid)
     * @type {string}
     * @memberof PageApiGetSimplePage
     */
    readonly uuid: string
}

/**
 * Request parameters for getThanksPage operation in PageApi.
 * @export
 * @interface PageApiGetThanksPageRequest
 */
export interface PageApiGetThanksPageRequest {
    /**
     * UUID(pages.uuid)
     * @type {string}
     * @memberof PageApiGetThanksPage
     */
    readonly uuid: string
}

/**
 * Request parameters for postPageSecretPassword operation in PageApi.
 * @export
 * @interface PageApiPostPageSecretPasswordRequest
 */
export interface PageApiPostPageSecretPasswordRequest {
    /**
     * UUID(pages.uuid)
     * @type {string}
     * @memberof PageApiPostPageSecretPassword
     */
    readonly uuid: string

    /**
     * 
     * @type {PostPageSecretPasswordRequest}
     * @memberof PageApiPostPageSecretPassword
     */
    readonly postPageSecretPasswordRequest: PostPageSecretPasswordRequest
}

/**
 * PageApi - object-oriented interface
 * @export
 * @class PageApi
 * @extends {BaseAPI}
 */
export class PageApi extends BaseAPI {
    /**
     * ページのUUIDに紐づく入力フォーム情報を取得
     * @summary 入力フォーム情報取得
     * @param {PageApiGetFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public getForm(requestParameters: PageApiGetFormRequest, options?: AxiosRequestConfig) {
        return PageApiFp(this.configuration).getForm(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ページのUUIDに紐づくLP画面のテンプレート情報を取得
     * @summary LP画面テンプレート取得
     * @param {PageApiGetPageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public getPage(requestParameters: PageApiGetPageRequest, options?: AxiosRequestConfig) {
        return PageApiFp(this.configuration).getPage(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * getServiceTermPage
     * @summary getServiceTermPage
     * @param {PageApiGetServiceTermPageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public getServiceTermPage(requestParameters: PageApiGetServiceTermPageRequest, options?: AxiosRequestConfig) {
        return PageApiFp(this.configuration).getServiceTermPage(requestParameters.serviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ページのUUIDに紐づくSimpleタイプの画面テンプレート情報を取得
     * @summary シンプルページ画面テンプレート取得
     * @param {PageApiGetSimplePageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public getSimplePage(requestParameters: PageApiGetSimplePageRequest, options?: AxiosRequestConfig) {
        return PageApiFp(this.configuration).getSimplePage(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ページのUUIDに紐づくテンプレート情報を取得
     * @summary サンクスページ画面テンプレート取得
     * @param {PageApiGetThanksPageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public getThanksPage(requestParameters: PageApiGetThanksPageRequest, options?: AxiosRequestConfig) {
        return PageApiFp(this.configuration).getThanksPage(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary シークレットパスワード
     * @param {PageApiPostPageSecretPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PageApi
     */
    public postPageSecretPassword(requestParameters: PageApiPostPageSecretPasswordRequest, options?: AxiosRequestConfig) {
        return PageApiFp(this.configuration).postPageSecretPassword(requestParameters.uuid, requestParameters.postPageSecretPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PostPurchaseHistoriesInvoiceApi - axios parameter creator
 * @export
 */
export const PostPurchaseHistoriesInvoiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Download invoice file
         * @summary Download invoice file
         * @param {PostPurchaseHistoriesInvoiceRequest} [postPurchaseHistoriesInvoiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPurchaseHistoriesInvoice: async (postPurchaseHistoriesInvoiceRequest?: PostPurchaseHistoriesInvoiceRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/purchase-histories/invoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postPurchaseHistoriesInvoiceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PostPurchaseHistoriesInvoiceApi - functional programming interface
 * @export
 */
export const PostPurchaseHistoriesInvoiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PostPurchaseHistoriesInvoiceApiAxiosParamCreator(configuration)
    return {
        /**
         * Download invoice file
         * @summary Download invoice file
         * @param {PostPurchaseHistoriesInvoiceRequest} [postPurchaseHistoriesInvoiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPurchaseHistoriesInvoice(postPurchaseHistoriesInvoiceRequest?: PostPurchaseHistoriesInvoiceRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostPurchaseHistoriesInvoice200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPurchaseHistoriesInvoice(postPurchaseHistoriesInvoiceRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PostPurchaseHistoriesInvoiceApi - factory interface
 * @export
 */
export const PostPurchaseHistoriesInvoiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PostPurchaseHistoriesInvoiceApiFp(configuration)
    return {
        /**
         * Download invoice file
         * @summary Download invoice file
         * @param {PostPurchaseHistoriesInvoiceRequest} [postPurchaseHistoriesInvoiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPurchaseHistoriesInvoice(postPurchaseHistoriesInvoiceRequest?: PostPurchaseHistoriesInvoiceRequest, options?: any): AxiosPromise<PostPurchaseHistoriesInvoice200Response> {
            return localVarFp.postPurchaseHistoriesInvoice(postPurchaseHistoriesInvoiceRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for postPurchaseHistoriesInvoice operation in PostPurchaseHistoriesInvoiceApi.
 * @export
 * @interface PostPurchaseHistoriesInvoiceApiPostPurchaseHistoriesInvoiceRequest
 */
export interface PostPurchaseHistoriesInvoiceApiPostPurchaseHistoriesInvoiceRequest {
    /**
     * 
     * @type {PostPurchaseHistoriesInvoiceRequest}
     * @memberof PostPurchaseHistoriesInvoiceApiPostPurchaseHistoriesInvoice
     */
    readonly postPurchaseHistoriesInvoiceRequest?: PostPurchaseHistoriesInvoiceRequest
}

/**
 * PostPurchaseHistoriesInvoiceApi - object-oriented interface
 * @export
 * @class PostPurchaseHistoriesInvoiceApi
 * @extends {BaseAPI}
 */
export class PostPurchaseHistoriesInvoiceApi extends BaseAPI {
    /**
     * Download invoice file
     * @summary Download invoice file
     * @param {PostPurchaseHistoriesInvoiceApiPostPurchaseHistoriesInvoiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostPurchaseHistoriesInvoiceApi
     */
    public postPurchaseHistoriesInvoice(requestParameters: PostPurchaseHistoriesInvoiceApiPostPurchaseHistoriesInvoiceRequest = {}, options?: AxiosRequestConfig) {
        return PostPurchaseHistoriesInvoiceApiFp(this.configuration).postPurchaseHistoriesInvoice(requestParameters.postPurchaseHistoriesInvoiceRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PrefMasterApi - axios parameter creator
 * @export
 */
export const PrefMasterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 都道府県マスタの取得API
         * @summary 都道府県マスタAPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrefectures: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pref-master`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrefMasterApi - functional programming interface
 * @export
 */
export const PrefMasterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrefMasterApiAxiosParamCreator(configuration)
    return {
        /**
         * 都道府県マスタの取得API
         * @summary 都道府県マスタAPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrefectures(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPrefectures200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrefectures(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PrefMasterApi - factory interface
 * @export
 */
export const PrefMasterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrefMasterApiFp(configuration)
    return {
        /**
         * 都道府県マスタの取得API
         * @summary 都道府県マスタAPI
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrefectures(options?: any): AxiosPromise<GetPrefectures200Response> {
            return localVarFp.getPrefectures(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrefMasterApi - object-oriented interface
 * @export
 * @class PrefMasterApi
 * @extends {BaseAPI}
 */
export class PrefMasterApi extends BaseAPI {
    /**
     * 都道府県マスタの取得API
     * @summary 都道府県マスタAPI
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrefMasterApi
     */
    public getPrefectures(options?: AxiosRequestConfig) {
        return PrefMasterApiFp(this.configuration).getPrefectures(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ReservationApi - axios parameter creator
 * @export
 */
export const ReservationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 予約するサービスメニューに応じた予約可否一覧を返却
         * @summary カレンダー予約可否一覧取得
         * @param {string} startDate 初回リクエストは現在日週の開始(日曜日)をリクエスト
         * @param {number} serviceMenuId service_menu.id
         * @param {Array<number>} [serviceMenuOptionIds] 対象ID[]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReservationCalendar: async (startDate: string, serviceMenuId: number, serviceMenuOptionIds?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('getReservationCalendar', 'startDate', startDate)
            // verify required parameter 'serviceMenuId' is not null or undefined
            assertParamExists('getReservationCalendar', 'serviceMenuId', serviceMenuId)
            const localVarPath = `/reservation/calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substr(0,10) :
                    startDate;
            }

            if (serviceMenuId !== undefined) {
                localVarQueryParameter['service_menu_id'] = serviceMenuId;
            }

            if (serviceMenuOptionIds) {
                localVarQueryParameter['service_menu_option_ids[]'] = serviceMenuOptionIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 購入詳細画面(予約内容エリア)<br/>注文IDに紐づく予約情報を取得
         * @summary 予約詳細取得(カレンダー)
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReservationCalendarDetail: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getReservationCalendarDetail', 'uuid', uuid)
            const localVarPath = `/reservation/{uuid}/calendar`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 予約カレンダーの直近の日付を取得する
         * @summary 予約カレンダーの直近の日付を取得する
         * @param {string} id id of service calendar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReservationCalendarNearestDate: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getReservationCalendarNearestDate', 'id', id)
            const localVarPath = `/reservation/calendar/nearest-date/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 購入詳細画面(サービス情報エリア)<br/>注文IDに紐づくサービス情報(カレンダー)を取得
         * @summary 予約サービス情報取得(カレンダー)
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReservationCalendarService: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getReservationCalendarService', 'uuid', uuid)
            const localVarPath = `/reservation/{uuid}/services-calendar`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 注文IDに紐づく予約お問合せ先を取得
         * @summary 予約お問合せ先取得
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReservationContact: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getReservationContact', 'uuid', uuid)
            const localVarPath = `/reservation/{uuid}/contact`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 注文IDに紐づく予約サービス情報を取得
         * @summary 予約詳細取得
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReservationDetail: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getReservationDetail', 'uuid', uuid)
            const localVarPath = `/reservation/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 注文IDに紐づく予約サービス情報を取得
         * @summary 予約サービス情報取得
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReservationService: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getReservationService', 'uuid', uuid)
            const localVarPath = `/reservation/{uuid}/services`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 予約のバリデーションを実行
         * @summary 予約バリデーション
         * @param {InvalidateReservationRequest} [invalidateReservationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateReservation: async (invalidateReservationRequest?: InvalidateReservationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reservation/invalidate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invalidateReservationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * カレンダー指定時間の予約可否取得する
         * @summary カレンダー指定時間の予約可否取得
         * @param {number} serviceMenuId service_menu.id
         * @param {string} reservationDatetime 初回リクエストは現在日週の開始(日曜日)をリクエスト
         * @param {Array<number>} [serviceMenuOptionIds] 対象ID[]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCalendarReservable: async (serviceMenuId: number, reservationDatetime: string, serviceMenuOptionIds?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceMenuId' is not null or undefined
            assertParamExists('postCalendarReservable', 'serviceMenuId', serviceMenuId)
            // verify required parameter 'reservationDatetime' is not null or undefined
            assertParamExists('postCalendarReservable', 'reservationDatetime', reservationDatetime)
            const localVarPath = `/reservation/calendar/reservable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (serviceMenuId !== undefined) {
                localVarQueryParameter['service_menu_id'] = serviceMenuId;
            }

            if (reservationDatetime !== undefined) {
                localVarQueryParameter['reservation_datetime'] = (reservationDatetime as any instanceof Date) ?
                    (reservationDatetime as any).toISOString() :
                    reservationDatetime;
            }

            if (serviceMenuOptionIds) {
                localVarQueryParameter['service_menu_option_ids[]'] = serviceMenuOptionIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 予約をキャンセルする
         * @summary 予約キャンセル
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCancelReservation: async (uuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('postCancelReservation', 'uuid', uuid)
            const localVarPath = `/reservation/{uuid}/cancel`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 予約申込の支払い処理
         * @summary 予約申込支払処理
         * @param {PostReservationCalendarPaymentRequest} [postReservationCalendarPaymentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReservationCalendarPayment: async (postReservationCalendarPaymentRequest?: PostReservationCalendarPaymentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reservation/payment-calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postReservationCalendarPaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 予約申込の支払い処理
         * @summary 予約申込支払処理
         * @param {PostReservationPaymentRequest} [postReservationPaymentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReservationPayment: async (postReservationPaymentRequest?: PostReservationPaymentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reservation/payment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postReservationPaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * サービス(カレンダー)で予約を申込みした顧客情報を保存
         * @summary 予約申込登録(カレンダー)
         * @param {PutReservationCalendarOrderRequest} [putReservationCalendarOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putReservationCalendarOrder: async (putReservationCalendarOrderRequest?: PutReservationCalendarOrderRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reservation/order-calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putReservationCalendarOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 予約日時を1件更新する
         * @summary 予約日時変更
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {PutReservationDatesRequest} [putReservationDatesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putReservationDates: async (uuid: string, putReservationDatesRequest?: PutReservationDatesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('putReservationDates', 'uuid', uuid)
            const localVarPath = `/reservation/{uuid}/dates`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putReservationDatesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 予約を申込みした顧客情報を保存
         * @summary 予約申込登録
         * @param {PutReservationOrderRequest} [putReservationOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putReservationOrder: async (putReservationOrderRequest?: PutReservationOrderRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reservation/order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putReservationOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reservation Prepare Order Via Paypal
         * @summary Reservation Prepare Order Via Paypal
         * @param {PutReservationPrepareOrderViaPaypalRequest} [putReservationPrepareOrderViaPaypalRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putReservationPrepareOrderViaPaypal: async (putReservationPrepareOrderViaPaypalRequest?: PutReservationPrepareOrderViaPaypalRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/reservation/prepare-order-via-paypal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putReservationPrepareOrderViaPaypalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReservationApi - functional programming interface
 * @export
 */
export const ReservationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReservationApiAxiosParamCreator(configuration)
    return {
        /**
         * 予約するサービスメニューに応じた予約可否一覧を返却
         * @summary カレンダー予約可否一覧取得
         * @param {string} startDate 初回リクエストは現在日週の開始(日曜日)をリクエスト
         * @param {number} serviceMenuId service_menu.id
         * @param {Array<number>} [serviceMenuOptionIds] 対象ID[]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReservationCalendar(startDate: string, serviceMenuId: number, serviceMenuOptionIds?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReservationCalendar200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReservationCalendar(startDate, serviceMenuId, serviceMenuOptionIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 購入詳細画面(予約内容エリア)<br/>注文IDに紐づく予約情報を取得
         * @summary 予約詳細取得(カレンダー)
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReservationCalendarDetail(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReservationCalendarDetail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReservationCalendarDetail(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 予約カレンダーの直近の日付を取得する
         * @summary 予約カレンダーの直近の日付を取得する
         * @param {string} id id of service calendar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReservationCalendarNearestDate(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReservationCalendarNearestDate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReservationCalendarNearestDate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 購入詳細画面(サービス情報エリア)<br/>注文IDに紐づくサービス情報(カレンダー)を取得
         * @summary 予約サービス情報取得(カレンダー)
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReservationCalendarService(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReservationCalendarService200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReservationCalendarService(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 注文IDに紐づく予約お問合せ先を取得
         * @summary 予約お問合せ先取得
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReservationContact(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReservationContact200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReservationContact(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 注文IDに紐づく予約サービス情報を取得
         * @summary 予約詳細取得
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReservationDetail(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReservationDetail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReservationDetail(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 注文IDに紐づく予約サービス情報を取得
         * @summary 予約サービス情報取得
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReservationService(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetReservationService200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReservationService(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 予約のバリデーションを実行
         * @summary 予約バリデーション
         * @param {InvalidateReservationRequest} [invalidateReservationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invalidateReservation(invalidateReservationRequest?: InvalidateReservationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvalidateReservation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invalidateReservation(invalidateReservationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * カレンダー指定時間の予約可否取得する
         * @summary カレンダー指定時間の予約可否取得
         * @param {number} serviceMenuId service_menu.id
         * @param {string} reservationDatetime 初回リクエストは現在日週の開始(日曜日)をリクエスト
         * @param {Array<number>} [serviceMenuOptionIds] 対象ID[]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCalendarReservable(serviceMenuId: number, reservationDatetime: string, serviceMenuOptionIds?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostCalendarReservable200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCalendarReservable(serviceMenuId, reservationDatetime, serviceMenuOptionIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 予約をキャンセルする
         * @summary 予約キャンセル
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCancelReservation(uuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCancelReservation(uuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 予約申込の支払い処理
         * @summary 予約申込支払処理
         * @param {PostReservationCalendarPaymentRequest} [postReservationCalendarPaymentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postReservationCalendarPayment(postReservationCalendarPaymentRequest?: PostReservationCalendarPaymentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostReservationCalendarPayment200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postReservationCalendarPayment(postReservationCalendarPaymentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 予約申込の支払い処理
         * @summary 予約申込支払処理
         * @param {PostReservationPaymentRequest} [postReservationPaymentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postReservationPayment(postReservationPaymentRequest?: PostReservationPaymentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostReservationPayment200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postReservationPayment(postReservationPaymentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * サービス(カレンダー)で予約を申込みした顧客情報を保存
         * @summary 予約申込登録(カレンダー)
         * @param {PutReservationCalendarOrderRequest} [putReservationCalendarOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putReservationCalendarOrder(putReservationCalendarOrderRequest?: PutReservationCalendarOrderRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutReservationCalendarOrder200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putReservationCalendarOrder(putReservationCalendarOrderRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 予約日時を1件更新する
         * @summary 予約日時変更
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {PutReservationDatesRequest} [putReservationDatesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putReservationDates(uuid: string, putReservationDatesRequest?: PutReservationDatesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putReservationDates(uuid, putReservationDatesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 予約を申込みした顧客情報を保存
         * @summary 予約申込登録
         * @param {PutReservationOrderRequest} [putReservationOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putReservationOrder(putReservationOrderRequest?: PutReservationOrderRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutReservationOrder200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putReservationOrder(putReservationOrderRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Reservation Prepare Order Via Paypal
         * @summary Reservation Prepare Order Via Paypal
         * @param {PutReservationPrepareOrderViaPaypalRequest} [putReservationPrepareOrderViaPaypalRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putReservationPrepareOrderViaPaypal(putReservationPrepareOrderViaPaypalRequest?: PutReservationPrepareOrderViaPaypalRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutReservationPrepareOrderViaPaypal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putReservationPrepareOrderViaPaypal(putReservationPrepareOrderViaPaypalRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReservationApi - factory interface
 * @export
 */
export const ReservationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReservationApiFp(configuration)
    return {
        /**
         * 予約するサービスメニューに応じた予約可否一覧を返却
         * @summary カレンダー予約可否一覧取得
         * @param {string} startDate 初回リクエストは現在日週の開始(日曜日)をリクエスト
         * @param {number} serviceMenuId service_menu.id
         * @param {Array<number>} [serviceMenuOptionIds] 対象ID[]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReservationCalendar(startDate: string, serviceMenuId: number, serviceMenuOptionIds?: Array<number>, options?: any): AxiosPromise<GetReservationCalendar200Response> {
            return localVarFp.getReservationCalendar(startDate, serviceMenuId, serviceMenuOptionIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 購入詳細画面(予約内容エリア)<br/>注文IDに紐づく予約情報を取得
         * @summary 予約詳細取得(カレンダー)
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReservationCalendarDetail(uuid: string, options?: any): AxiosPromise<GetReservationCalendarDetail200Response> {
            return localVarFp.getReservationCalendarDetail(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 予約カレンダーの直近の日付を取得する
         * @summary 予約カレンダーの直近の日付を取得する
         * @param {string} id id of service calendar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReservationCalendarNearestDate(id: string, options?: any): AxiosPromise<GetReservationCalendarNearestDate200Response> {
            return localVarFp.getReservationCalendarNearestDate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 購入詳細画面(サービス情報エリア)<br/>注文IDに紐づくサービス情報(カレンダー)を取得
         * @summary 予約サービス情報取得(カレンダー)
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReservationCalendarService(uuid: string, options?: any): AxiosPromise<GetReservationCalendarService200Response> {
            return localVarFp.getReservationCalendarService(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 注文IDに紐づく予約お問合せ先を取得
         * @summary 予約お問合せ先取得
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReservationContact(uuid: string, options?: any): AxiosPromise<GetReservationContact200Response> {
            return localVarFp.getReservationContact(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 注文IDに紐づく予約サービス情報を取得
         * @summary 予約詳細取得
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReservationDetail(uuid: string, options?: any): AxiosPromise<GetReservationDetail200Response> {
            return localVarFp.getReservationDetail(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 注文IDに紐づく予約サービス情報を取得
         * @summary 予約サービス情報取得
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReservationService(uuid: string, options?: any): AxiosPromise<GetReservationService200Response> {
            return localVarFp.getReservationService(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 予約のバリデーションを実行
         * @summary 予約バリデーション
         * @param {InvalidateReservationRequest} [invalidateReservationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateReservation(invalidateReservationRequest?: InvalidateReservationRequest, options?: any): AxiosPromise<InvalidateReservation200Response> {
            return localVarFp.invalidateReservation(invalidateReservationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * カレンダー指定時間の予約可否取得する
         * @summary カレンダー指定時間の予約可否取得
         * @param {number} serviceMenuId service_menu.id
         * @param {string} reservationDatetime 初回リクエストは現在日週の開始(日曜日)をリクエスト
         * @param {Array<number>} [serviceMenuOptionIds] 対象ID[]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCalendarReservable(serviceMenuId: number, reservationDatetime: string, serviceMenuOptionIds?: Array<number>, options?: any): AxiosPromise<PostCalendarReservable200Response> {
            return localVarFp.postCalendarReservable(serviceMenuId, reservationDatetime, serviceMenuOptionIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 予約をキャンセルする
         * @summary 予約キャンセル
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCancelReservation(uuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.postCancelReservation(uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 予約申込の支払い処理
         * @summary 予約申込支払処理
         * @param {PostReservationCalendarPaymentRequest} [postReservationCalendarPaymentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReservationCalendarPayment(postReservationCalendarPaymentRequest?: PostReservationCalendarPaymentRequest, options?: any): AxiosPromise<PostReservationCalendarPayment200Response> {
            return localVarFp.postReservationCalendarPayment(postReservationCalendarPaymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 予約申込の支払い処理
         * @summary 予約申込支払処理
         * @param {PostReservationPaymentRequest} [postReservationPaymentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postReservationPayment(postReservationPaymentRequest?: PostReservationPaymentRequest, options?: any): AxiosPromise<PostReservationPayment200Response> {
            return localVarFp.postReservationPayment(postReservationPaymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * サービス(カレンダー)で予約を申込みした顧客情報を保存
         * @summary 予約申込登録(カレンダー)
         * @param {PutReservationCalendarOrderRequest} [putReservationCalendarOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putReservationCalendarOrder(putReservationCalendarOrderRequest?: PutReservationCalendarOrderRequest, options?: any): AxiosPromise<PutReservationCalendarOrder200Response> {
            return localVarFp.putReservationCalendarOrder(putReservationCalendarOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 予約日時を1件更新する
         * @summary 予約日時変更
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {PutReservationDatesRequest} [putReservationDatesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putReservationDates(uuid: string, putReservationDatesRequest?: PutReservationDatesRequest, options?: any): AxiosPromise<void> {
            return localVarFp.putReservationDates(uuid, putReservationDatesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 予約を申込みした顧客情報を保存
         * @summary 予約申込登録
         * @param {PutReservationOrderRequest} [putReservationOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putReservationOrder(putReservationOrderRequest?: PutReservationOrderRequest, options?: any): AxiosPromise<PutReservationOrder200Response> {
            return localVarFp.putReservationOrder(putReservationOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Reservation Prepare Order Via Paypal
         * @summary Reservation Prepare Order Via Paypal
         * @param {PutReservationPrepareOrderViaPaypalRequest} [putReservationPrepareOrderViaPaypalRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putReservationPrepareOrderViaPaypal(putReservationPrepareOrderViaPaypalRequest?: PutReservationPrepareOrderViaPaypalRequest, options?: any): AxiosPromise<PutReservationPrepareOrderViaPaypal200Response> {
            return localVarFp.putReservationPrepareOrderViaPaypal(putReservationPrepareOrderViaPaypalRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getReservationCalendar operation in ReservationApi.
 * @export
 * @interface ReservationApiGetReservationCalendarRequest
 */
export interface ReservationApiGetReservationCalendarRequest {
    /**
     * 初回リクエストは現在日週の開始(日曜日)をリクエスト
     * @type {string}
     * @memberof ReservationApiGetReservationCalendar
     */
    readonly startDate: string

    /**
     * service_menu.id
     * @type {number}
     * @memberof ReservationApiGetReservationCalendar
     */
    readonly serviceMenuId: number

    /**
     * 対象ID[]
     * @type {Array<number>}
     * @memberof ReservationApiGetReservationCalendar
     */
    readonly serviceMenuOptionIds?: Array<number>
}

/**
 * Request parameters for getReservationCalendarDetail operation in ReservationApi.
 * @export
 * @interface ReservationApiGetReservationCalendarDetailRequest
 */
export interface ReservationApiGetReservationCalendarDetailRequest {
    /**
     * 注文ユニークID(orders.uuid)
     * @type {string}
     * @memberof ReservationApiGetReservationCalendarDetail
     */
    readonly uuid: string
}

/**
 * Request parameters for getReservationCalendarNearestDate operation in ReservationApi.
 * @export
 * @interface ReservationApiGetReservationCalendarNearestDateRequest
 */
export interface ReservationApiGetReservationCalendarNearestDateRequest {
    /**
     * id of service calendar
     * @type {string}
     * @memberof ReservationApiGetReservationCalendarNearestDate
     */
    readonly id: string
}

/**
 * Request parameters for getReservationCalendarService operation in ReservationApi.
 * @export
 * @interface ReservationApiGetReservationCalendarServiceRequest
 */
export interface ReservationApiGetReservationCalendarServiceRequest {
    /**
     * 注文ユニークID(orders.uuid)
     * @type {string}
     * @memberof ReservationApiGetReservationCalendarService
     */
    readonly uuid: string
}

/**
 * Request parameters for getReservationContact operation in ReservationApi.
 * @export
 * @interface ReservationApiGetReservationContactRequest
 */
export interface ReservationApiGetReservationContactRequest {
    /**
     * 注文ユニークID(orders.uuid)
     * @type {string}
     * @memberof ReservationApiGetReservationContact
     */
    readonly uuid: string
}

/**
 * Request parameters for getReservationDetail operation in ReservationApi.
 * @export
 * @interface ReservationApiGetReservationDetailRequest
 */
export interface ReservationApiGetReservationDetailRequest {
    /**
     * 注文ユニークID(orders.uuid)
     * @type {string}
     * @memberof ReservationApiGetReservationDetail
     */
    readonly uuid: string
}

/**
 * Request parameters for getReservationService operation in ReservationApi.
 * @export
 * @interface ReservationApiGetReservationServiceRequest
 */
export interface ReservationApiGetReservationServiceRequest {
    /**
     * 注文ユニークID(orders.uuid)
     * @type {string}
     * @memberof ReservationApiGetReservationService
     */
    readonly uuid: string
}

/**
 * Request parameters for invalidateReservation operation in ReservationApi.
 * @export
 * @interface ReservationApiInvalidateReservationRequest
 */
export interface ReservationApiInvalidateReservationRequest {
    /**
     * 
     * @type {InvalidateReservationRequest}
     * @memberof ReservationApiInvalidateReservation
     */
    readonly invalidateReservationRequest?: InvalidateReservationRequest
}

/**
 * Request parameters for postCalendarReservable operation in ReservationApi.
 * @export
 * @interface ReservationApiPostCalendarReservableRequest
 */
export interface ReservationApiPostCalendarReservableRequest {
    /**
     * service_menu.id
     * @type {number}
     * @memberof ReservationApiPostCalendarReservable
     */
    readonly serviceMenuId: number

    /**
     * 初回リクエストは現在日週の開始(日曜日)をリクエスト
     * @type {string}
     * @memberof ReservationApiPostCalendarReservable
     */
    readonly reservationDatetime: string

    /**
     * 対象ID[]
     * @type {Array<number>}
     * @memberof ReservationApiPostCalendarReservable
     */
    readonly serviceMenuOptionIds?: Array<number>
}

/**
 * Request parameters for postCancelReservation operation in ReservationApi.
 * @export
 * @interface ReservationApiPostCancelReservationRequest
 */
export interface ReservationApiPostCancelReservationRequest {
    /**
     * 注文ユニークID(orders.uuid)
     * @type {string}
     * @memberof ReservationApiPostCancelReservation
     */
    readonly uuid: string
}

/**
 * Request parameters for postReservationCalendarPayment operation in ReservationApi.
 * @export
 * @interface ReservationApiPostReservationCalendarPaymentRequest
 */
export interface ReservationApiPostReservationCalendarPaymentRequest {
    /**
     * 
     * @type {PostReservationCalendarPaymentRequest}
     * @memberof ReservationApiPostReservationCalendarPayment
     */
    readonly postReservationCalendarPaymentRequest?: PostReservationCalendarPaymentRequest
}

/**
 * Request parameters for postReservationPayment operation in ReservationApi.
 * @export
 * @interface ReservationApiPostReservationPaymentRequest
 */
export interface ReservationApiPostReservationPaymentRequest {
    /**
     * 
     * @type {PostReservationPaymentRequest}
     * @memberof ReservationApiPostReservationPayment
     */
    readonly postReservationPaymentRequest?: PostReservationPaymentRequest
}

/**
 * Request parameters for putReservationCalendarOrder operation in ReservationApi.
 * @export
 * @interface ReservationApiPutReservationCalendarOrderRequest
 */
export interface ReservationApiPutReservationCalendarOrderRequest {
    /**
     * 
     * @type {PutReservationCalendarOrderRequest}
     * @memberof ReservationApiPutReservationCalendarOrder
     */
    readonly putReservationCalendarOrderRequest?: PutReservationCalendarOrderRequest
}

/**
 * Request parameters for putReservationDates operation in ReservationApi.
 * @export
 * @interface ReservationApiPutReservationDatesRequest
 */
export interface ReservationApiPutReservationDatesRequest {
    /**
     * 注文ユニークID(orders.uuid)
     * @type {string}
     * @memberof ReservationApiPutReservationDates
     */
    readonly uuid: string

    /**
     * 
     * @type {PutReservationDatesRequest}
     * @memberof ReservationApiPutReservationDates
     */
    readonly putReservationDatesRequest?: PutReservationDatesRequest
}

/**
 * Request parameters for putReservationOrder operation in ReservationApi.
 * @export
 * @interface ReservationApiPutReservationOrderRequest
 */
export interface ReservationApiPutReservationOrderRequest {
    /**
     * 
     * @type {PutReservationOrderRequest}
     * @memberof ReservationApiPutReservationOrder
     */
    readonly putReservationOrderRequest?: PutReservationOrderRequest
}

/**
 * Request parameters for putReservationPrepareOrderViaPaypal operation in ReservationApi.
 * @export
 * @interface ReservationApiPutReservationPrepareOrderViaPaypalRequest
 */
export interface ReservationApiPutReservationPrepareOrderViaPaypalRequest {
    /**
     * 
     * @type {PutReservationPrepareOrderViaPaypalRequest}
     * @memberof ReservationApiPutReservationPrepareOrderViaPaypal
     */
    readonly putReservationPrepareOrderViaPaypalRequest?: PutReservationPrepareOrderViaPaypalRequest
}

/**
 * ReservationApi - object-oriented interface
 * @export
 * @class ReservationApi
 * @extends {BaseAPI}
 */
export class ReservationApi extends BaseAPI {
    /**
     * 予約するサービスメニューに応じた予約可否一覧を返却
     * @summary カレンダー予約可否一覧取得
     * @param {ReservationApiGetReservationCalendarRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationApi
     */
    public getReservationCalendar(requestParameters: ReservationApiGetReservationCalendarRequest, options?: AxiosRequestConfig) {
        return ReservationApiFp(this.configuration).getReservationCalendar(requestParameters.startDate, requestParameters.serviceMenuId, requestParameters.serviceMenuOptionIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 購入詳細画面(予約内容エリア)<br/>注文IDに紐づく予約情報を取得
     * @summary 予約詳細取得(カレンダー)
     * @param {ReservationApiGetReservationCalendarDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationApi
     */
    public getReservationCalendarDetail(requestParameters: ReservationApiGetReservationCalendarDetailRequest, options?: AxiosRequestConfig) {
        return ReservationApiFp(this.configuration).getReservationCalendarDetail(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 予約カレンダーの直近の日付を取得する
     * @summary 予約カレンダーの直近の日付を取得する
     * @param {ReservationApiGetReservationCalendarNearestDateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationApi
     */
    public getReservationCalendarNearestDate(requestParameters: ReservationApiGetReservationCalendarNearestDateRequest, options?: AxiosRequestConfig) {
        return ReservationApiFp(this.configuration).getReservationCalendarNearestDate(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 購入詳細画面(サービス情報エリア)<br/>注文IDに紐づくサービス情報(カレンダー)を取得
     * @summary 予約サービス情報取得(カレンダー)
     * @param {ReservationApiGetReservationCalendarServiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationApi
     */
    public getReservationCalendarService(requestParameters: ReservationApiGetReservationCalendarServiceRequest, options?: AxiosRequestConfig) {
        return ReservationApiFp(this.configuration).getReservationCalendarService(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 注文IDに紐づく予約お問合せ先を取得
     * @summary 予約お問合せ先取得
     * @param {ReservationApiGetReservationContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationApi
     */
    public getReservationContact(requestParameters: ReservationApiGetReservationContactRequest, options?: AxiosRequestConfig) {
        return ReservationApiFp(this.configuration).getReservationContact(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 注文IDに紐づく予約サービス情報を取得
     * @summary 予約詳細取得
     * @param {ReservationApiGetReservationDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationApi
     */
    public getReservationDetail(requestParameters: ReservationApiGetReservationDetailRequest, options?: AxiosRequestConfig) {
        return ReservationApiFp(this.configuration).getReservationDetail(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 注文IDに紐づく予約サービス情報を取得
     * @summary 予約サービス情報取得
     * @param {ReservationApiGetReservationServiceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationApi
     */
    public getReservationService(requestParameters: ReservationApiGetReservationServiceRequest, options?: AxiosRequestConfig) {
        return ReservationApiFp(this.configuration).getReservationService(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 予約のバリデーションを実行
     * @summary 予約バリデーション
     * @param {ReservationApiInvalidateReservationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationApi
     */
    public invalidateReservation(requestParameters: ReservationApiInvalidateReservationRequest = {}, options?: AxiosRequestConfig) {
        return ReservationApiFp(this.configuration).invalidateReservation(requestParameters.invalidateReservationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * カレンダー指定時間の予約可否取得する
     * @summary カレンダー指定時間の予約可否取得
     * @param {ReservationApiPostCalendarReservableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationApi
     */
    public postCalendarReservable(requestParameters: ReservationApiPostCalendarReservableRequest, options?: AxiosRequestConfig) {
        return ReservationApiFp(this.configuration).postCalendarReservable(requestParameters.serviceMenuId, requestParameters.reservationDatetime, requestParameters.serviceMenuOptionIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 予約をキャンセルする
     * @summary 予約キャンセル
     * @param {ReservationApiPostCancelReservationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationApi
     */
    public postCancelReservation(requestParameters: ReservationApiPostCancelReservationRequest, options?: AxiosRequestConfig) {
        return ReservationApiFp(this.configuration).postCancelReservation(requestParameters.uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 予約申込の支払い処理
     * @summary 予約申込支払処理
     * @param {ReservationApiPostReservationCalendarPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationApi
     */
    public postReservationCalendarPayment(requestParameters: ReservationApiPostReservationCalendarPaymentRequest = {}, options?: AxiosRequestConfig) {
        return ReservationApiFp(this.configuration).postReservationCalendarPayment(requestParameters.postReservationCalendarPaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 予約申込の支払い処理
     * @summary 予約申込支払処理
     * @param {ReservationApiPostReservationPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationApi
     */
    public postReservationPayment(requestParameters: ReservationApiPostReservationPaymentRequest = {}, options?: AxiosRequestConfig) {
        return ReservationApiFp(this.configuration).postReservationPayment(requestParameters.postReservationPaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * サービス(カレンダー)で予約を申込みした顧客情報を保存
     * @summary 予約申込登録(カレンダー)
     * @param {ReservationApiPutReservationCalendarOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationApi
     */
    public putReservationCalendarOrder(requestParameters: ReservationApiPutReservationCalendarOrderRequest = {}, options?: AxiosRequestConfig) {
        return ReservationApiFp(this.configuration).putReservationCalendarOrder(requestParameters.putReservationCalendarOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 予約日時を1件更新する
     * @summary 予約日時変更
     * @param {ReservationApiPutReservationDatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationApi
     */
    public putReservationDates(requestParameters: ReservationApiPutReservationDatesRequest, options?: AxiosRequestConfig) {
        return ReservationApiFp(this.configuration).putReservationDates(requestParameters.uuid, requestParameters.putReservationDatesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 予約を申込みした顧客情報を保存
     * @summary 予約申込登録
     * @param {ReservationApiPutReservationOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationApi
     */
    public putReservationOrder(requestParameters: ReservationApiPutReservationOrderRequest = {}, options?: AxiosRequestConfig) {
        return ReservationApiFp(this.configuration).putReservationOrder(requestParameters.putReservationOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reservation Prepare Order Via Paypal
     * @summary Reservation Prepare Order Via Paypal
     * @param {ReservationApiPutReservationPrepareOrderViaPaypalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReservationApi
     */
    public putReservationPrepareOrderViaPaypal(requestParameters: ReservationApiPutReservationPrepareOrderViaPaypalRequest = {}, options?: AxiosRequestConfig) {
        return ReservationApiFp(this.configuration).putReservationPrepareOrderViaPaypal(requestParameters.putReservationPrepareOrderViaPaypalRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ServiceApi - axios parameter creator
 * @export
 */
export const ServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * サービスメニュー選択画面<br/>サービスIDによりサービス(カレンダー)情報を1件取得する
         * @summary サービス(カレンダー)情報取得API
         * @param {number} id サービスID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarServiceById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCalendarServiceById', 'id', id)
            const localVarPath = `/services/{id}/calendar`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * サービスIDよりプライバシーポリシーを1件取得する
         * @summary プライバシーポリシー取得API
         * @param {number} id サービスID(service.id)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrivacyPolicyByServiceId: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPrivacyPolicyByServiceId', 'id', id)
            const localVarPath = `/services/{id}/privacy-policy`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * サービスIDによりサービス情報を1件取得する
         * @summary サービス情報取得API
         * @param {number} id サービスID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getServiceById', 'id', id)
            const localVarPath = `/services/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * サービスコンポーネントの一覧を取得する
         * @summary Get service components
         * @param {string} lpPageUuid Landing page UUID
         * @param {number} [page] Page number
         * @param {number} [perPage] Items per page
         * @param {0 | 1} [status] サービスステータス (0: 非公開, 1: 公開)
         * @param {1 | 2 | 12} [type] サービスタイプ (1: 有料イベント, 2: カレンダーサービス, 12: フォームサービス)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceComponents: async (lpPageUuid: string, page?: number, perPage?: number, status?: 0 | 1, type?: 1 | 2 | 12, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lpPageUuid' is not null or undefined
            assertParamExists('getServiceComponents', 'lpPageUuid', lpPageUuid)
            const localVarPath = `/services/components`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (lpPageUuid !== undefined) {
                localVarQueryParameter['lp_page_uuid'] = lpPageUuid;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定したIDのサービスコンポーネント一覧を取得する
         * @summary Get service components by IDs
         * @param {Array<number>} serviceIds サービスID配列
         * @param {string} lpPageUuid Landing page UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceComponentsByIds: async (serviceIds: Array<number>, lpPageUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceIds' is not null or undefined
            assertParamExists('getServiceComponentsByIds', 'serviceIds', serviceIds)
            // verify required parameter 'lpPageUuid' is not null or undefined
            assertParamExists('getServiceComponentsByIds', 'lpPageUuid', lpPageUuid)
            const localVarPath = `/services/components/list-service-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (serviceIds) {
                localVarQueryParameter['service_ids[]'] = serviceIds;
            }

            if (lpPageUuid !== undefined) {
                localVarQueryParameter['lp_page_uuid'] = lpPageUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 予約日時選択画面<br/>サービスメニューIDによりサービスメニュー情報詳細を1件取得する
         * @summary サービスメニュー詳細情報取得API
         * @param {number} id サービスメニューID(service_menu.id)
         * @param {Array<number>} [menuOptions] 対象のサービスメニューオプションID&lt;br/&gt;(指定がない場合、全メニュー取得)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceMenuById: async (id: number, menuOptions?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getServiceMenuById', 'id', id)
            const localVarPath = `/services/menu/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (menuOptions) {
                localVarQueryParameter['menu_options[]'] = menuOptions;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * サービスIDより特定商取引法取得を1件取得する
         * @summary 特定商取引法取得API
         * @param {number} id サービスID(service.id)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecialCommercialLawById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSpecialCommercialLawById', 'id', id)
            const localVarPath = `/services/{id}/special-commercial-law`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * サービスIDにより、そのサービスの開催日一覧を一括で取得する
         * @summary サービス開催日一覧取得
         * @param {number} id サービスID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexServiceHoldDate: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('indexServiceHoldDate', 'id', id)
            const localVarPath = `/services/{id}/hold-dates`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceApi - functional programming interface
 * @export
 */
export const ServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * サービスメニュー選択画面<br/>サービスIDによりサービス(カレンダー)情報を1件取得する
         * @summary サービス(カレンダー)情報取得API
         * @param {number} id サービスID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalendarServiceById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCalendarServiceById200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalendarServiceById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * サービスIDよりプライバシーポリシーを1件取得する
         * @summary プライバシーポリシー取得API
         * @param {number} id サービスID(service.id)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrivacyPolicyByServiceId(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPrivacyPolicyByServiceId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrivacyPolicyByServiceId(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * サービスIDによりサービス情報を1件取得する
         * @summary サービス情報取得API
         * @param {number} id サービスID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetServiceById200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * サービスコンポーネントの一覧を取得する
         * @summary Get service components
         * @param {string} lpPageUuid Landing page UUID
         * @param {number} [page] Page number
         * @param {number} [perPage] Items per page
         * @param {0 | 1} [status] サービスステータス (0: 非公開, 1: 公開)
         * @param {1 | 2 | 12} [type] サービスタイプ (1: 有料イベント, 2: カレンダーサービス, 12: フォームサービス)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceComponents(lpPageUuid: string, page?: number, perPage?: number, status?: 0 | 1, type?: 1 | 2 | 12, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetServiceComponents200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceComponents(lpPageUuid, page, perPage, status, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 指定したIDのサービスコンポーネント一覧を取得する
         * @summary Get service components by IDs
         * @param {Array<number>} serviceIds サービスID配列
         * @param {string} lpPageUuid Landing page UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceComponentsByIds(serviceIds: Array<number>, lpPageUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetServiceComponentsByIds200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceComponentsByIds(serviceIds, lpPageUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 予約日時選択画面<br/>サービスメニューIDによりサービスメニュー情報詳細を1件取得する
         * @summary サービスメニュー詳細情報取得API
         * @param {number} id サービスメニューID(service_menu.id)
         * @param {Array<number>} [menuOptions] 対象のサービスメニューオプションID&lt;br/&gt;(指定がない場合、全メニュー取得)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceMenuById(id: number, menuOptions?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetServiceMenuById200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceMenuById(id, menuOptions, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * サービスIDより特定商取引法取得を1件取得する
         * @summary 特定商取引法取得API
         * @param {number} id サービスID(service.id)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSpecialCommercialLawById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSpecialCommercialLawById200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSpecialCommercialLawById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * サービスIDにより、そのサービスの開催日一覧を一括で取得する
         * @summary サービス開催日一覧取得
         * @param {number} id サービスID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async indexServiceHoldDate(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndexServiceHoldDate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.indexServiceHoldDate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ServiceApi - factory interface
 * @export
 */
export const ServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceApiFp(configuration)
    return {
        /**
         * サービスメニュー選択画面<br/>サービスIDによりサービス(カレンダー)情報を1件取得する
         * @summary サービス(カレンダー)情報取得API
         * @param {number} id サービスID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendarServiceById(id: number, options?: any): AxiosPromise<GetCalendarServiceById200Response> {
            return localVarFp.getCalendarServiceById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * サービスIDよりプライバシーポリシーを1件取得する
         * @summary プライバシーポリシー取得API
         * @param {number} id サービスID(service.id)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrivacyPolicyByServiceId(id: number, options?: any): AxiosPromise<GetPrivacyPolicyByServiceId200Response> {
            return localVarFp.getPrivacyPolicyByServiceId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * サービスIDによりサービス情報を1件取得する
         * @summary サービス情報取得API
         * @param {number} id サービスID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceById(id: number, options?: any): AxiosPromise<GetServiceById200Response> {
            return localVarFp.getServiceById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * サービスコンポーネントの一覧を取得する
         * @summary Get service components
         * @param {string} lpPageUuid Landing page UUID
         * @param {number} [page] Page number
         * @param {number} [perPage] Items per page
         * @param {0 | 1} [status] サービスステータス (0: 非公開, 1: 公開)
         * @param {1 | 2 | 12} [type] サービスタイプ (1: 有料イベント, 2: カレンダーサービス, 12: フォームサービス)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceComponents(lpPageUuid: string, page?: number, perPage?: number, status?: 0 | 1, type?: 1 | 2 | 12, options?: any): AxiosPromise<GetServiceComponents200Response> {
            return localVarFp.getServiceComponents(lpPageUuid, page, perPage, status, type, options).then((request) => request(axios, basePath));
        },
        /**
         * 指定したIDのサービスコンポーネント一覧を取得する
         * @summary Get service components by IDs
         * @param {Array<number>} serviceIds サービスID配列
         * @param {string} lpPageUuid Landing page UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceComponentsByIds(serviceIds: Array<number>, lpPageUuid: string, options?: any): AxiosPromise<GetServiceComponentsByIds200Response> {
            return localVarFp.getServiceComponentsByIds(serviceIds, lpPageUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 予約日時選択画面<br/>サービスメニューIDによりサービスメニュー情報詳細を1件取得する
         * @summary サービスメニュー詳細情報取得API
         * @param {number} id サービスメニューID(service_menu.id)
         * @param {Array<number>} [menuOptions] 対象のサービスメニューオプションID&lt;br/&gt;(指定がない場合、全メニュー取得)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceMenuById(id: number, menuOptions?: Array<number>, options?: any): AxiosPromise<GetServiceMenuById200Response> {
            return localVarFp.getServiceMenuById(id, menuOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * サービスIDより特定商取引法取得を1件取得する
         * @summary 特定商取引法取得API
         * @param {number} id サービスID(service.id)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecialCommercialLawById(id: number, options?: any): AxiosPromise<GetSpecialCommercialLawById200Response> {
            return localVarFp.getSpecialCommercialLawById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * サービスIDにより、そのサービスの開催日一覧を一括で取得する
         * @summary サービス開催日一覧取得
         * @param {number} id サービスID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexServiceHoldDate(id: number, options?: any): AxiosPromise<IndexServiceHoldDate200Response> {
            return localVarFp.indexServiceHoldDate(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getCalendarServiceById operation in ServiceApi.
 * @export
 * @interface ServiceApiGetCalendarServiceByIdRequest
 */
export interface ServiceApiGetCalendarServiceByIdRequest {
    /**
     * サービスID
     * @type {number}
     * @memberof ServiceApiGetCalendarServiceById
     */
    readonly id: number
}

/**
 * Request parameters for getPrivacyPolicyByServiceId operation in ServiceApi.
 * @export
 * @interface ServiceApiGetPrivacyPolicyByServiceIdRequest
 */
export interface ServiceApiGetPrivacyPolicyByServiceIdRequest {
    /**
     * サービスID(service.id)
     * @type {number}
     * @memberof ServiceApiGetPrivacyPolicyByServiceId
     */
    readonly id: number
}

/**
 * Request parameters for getServiceById operation in ServiceApi.
 * @export
 * @interface ServiceApiGetServiceByIdRequest
 */
export interface ServiceApiGetServiceByIdRequest {
    /**
     * サービスID
     * @type {number}
     * @memberof ServiceApiGetServiceById
     */
    readonly id: number
}

/**
 * Request parameters for getServiceComponents operation in ServiceApi.
 * @export
 * @interface ServiceApiGetServiceComponentsRequest
 */
export interface ServiceApiGetServiceComponentsRequest {
    /**
     * Landing page UUID
     * @type {string}
     * @memberof ServiceApiGetServiceComponents
     */
    readonly lpPageUuid: string

    /**
     * Page number
     * @type {number}
     * @memberof ServiceApiGetServiceComponents
     */
    readonly page?: number

    /**
     * Items per page
     * @type {number}
     * @memberof ServiceApiGetServiceComponents
     */
    readonly perPage?: number

    /**
     * サービスステータス (0: 非公開, 1: 公開)
     * @type {0 | 1}
     * @memberof ServiceApiGetServiceComponents
     */
    readonly status?: 0 | 1

    /**
     * サービスタイプ (1: 有料イベント, 2: カレンダーサービス, 12: フォームサービス)
     * @type {1 | 2 | 12}
     * @memberof ServiceApiGetServiceComponents
     */
    readonly type?: 1 | 2 | 12
}

/**
 * Request parameters for getServiceComponentsByIds operation in ServiceApi.
 * @export
 * @interface ServiceApiGetServiceComponentsByIdsRequest
 */
export interface ServiceApiGetServiceComponentsByIdsRequest {
    /**
     * サービスID配列
     * @type {Array<number>}
     * @memberof ServiceApiGetServiceComponentsByIds
     */
    readonly serviceIds: Array<number>

    /**
     * Landing page UUID
     * @type {string}
     * @memberof ServiceApiGetServiceComponentsByIds
     */
    readonly lpPageUuid: string
}

/**
 * Request parameters for getServiceMenuById operation in ServiceApi.
 * @export
 * @interface ServiceApiGetServiceMenuByIdRequest
 */
export interface ServiceApiGetServiceMenuByIdRequest {
    /**
     * サービスメニューID(service_menu.id)
     * @type {number}
     * @memberof ServiceApiGetServiceMenuById
     */
    readonly id: number

    /**
     * 対象のサービスメニューオプションID&lt;br/&gt;(指定がない場合、全メニュー取得)
     * @type {Array<number>}
     * @memberof ServiceApiGetServiceMenuById
     */
    readonly menuOptions?: Array<number>
}

/**
 * Request parameters for getSpecialCommercialLawById operation in ServiceApi.
 * @export
 * @interface ServiceApiGetSpecialCommercialLawByIdRequest
 */
export interface ServiceApiGetSpecialCommercialLawByIdRequest {
    /**
     * サービスID(service.id)
     * @type {number}
     * @memberof ServiceApiGetSpecialCommercialLawById
     */
    readonly id: number
}

/**
 * Request parameters for indexServiceHoldDate operation in ServiceApi.
 * @export
 * @interface ServiceApiIndexServiceHoldDateRequest
 */
export interface ServiceApiIndexServiceHoldDateRequest {
    /**
     * サービスID
     * @type {number}
     * @memberof ServiceApiIndexServiceHoldDate
     */
    readonly id: number
}

/**
 * ServiceApi - object-oriented interface
 * @export
 * @class ServiceApi
 * @extends {BaseAPI}
 */
export class ServiceApi extends BaseAPI {
    /**
     * サービスメニュー選択画面<br/>サービスIDによりサービス(カレンダー)情報を1件取得する
     * @summary サービス(カレンダー)情報取得API
     * @param {ServiceApiGetCalendarServiceByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public getCalendarServiceById(requestParameters: ServiceApiGetCalendarServiceByIdRequest, options?: AxiosRequestConfig) {
        return ServiceApiFp(this.configuration).getCalendarServiceById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * サービスIDよりプライバシーポリシーを1件取得する
     * @summary プライバシーポリシー取得API
     * @param {ServiceApiGetPrivacyPolicyByServiceIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public getPrivacyPolicyByServiceId(requestParameters: ServiceApiGetPrivacyPolicyByServiceIdRequest, options?: AxiosRequestConfig) {
        return ServiceApiFp(this.configuration).getPrivacyPolicyByServiceId(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * サービスIDによりサービス情報を1件取得する
     * @summary サービス情報取得API
     * @param {ServiceApiGetServiceByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public getServiceById(requestParameters: ServiceApiGetServiceByIdRequest, options?: AxiosRequestConfig) {
        return ServiceApiFp(this.configuration).getServiceById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * サービスコンポーネントの一覧を取得する
     * @summary Get service components
     * @param {ServiceApiGetServiceComponentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public getServiceComponents(requestParameters: ServiceApiGetServiceComponentsRequest, options?: AxiosRequestConfig) {
        return ServiceApiFp(this.configuration).getServiceComponents(requestParameters.lpPageUuid, requestParameters.page, requestParameters.perPage, requestParameters.status, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定したIDのサービスコンポーネント一覧を取得する
     * @summary Get service components by IDs
     * @param {ServiceApiGetServiceComponentsByIdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public getServiceComponentsByIds(requestParameters: ServiceApiGetServiceComponentsByIdsRequest, options?: AxiosRequestConfig) {
        return ServiceApiFp(this.configuration).getServiceComponentsByIds(requestParameters.serviceIds, requestParameters.lpPageUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 予約日時選択画面<br/>サービスメニューIDによりサービスメニュー情報詳細を1件取得する
     * @summary サービスメニュー詳細情報取得API
     * @param {ServiceApiGetServiceMenuByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public getServiceMenuById(requestParameters: ServiceApiGetServiceMenuByIdRequest, options?: AxiosRequestConfig) {
        return ServiceApiFp(this.configuration).getServiceMenuById(requestParameters.id, requestParameters.menuOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * サービスIDより特定商取引法取得を1件取得する
     * @summary 特定商取引法取得API
     * @param {ServiceApiGetSpecialCommercialLawByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public getSpecialCommercialLawById(requestParameters: ServiceApiGetSpecialCommercialLawByIdRequest, options?: AxiosRequestConfig) {
        return ServiceApiFp(this.configuration).getSpecialCommercialLawById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * サービスIDにより、そのサービスの開催日一覧を一括で取得する
     * @summary サービス開催日一覧取得
     * @param {ServiceApiIndexServiceHoldDateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceApi
     */
    public indexServiceHoldDate(requestParameters: ServiceApiIndexServiceHoldDateRequest, options?: AxiosRequestConfig) {
        return ServiceApiFp(this.configuration).indexServiceHoldDate(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SubscriptionApi - axios parameter creator
 * @export
 */
export const SubscriptionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Stripe customer portal URL
         * @summary Stripe customer portal URL
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {'cancel'} [flow] Portal flow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionPortal: async (uuid: string, flow?: 'cancel', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getSubscriptionPortal', 'uuid', uuid)
            const localVarPath = `/subscription/{uuid}/portal`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (flow !== undefined) {
                localVarQueryParameter['flow'] = flow;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubscriptionApi - functional programming interface
 * @export
 */
export const SubscriptionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubscriptionApiAxiosParamCreator(configuration)
    return {
        /**
         * Stripe customer portal URL
         * @summary Stripe customer portal URL
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {'cancel'} [flow] Portal flow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptionPortal(uuid: string, flow?: 'cancel', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSubscriptionPortal200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptionPortal(uuid, flow, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SubscriptionApi - factory interface
 * @export
 */
export const SubscriptionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubscriptionApiFp(configuration)
    return {
        /**
         * Stripe customer portal URL
         * @summary Stripe customer portal URL
         * @param {string} uuid 注文ユニークID(orders.uuid)
         * @param {'cancel'} [flow] Portal flow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionPortal(uuid: string, flow?: 'cancel', options?: any): AxiosPromise<GetSubscriptionPortal200Response> {
            return localVarFp.getSubscriptionPortal(uuid, flow, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getSubscriptionPortal operation in SubscriptionApi.
 * @export
 * @interface SubscriptionApiGetSubscriptionPortalRequest
 */
export interface SubscriptionApiGetSubscriptionPortalRequest {
    /**
     * 注文ユニークID(orders.uuid)
     * @type {string}
     * @memberof SubscriptionApiGetSubscriptionPortal
     */
    readonly uuid: string

    /**
     * Portal flow
     * @type {'cancel'}
     * @memberof SubscriptionApiGetSubscriptionPortal
     */
    readonly flow?: 'cancel'
}

/**
 * SubscriptionApi - object-oriented interface
 * @export
 * @class SubscriptionApi
 * @extends {BaseAPI}
 */
export class SubscriptionApi extends BaseAPI {
    /**
     * Stripe customer portal URL
     * @summary Stripe customer portal URL
     * @param {SubscriptionApiGetSubscriptionPortalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    public getSubscriptionPortal(requestParameters: SubscriptionApiGetSubscriptionPortalRequest, options?: AxiosRequestConfig) {
        return SubscriptionApiFp(this.configuration).getSubscriptionPortal(requestParameters.uuid, requestParameters.flow, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserIndustryMasterApi - axios parameter creator
 * @export
 */
export const UserIndustryMasterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ユーザー業種マスタ一覧の取得API
         * @summary ユーザー業種マスタ一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserIndustries: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user-industry-master`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserIndustryMasterApi - functional programming interface
 * @export
 */
export const UserIndustryMasterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserIndustryMasterApiAxiosParamCreator(configuration)
    return {
        /**
         * ユーザー業種マスタ一覧の取得API
         * @summary ユーザー業種マスタ一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserIndustries(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserIndustryMaster>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserIndustries(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserIndustryMasterApi - factory interface
 * @export
 */
export const UserIndustryMasterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserIndustryMasterApiFp(configuration)
    return {
        /**
         * ユーザー業種マスタ一覧の取得API
         * @summary ユーザー業種マスタ一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserIndustries(options?: any): AxiosPromise<Array<UserIndustryMaster>> {
            return localVarFp.getUserIndustries(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserIndustryMasterApi - object-oriented interface
 * @export
 * @class UserIndustryMasterApi
 * @extends {BaseAPI}
 */
export class UserIndustryMasterApi extends BaseAPI {
    /**
     * ユーザー業種マスタ一覧の取得API
     * @summary ユーザー業種マスタ一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserIndustryMasterApi
     */
    public getUserIndustries(options?: AxiosRequestConfig) {
        return UserIndustryMasterApiFp(this.configuration).getUserIndustries(options).then((request) => request(this.axios, this.basePath));
    }
}


